var Data = [
    "1$115.875098818,40.4626462646",
    "4$116.039546917,40.1656165617",
    "48$116.203995017,39.6615661566",
    "127$116.286219067,39.7875787579",
    "43$116.403681996,39.6705670567",
    "2$116.579876389,40.6876687669",
    "1$116.603368974,39.7875787579",
    "2$116.697339317,40.2556255626",
    "5$116.70908561,40.3636363636",
    "20$116.932265174,40.0666066607",
    "5$115.863352525,40.0396039604",
    "16$115.898591403,40.3636363636",
    "14$115.922083989,39.6345634563",
    "284$115.980815453,39.7065706571",
    "1616$116.250980189,39.9765976598",
    "2223$116.556383803,39.904590459",
    "37$116.662100439,39.7695769577",
    "1$116.720831903,40.2916291629",
    "1$116.779563367,40.1296129613",
    "2$116.838294831,40.102610261",
    "2$116.885280003,40.1386138614",
    "11$116.990996639,40.3636363636",
    "10$115.757635889,39.5355535554",
    "2$115.875098818,39.8235823582",
    "2$116.086532089,40.0846084608",
    "24$116.168756139,40.201620162",
    "65$116.21574131,40.00360036",
    "428$116.262726482,39.9585958596",
    "31$116.697339317,40.1476147615",
    "60$116.838294831,40.2826282628",
    "4$115.851606232,39.6885688569",
    "1822$116.227487603,39.9315931593",
    "25$116.309711653,40.1296129613",
    "5$116.344950532,39.6525652565",
    "93$116.368443117,39.7065706571",
    "126$116.368443117,39.7335733573",
    "57$116.615115267,39.8415841584",
    "556$116.732578196,39.904590459",
    "78$116.121770967,40.1296129613",
    "35$116.145263553,40.2736273627",
    "2$116.180502432,40.3906390639",
    "500$116.262726482,40.0126012601",
    "5650$116.309711653,39.9135913591",
    "1$116.474159753,40.201620162",
    "5$116.87353371,40.399639964",
    "34$117.135082368,40.1386138614",
    "68$116.016054332,39.598559856",
    "1$116.262726482,40.4086408641",
    "4128$116.286219067,39.8325832583",
    "1$116.309711653,39.4815481548",
    "50$116.403681996,39.6615661566",
    "55$116.650354146,40.0306030603",
    "47$116.650354146,40.4086408641",
    "49$116.70908561,39.7245724572",
    "2$116.826548539,40.5436543654",
    "6$116.908772589,40.3906390639",
    "1$115.80462106,39.6075607561",
    "646$116.027800625,39.904590459",
    "257$116.074785796,39.7155715572",
    "214$116.321457946,39.6165616562",
    "2957$116.321457946,40.0486048605",
    "1870$116.38018941,40.0216021602",
    "12$116.603368974,40.0666066607",
    "1$116.62686156,39.7515751575",
    "47$116.62686156,40.1566156616",
    "2$116.908772589,40.1116111611",
    "1$117.123336075,40.1926192619",
    "2$117.381754518,40.2286228623",
    "91$115.80462106,39.7155715572",
    "1$115.863352525,40.102610261",
    "407$116.039546917,39.598559856",
    "5$116.063039503,40.1656165617",
    "59$116.180502432,40.0756075608",
    "2969$116.450667167,39.8415841584",
    "1420$116.497652339,39.7605760576",
    "59$116.497652339,40.201620162",
    "6974$116.521144924,39.9135913591",
    "131$117.099843489,40.1386138614",
    "3$116.004308039,40.3366336634",
    "49$116.110024675,39.7155715572",
    "80$116.497652339,39.697569757",
    "1$116.79130966,40.2646264626",
    "14$116.803055953,39.6525652565",
    "12$116.95575776,40.1746174617",
    "59$116.13351726,39.7155715572",
    "4$116.556383803,40.2286228623",
    "201$116.603368974,39.8145814581",
    "103$116.62686156,40.102610261",
    "10$117.111589782,40.597659766",
    "16$115.734143303,39.5895589559",
    "1$116.004308039,39.6345634563",
    "31$116.086532089,40.00360036",
    "2$116.145263553,39.6885688569",
    "47$116.192248725,39.8775877588",
    "3$116.250980189,39.6075607561",
    "180$116.274472775,40.2556255626",
    "13$116.568130096,40.201620162",
    "14$116.650354146,40.4356435644",
    "1$117.240799003,40.1926192619",
    "5$116.180502432,39.6795679568",
    "234$116.227487603,40.1206120612",
    "6$116.29796536,39.6525652565",
    "1845$116.356696825,39.8595859586",
    "657$116.485906046,40.0126012601",
    "1$116.579876389,40.2286228623",
    "10$116.79130966,40.1746174617",
    "3$116.850041124,40.1656165617",
    "9$116.990996639,40.0666066607",
    "47$117.123336075,40.1656165617",
    "75$116.121770967,40.2106210621",
    "94$116.46241346,40.0666066607",
    "32$116.685593024,40.3726372637",
    "1$116.732578196,39.6525652565",
    "22$116.767817074,39.796579658",
    "1$116.767817074,40.0396039604",
    "8$116.920518881,40.1476147615",
    "5$117.076350904,40.2196219622",
    "4$116.098278382,40.2556255626",
    "96$116.321457946,39.7065706571",
    "134$116.450667167,40.0666066607",
    "128$116.521144924,40.2196219622",
    "479$116.556383803,39.895589559",
    "36$116.62686156,39.6525652565",
    "27$116.673846732,39.8235823582",
    "3$116.908772589,40.1296129613",
    "1$117.182067539,40.5706570657",
    "41$115.757635889,39.5535553555",
    "44$115.96906916,39.5805580558",
    "43$116.21574131,39.7335733573",
    "23$116.767817074,40.1656165617",
    "2$116.908772589,40.2376237624",
    "9$117.017619439,40.0756075608",
    "16$117.170321246,40.1296129613",
    "666$116.309711653,39.7515751575",
    "1$116.756070781,40.2466246625",
    "4$116.79130966,40.102610261",
    "2$116.967504053,40.0486048605",
    "32$117.076350904,40.1836183618",
    "3470$116.344950532,39.8505850585",
    "1686$116.38018941,40.0306030603",
    "2866$116.438920874,40.0846084608",
    "1$116.54463751,40.300630063",
    "6$116.803055953,40.2376237624",
    "14$116.826548539,40.4626462646",
    "1$115.980815453,40.4086408641",
    "7$116.039546917,39.6435643564",
    "18$116.368443117,39.5715571557",
    "109$116.603368974,40.00360036",
    "11$116.650354146,40.0756075608",
    "4$116.720831903,39.6345634563",
    "44$116.732578196,39.6435643564",
    "1$116.897026296,40.4356435644",
    "4$117.041112025,40.2106210621",
    "1$116.004308039,40.5526552655",
    "117$116.074785796,40.0576057606",
    "481$116.192248725,39.7695769577",
    "1$116.321457946,40.4716471647",
    "134$116.46241346,40.0576057606",
    "1301$116.521144924,40.00360036",
    "20$116.767817074,40.1386138614",
    "44$117.076350904,40.0846084608",
    "1$117.146828661,40.2736273627",
    "4$115.875098818,40.3726372637",
    "7$116.110024675,40.5166516652",
    "47$116.168756139,40.0846084608",
    "1$116.168756139,40.6156615662",
    "457$116.274472775,40.1296129613",
    "190$116.29796536,39.7695769577",
    "139$116.438920874,39.7695769577",
    "126$116.438920874,40.1116111611",
    "5$116.568130096,39.6525652565",
    "363$116.568130096,40.0396039604",
    "5$116.779563367,40.1386138614",
    "126$116.838294831,40.1566156616",
    "1$117.158574954,40.4716471647",
    "2$116.074785796,40.4266426643",
    "5$116.086532089,39.6435643564",
    "1$116.368443117,40.1476147615",
    "1$116.450667167,40.3636363636",
    "26$116.615115267,40.2916291629",
    "14$116.79130966,39.7875787579",
    "1$117.217306418,40.2196219622",
    "6$115.945576575,40.3276327633",
    "5$116.180502432,40.1566156616",
    "1$116.427174582,40.2466246625",
    "1$116.615115267,40.9756975698",
    "56$116.662100439,39.8235823582",
    "25$116.767817074,39.8865886589",
    "3$117.205560125,40.6786678668",
    "5$115.96906916,40.399639964",
    "374$116.262726482,39.9855985599",
    "11423$116.427174582,39.8595859586",
    "3$116.591622682,40.6876687669",
    "129$116.121770967,40.0666066607",
    "580$116.168756139,40.0486048605",
    "303$116.356696825,39.7425742574",
    "1729$116.54463751,39.9495949595",
    "4$116.756070781,40.0486048605",
    "23$116.838294831,39.8145814581",
    "2$116.897026296,40.4176417642",
    "1$115.875098818,40.1476147615",
    "9$115.957322868,39.5895589559",
    "74$116.05129321,39.7155715572",
    "42$116.074785796,39.7425742574",
    "7$116.21574131,40.3276327633",
    "1439$116.262726482,40.1206120612",
    "127$116.427174582,40.1566156616",
    "3074$116.438920874,39.8775877588",
    "23$116.615115267,39.7155715572",
    "45$116.685593024,39.796579658",
    "1$117.064604611,40.1926192619",
    "17$117.135082368,40.3186318632",
    "7$115.816367353,40.4716471647",
    "6$116.063039503,39.9945994599",
    "70$116.145263553,39.6705670567",
    "1013$116.603368974,39.8865886589",
    "8$116.016054332,40.4446444644",
    "821$116.321457946,39.6795679568",
    "7236$116.333204239,39.9675967597",
    "182$116.62686156,40.1656165617",
    "71$116.720831903,40.0396039604",
    "12$116.767817074,39.6705670567",
    "15$116.87353371,40.2286228623",
    "15$115.945576575,39.9225922592",
    "31$116.086532089,39.9945994599",
    "18$116.157009846,39.8235823582",
    "1$116.227487603,39.7875787579",
    "1$116.46241346,39.5715571557",
    "25$116.732578196,39.7515751575",
    "2$116.897026296,39.7785778578",
    "12$117.252545296,40.6786678668",
    "591$117.276037882,40.6516651665",
    "1$115.745889596,39.8235823582",
    "1$116.039546917,40.2106210621",
    "17$116.063039503,39.697569757",
    "87$116.227487603,39.9675967597",
    "159$116.250980189,40.2736273627",
    "13$116.274472775,39.6435643564",
    "38$115.88684511,39.5625562556",
    "6$115.945576575,39.9765976598",
    "83$116.121770967,39.7065706571",
    "2$116.192248725,40.6426642664",
    "2710$116.274472775,39.9405940594",
    "4$116.568130096,40.3276327633",
    "8$116.897026296,39.7425742574",
    "6$117.064604611,40.498649865",
    "4$116.016054332,40.300630063",
    "102$116.168756139,40.1746174617",
    "39$116.21574131,40.1566156616",
    "281$116.250980189,40.1476147615",
    "1314$116.556383803,39.7605760576",
    "83$116.685593024,40.1926192619",
    "122$116.697339317,39.7245724572",
    "189$116.720831903,39.9225922592",
    "3$116.756070781,40.399639964",
    "6$116.967504053,40.1476147615",
    "6$115.616680375,39.7065706571",
    "6$116.063039503,39.7785778578",
    "1$116.074785796,40.1116111611",
    "5$116.086532089,39.5895589559",
    "27$116.732578196,40.2736273627",
    "10$116.838294831,40.0936093609",
    "2$116.157009846,40.5436543654",
    "739$116.227487603,39.9495949595",
    "162$116.286219067,40.2196219622",
    "2890$116.497652339,39.9855985599",
    "19$116.920518881,40.5616561656",
    "8$115.80462106,39.697569757",
    "14$116.157009846,39.6345634563",
    "7199$116.344950532,39.9135913591",
    "6$116.54463751,40.2376237624",
    "5$116.603368974,39.6525652565",
    "39$116.779563367,39.598559856",
    "30$116.850041124,39.7425742574",
    "32$115.898591403,39.5895589559",
    "41$116.180502432,40.00360036",
    "391$116.274472775,39.7785778578",
    "8769$116.309711653,39.9945994599",
    "110$116.415428289,39.6705670567",
    "62$116.450667167,40.0936093609",
    "11$116.46241346,40.3636363636",
    "877$116.497652339,39.796579658",
    "115$116.497652339,39.8865886589",
    "3$116.532891217,40.2556255626",
    "34$116.591622682,39.697569757",
    "3$116.62686156,39.6795679568",
    "161$116.62686156,40.1116111611",
    "1$115.745889596,39.5895589559",
    "1$115.781128475,39.5265526553",
    "12$115.839859939,39.7155715572",
    "19$116.450667167,40.2286228623",
    "29$116.826548539,39.8685868587",
    "5$116.967504053,40.1656165617",
    "4$117.170321246,40.5076507651",
    "1$115.88684511,39.8595859586",
    "2$116.039546917,40.5166516652",
    "1$116.333204239,40.4446444644",
    "829$116.438920874,40.0576057606",
    "3$116.497652339,40.3366336634",
    "95$116.568130096,39.9765976598",
    "1$116.662100439,39.6885688569",
    "80$116.756070781,40.0126012601",
    "46$116.074785796,39.6345634563",
    "28$116.145263553,40.0576057606",
    "66$116.192248725,40.1656165617",
    "37$116.638607853,40.0846084608",
    "48$116.650354146,40.0126012601",
    "5$116.826548539,40.1746174617",
    "1$116.885280003,40.6516651665",
    "5$115.88684511,40.3906390639",
    "160$116.016054332,39.7155715572",
    "3$116.039546917,40.5346534653",
    "1$116.121770967,40.1656165617",
    "3$116.438920874,40.4446444644",
    "1$116.450667167,40.5076507651",
    "9$116.509398632,40.1386138614",
    "15$116.685593024,40.1476147615",
    "29$116.850041124,39.8055805581",
    "45$116.932265174,40.399639964",
    "9$117.393500811,40.6426642664",
    "10$115.922083989,40.399639964",
    "28$116.004308039,40.3636363636",
    "1281$116.46241346,39.8055805581",
    "45$116.603368974,39.9855985599",
    "20$116.673846732,39.8055805581",
    "4$116.685593024,39.7245724572",
    "15$117.099843489,40.1206120612",
    "1$115.933830282,40.1476147615",
    "39$116.110024675,39.6615661566",
    "1590$116.485906046,39.8505850585",
    "265$116.532891217,40.102610261",
    "27$116.814802246,40.3366336634",
    "696$116.145263553,39.7515751575",
    "4$116.145263553,40.2106210621",
    "3506$116.309711653,39.8415841584",
    "2$116.356696825,39.4725472547",
    "4$116.485906046,40.2286228623",
    "16$116.556383803,39.6885688569",
    "5$116.861787417,40.1836183618",
    "22$117.205560125,40.201620162",
    "10$115.745889596,39.5445544554",
    "1$116.13351726,39.8775877588",
    "5804$116.321457946,39.9225922592",
    "56$116.368443117,40.3636363636",
    "23$116.391935703,39.6795679568",
    "32$116.62686156,40.2286228623",
    "20$116.650354146,39.9675967597",
    "14$116.87353371,40.1926192619",
    "2$117.287784175,40.201620162",
    "12$115.816367353,39.6615661566",
    "6$116.086532089,39.7425742574",
    "1212$116.13351726,39.7335733573",
    "186$116.309711653,39.7245724572",
    "2001$116.333204239,39.796579658",
    "175$116.368443117,39.7245724572",
    "2957$116.38018941,39.9225922592",
    "9222$116.415428289,39.9675967597",
    "246$116.556383803,40.0216021602",
    "8$116.756070781,39.7515751575",
    "20$116.920518881,40.4086408641",
    "1$116.944011467,40.1296129613",
    "4$115.769382182,40.0396039604",
    "3$116.168756139,39.9855985599",
    "2$116.262726482,39.7245724572",
    "20$116.368443117,39.5535553555",
    "1$116.403681996,40.4626462646",
    "98$116.615115267,40.0306030603",
    "7$116.662100439,40.6066606661",
    "11$116.767817074,40.2376237624",
    "2$116.826548539,40.5526552655",
    "4$115.933830282,40.1746174617",
    "1$115.933830282,40.3816381638",
    "8$116.21574131,39.6615661566",
    "8449$116.356696825,39.9315931593",
    "41$116.415428289,40.2106210621",
    "27$116.450667167,40.1656165617",
    "3014$116.568130096,39.9225922592",
    "5$116.897026296,40.0666066607",
    "6$116.990996639,40.1746174617",
    "44$117.158574954,40.1926192619",
    "22$117.170321246,40.1476147615",
    "1$115.769382182,40.0216021602",
    "8$115.945576575,40.4086408641",
    "30$115.96906916,39.7695769577",
    "2$116.250980189,40.3816381638",
    "2918$116.427174582,40.0306030603",
    "5154$116.474159753,39.9765976598",
    "10$116.603368974,40.1566156616",
    "22$116.767817074,39.6795679568",
    "2$116.850041124,40.1386138614",
    "5$117.017619439,40.2106210621",
    "2$117.205560125,40.2376237624",
    "153$116.05129321,39.8775877588",
    "17$116.098278382,39.7605760576",
    "3$116.250980189,40.6606660666",
    "46$116.356696825,40.3726372637",
    "7463$116.38018941,39.8505850585",
    "5$116.521144924,40.1746174617",
    "26$116.532891217,39.697569757",
    "167$116.568130096,39.8145814581",
    "17$116.638607853,39.8145814581",
    "2039$116.662100439,39.904590459",
    "1$116.744324489,39.7785778578",
    "18$116.767817074,39.7695769577",
    "47$115.992561746,40.498649865",
    "10$116.098278382,40.4806480648",
    "151$116.121770967,40.102610261",
    "107$116.286219067,40.2376237624",
    "673$116.391935703,39.8055805581",
    "254$116.403681996,39.7245724572",
    "491$116.556383803,39.7785778578",
    "72$116.87353371,40.3726372637",
    "15$116.920518881,39.796579658",
    "13$116.262726482,39.7155715572",
    "27$116.356696825,40.4896489649",
    "1508$116.415428289,40.102610261",
    "1891$116.532891217,39.9405940594",
    "41$116.803055953,39.8685868587",
    "6$116.814802246,40.5076507651",
    "1$116.932265174,40.0936093609",
    "2$116.95575776,40.2736273627",
    "4$115.534456325,39.7785778578",
    "1$115.910337696,40.3816381638",
    "27$116.121770967,39.9765976598",
    "14$116.168756139,39.6435643564",
    "24$116.168756139,39.9765976598",
    "50$116.227487603,40.102610261",
    "215$116.239233896,39.9675967597",
    "37$116.46241346,40.2106210621",
    "27$116.720831903,40.201620162",
    "1$116.779563367,40.1116111611",
    "26$117.017619439,40.0936093609",
    "1$115.945576575,40.5256525653",
    "1316$116.321457946,39.7515751575",
    "48$116.732578196,40.1386138614",
    "72$117.076350904,40.1566156616",
    "4$115.992561746,39.598559856",
    "1$116.027800625,40.0846084608",
    "253$116.110024675,39.895589559",
    "5388$116.333204239,39.9315931593",
    "5261$116.450667167,39.9135913591",
    "44$116.568130096,40.1746174617",
    "11$116.767817074,40.0126012601",
    "5$117.029365732,40.1116111611",
    "1$116.121770967,40.1566156616",
    "4671$116.286219067,39.9315931593",
    "85$116.309711653,40.1746174617",
    "5833$116.333204239,39.9405940594",
    "662$116.54463751,39.8775877588",
    "29$116.579876389,39.6615661566",
    "38$116.70908561,40.2736273627",
    "1$117.052858318,40.4806480648",
    "1$117.217306418,40.1116111611",
    "1$115.569695203,40.00360036",
    "61$115.992561746,40.4446444644",
    "5$116.039546917,40.2826282628",
    "178$116.086532089,39.9675967597",
    "754$116.121770967,39.7245724572",
    "10$116.157009846,40.2196219622",
    "161$116.579876389,39.7695769577",
    "17$116.62686156,40.0846084608",
    "5$116.720831903,39.7605760576",
    "19$116.803055953,40.3276327633",
    "20$116.039546917,39.7605760576",
    "7$116.145263553,40.5706570657",
    "6253$116.274472775,39.895589559",
    "259$116.309711653,40.4086408641",
    "4$116.333204239,39.4725472547",
    "7$116.450667167,39.6165616562",
    "2090$116.54463751,39.9585958596",
    "1341$116.579876389,39.9315931593",
    "55$116.62686156,39.8415841584",
    "77$116.70908561,40.0576057606",
    "1$117.076350904,40.6606660666",
    "7$117.252545296,40.1836183618",
    "1$115.980815453,40.3276327633",
    "20$116.05129321,39.6525652565",
    "83$116.239233896,40.2376237624",
    "1277$116.568130096,39.9585958596",
    "5$115.910337696,40.399639964",
    "55$116.098278382,40.2106210621",
    "2673$116.239233896,40.2196219622",
    "16$116.250980189,39.6525652565",
    "1904$116.309711653,39.8235823582",
    "11$116.474159753,39.6435643564",
    "566$116.521144924,39.7695769577",
    "23$116.638607853,40.2646264626",
    "13$116.779563367,40.2916291629",
    "1$116.814802246,39.8865886589",
    "10$115.875098818,39.5715571557",
    "855$116.192248725,40.0396039604",
    "6$116.203995017,39.6345634563",
    "1590$116.262726482,39.8505850585",
    "82$116.309711653,39.5085508551",
    "1$116.38018941,39.5355535554",
    "450$116.38018941,39.7695769577",
    "24$116.427174582,39.5535553555",
    "404$116.568130096,39.7875787579",
    "125$116.650354146,39.9855985599",
    "4$116.803055953,39.7155715572",
    "2$116.87353371,40.1116111611",
    "11$115.910337696,39.6615661566",
    "5$115.933830282,40.3546354635",
    "4$115.945576575,39.5805580558",
    "6$116.016054332,39.6525652565",
    "207$116.168756139,39.8865886589",
    "46$116.333204239,40.201620162",
    "4805$116.415428289,40.0846084608",
    "2141$116.579876389,39.9225922592",
    "7$116.861787417,40.4086408641",
    "3$117.264291589,40.201620162",
    "4$117.334769346,40.2286228623",
    "1$117.358261932,40.2106210621",
    "2$116.356696825,39.5265526553",
    "97$116.415428289,39.7425742574",
    "6$116.415428289,40.5256525653",
    "1$116.720831903,40.8406840684",
    "12$116.744324489,39.8235823582",
    "7$116.861787417,39.8415841584",
    "1$117.146828661,40.1926192619",
    "247$116.286219067,39.796579658",
    "2$116.603368974,40.1836183618",
    "4$116.767817074,40.0486048605",
    "8$116.79130966,39.7425742574",
    "130$116.944011467,40.1476147615",
    "1$117.135082368,40.3456345635",
    "6$116.027800625,40.5346534653",
    "54$116.203995017,39.6705670567",
    "3302$116.509398632,39.895589559",
    "1$116.70908561,40.4446444644",
    "5$116.767817074,39.7785778578",
    "1$115.828113646,40.4626462646",
    "66$116.086532089,39.9765976598",
    "123$116.110024675,40.1116111611",
    "373$116.192248725,39.8505850585",
    "10$116.309711653,40.4176417642",
    "8524$116.415428289,39.9855985599",
    "4$116.427174582,39.5805580558",
    "200$116.568130096,40.0756075608",
    "7$117.146828661,40.1836183618",
    "81$115.933830282,39.9315931593",
    "1$115.933830282,40.498649865",
    "3$116.016054332,40.498649865",
    "5$116.885280003,40.1746174617",
    "11$115.710650718,39.598559856",
    "17$115.957322868,40.4446444644",
    "197$116.039546917,39.9675967597",
    "10$116.13351726,39.598559856",
    "104$116.344950532,39.6795679568",
    "230$116.344950532,40.102610261",
    "64$116.474159753,39.7245724572",
    "6$117.240799003,40.2106210621",
    "4$115.957322868,39.6525652565",
    "3$116.039546917,39.9765976598",
    "57$116.145263553,40.0756075608",
    "42$116.157009846,40.1386138614",
    "1$116.21574131,40.5346534653",
    "9$116.509398632,40.2556255626",
    "385$116.591622682,39.8415841584",
    "8$117.005873146,40.1116111611",
    "13$117.264291589,40.2376237624",
    "35$115.839859939,39.5535553555",
    "3$115.945576575,40.3456345635",
    "8$116.098278382,40.0936093609",
    "2281$116.368443117,40.1116111611",
    "7$116.521144924,39.6075607561",
    "199$116.54463751,39.8235823582",
    "125$116.697339317,39.7695769577",
    "239$116.838294831,40.3636363636",
    "1$117.240799003,40.3546354635",
    "27$115.910337696,40.3906390639",
    "2$116.016054332,40.5076507651",
    "62$116.203995017,40.1746174617",
    "3$116.274472775,40.300630063",
    "74$116.321457946,39.5355535554",
    "15$116.62686156,40.2196219622",
    "9$116.814802246,39.6345634563",
    "22$116.814802246,39.8685868587",
    "2$116.967504053,40.2286228623",
    "21$117.358261932,40.1836183618",
    "4$115.922083989,40.4446444644",
    "17$115.945576575,39.6885688569",
    "52$116.05129321,39.6165616562",
    "39$116.192248725,40.1476147615",
    "164$116.203995017,40.0306030603",
    "13$116.274472775,40.4266426643",
    "2$116.438920874,40.2826282628",
    "10$116.697339317,40.201620162",
    "52$116.756070781,40.00360036",
    "1$116.814802246,40.0936093609",
    "98$116.838294831,40.4176417642",
    "10$116.967504053,40.0576057606",
    "3$115.922083989,40.2376237624",
    "663$116.274472775,39.8415841584",
    "4212$116.509398632,39.8685868587",
    "145$116.615115267,40.0216021602",
    "18$116.638607853,40.2286228623",
    "6$117.170321246,40.5886588659",
    "2$115.980815453,40.5076507651",
    "34$116.145263553,39.8775877588",
    "6$116.192248725,39.6165616562",
    "21$116.309711653,39.6435643564",
    "5$116.321457946,40.4086408641",
    "1$116.333204239,39.5445544554",
    "149$116.450667167,40.1296129613",
    "6$116.521144924,39.697569757",
    "1$116.650354146,39.697569757",
    "356$116.650354146,39.9495949595",
    "62$115.992561746,39.7245724572",
    "45$116.016054332,39.7245724572",
    "8$116.098278382,39.6255625563",
    "114$116.556383803,39.7155715572",
    "11$116.603368974,40.0576057606",
    "21$115.922083989,39.6705670567",
    "63$116.485906046,39.6165616562",
    "298$116.157009846,39.895589559",
    "4$116.203995017,39.6075607561",
    "686$116.309711653,39.7875787579",
    "1238$116.415428289,39.796579658",
    "106$116.662100439,40.3546354635",
    "13$116.697339317,40.3906390639",
    "20$116.779563367,39.7065706571",
    "1$115.651919253,39.9765976598",
    "409$116.145263553,40.1386138614",
    "4$116.157009846,39.5895589559",
    "509$116.403681996,40.1746174617",
    "5$116.46241346,40.4626462646",
    "1$116.615115267,40.4446444644",
    "18$116.944011467,40.4266426643",
    "1$115.875098818,39.6345634563",
    "707$116.46241346,39.796579658",
    "9$116.673846732,39.7245724572",
    "34$116.720831903,39.7245724572",
    "2$116.826548539,40.0936093609",
    "5$116.850041124,39.8505850585",
    "11$116.967504053,40.5616561656",
    "2$117.088097196,40.2466246625",
    "5$117.240799003,40.6786678668",
    "6$115.72239701,39.5625562556",
    "14$116.227487603,40.5706570657",
    "279$116.262726482,39.9405940594",
    "80$116.321457946,39.6525652565",
    "4895$116.403681996,39.9225922592",
    "1$116.403681996,40.7596759676",
    "21$116.756070781,40.3366336634",
    "247$116.004308039,40.3546354635",
    "332$116.13351726,39.9495949595",
    "859$116.157009846,39.7245724572",
    "632$116.250980189,40.0846084608",
    "11$116.29796536,39.6345634563",
    "7$116.427174582,39.6435643564",
    "7$116.438920874,39.6615661566",
    "4161$116.485906046,39.895589559",
    "4$116.944011467,40.399639964",
    "1$115.945576575,40.4716471647",
    "21$116.239233896,40.2466246625",
    "1$116.274472775,39.5715571557",
    "54$116.427174582,40.2376237624",
    "19$116.885280003,40.1566156616",
    "11$116.250980189,39.697569757",
    "1$116.29796536,40.6786678668",
    "233$116.38018941,39.7155715572",
    "66$116.38018941,40.1566156616",
    "6$116.497652339,40.2736273627",
    "2$116.673846732,40.1926192619",
    "16$115.769382182,39.6075607561",
    "27$115.80462106,39.5445544554",
    "99$116.074785796,40.2916291629",
    "4$116.650354146,40.3726372637",
    "18$116.920518881,40.0936093609",
    "249$115.980815453,39.6885688569",
    "18$116.016054332,40.4806480648",
    "5$116.262726482,40.4176417642",
    "15$116.321457946,40.2376237624",
    "4669$116.509398632,39.9225922592",
    "470$116.568130096,40.102610261",
    "3641$116.591622682,39.9225922592",
    "106$116.70908561,40.0396039604",
    "45$116.767817074,39.904590459",
    "5$116.826548539,40.2736273627",
    "6$117.017619439,40.4626462646",
    "228$116.180502432,39.8325832583",
    "6404$116.262726482,39.904590459",
    "244$116.368443117,39.8235823582",
    "1$116.438920874,39.5265526553",
    "829$116.509398632,39.8055805581",
    "7$115.698904425,39.7335733573",
    "18$116.05129321,39.895589559",
    "3388$116.344950532,40.0756075608",
    "72$116.509398632,40.1746174617",
    "22$116.556383803,40.2466246625",
    "2$116.779563367,40.1206120612",
    "3$116.990996639,40.0846084608",
    "1$117.029365732,40.4446444644",
    "9$117.076350904,40.5076507651",
    "92$115.96906916,40.4536453645",
    "129$116.427174582,40.0936093609",
    "2$116.638607853,39.6795679568",
    "8$116.662100439,40.6876687669",
    "26$116.756070781,39.8235823582",
    "14$116.979250346,40.1476147615",
    "5$117.017619439,40.102610261",
    "3$115.898591403,40.0486048605",
    "11$116.145263553,40.0396039604",
    "36$116.450667167,40.1476147615",
    "2$116.662100439,40.5076507651",
    "6$116.673846732,39.8505850585",
    "3$116.720831903,39.6525652565",
    "3$116.885280003,40.1656165617",
    "5$115.910337696,40.0306030603",
    "926$116.274472775,39.9945994599",
    "13$116.356696825,39.499549955",
    "343$116.391935703,39.8235823582",
    "1223$116.415428289,39.8325832583",
    "6739$116.438920874,39.904590459",
    "88$116.509398632,40.0846084608",
    "5$115.604934082,39.6885688569",
    "159$116.016054332,39.7065706571",
    "104$116.098278382,39.9675967597",
    "51$116.203995017,40.2466246625",
    "192$116.250980189,40.1836183618",
    "2184$116.274472775,40.1116111611",
    "2$116.286219067,39.6795679568",
    "1$116.29796536,39.5895589559",
    "7$116.333204239,40.2106210621",
    "7894$116.356696825,39.9495949595",
    "87$116.368443117,40.2466246625",
    "1$116.403681996,40.5256525653",
    "5$116.427174582,40.1836183618",
    "11$116.638607853,39.7695769577",
    "2$116.744324489,40.3726372637",
    "5$116.803055953,40.0756075608",
    "119$117.088097196,40.1476147615",
    "2$117.170321246,40.3456345635",
    "2$115.769382182,40.00360036",
    "1$115.910337696,39.9405940594",
    "1$116.016054332,40.4266426643",
    "2$116.074785796,40.4086408641",
    "80$116.180502432,39.7785778578",
    "1$116.250980189,39.5715571557",
    "45$116.286219067,40.3366336634",
    "4$116.391935703,39.6075607561",
    "2686$116.403681996,40.0666066607",
    "150$116.474159753,40.1746174617",
    "36$115.957322868,40.3726372637",
    "3$116.368443117,39.5445544554",
    "9$116.532891217,39.7155715572",
    "1$116.568130096,40.2466246625",
    "1$116.673846732,39.9585958596",
    "1$116.767817074,39.6165616562",
    "1017$116.415428289,40.1296129613",
    "1$116.838294831,39.8505850585",
    "39$116.838294831,40.3366336634",
    "39$117.146828661,40.3456345635",
    "112$116.027800625,39.8865886589",
    "37$116.450667167,39.6795679568",
    "44$116.685593024,40.2826282628",
    "9$116.016054332,40.1206120612",
    "19$116.016054332,40.3186318632",
    "14$116.145263553,39.8415841584",
    "156$116.192248725,39.7425742574",
    "4887$116.391935703,39.8775877588",
    "1$115.628426668,39.7425742574",
    "36$115.980815453,40.4356435644",
    "10$115.992561746,39.7695769577",
    "1098$116.21574131,40.0666066607",
    "26$116.274472775,39.6615661566",
    "5630$116.368443117,39.9225922592",
    "17$116.638607853,39.6435643564",
    "20$116.720831903,39.9765976598",
    "2$116.732578196,40.7866786679",
    "10$116.744324489,39.8415841584",
    "2$116.744324489,40.3096309631",
    "1$116.861787417,39.8505850585",
    "40$117.099843489,40.3096309631",
    "4$117.217306418,40.6696669667",
    "23$116.086532089,39.6525652565",
    "3$116.54463751,40.2556255626",
    "4$116.579876389,40.3366336634",
    "3$116.603368974,40.4086408641",
    "13$116.638607853,40.3546354635",
    "4$116.732578196,39.7425742574",
    "2$116.944011467,40.0756075608",
    "1$117.029365732,40.3186318632",
    "10$115.863352525,39.5715571557",
    "66$116.262726482,40.2466246625",
    "268$116.38018941,40.0396039604",
    "656$116.497652339,39.8145814581",
    "5$116.591622682,39.6255625563",
    "85$116.673846732,40.3726372637",
    "1$116.756070781,40.201620162",
    "24$116.803055953,39.697569757",
    "7$117.076350904,40.1296129613",
    "1$115.898591403,40.0396039604",
    "11$115.96906916,39.7335733573",
    "1$116.110024675,40.5526552655",
    "38$116.13351726,40.0486048605",
    "6$116.274472775,39.7065706571",
    "1$116.38018941,39.5085508551",
    "1$116.438920874,40.6696669667",
    "1$116.556383803,40.9306930693",
    "11$116.650354146,39.6615661566",
    "2$115.898591403,40.5166516652",
    "25$115.933830282,39.598559856",
    "3$116.098278382,40.5166516652",
    "161$116.286219067,39.9855985599",
    "3782$116.286219067,40.0216021602",
    "2$116.333204239,40.4176417642",
    "9$116.438920874,39.6525652565",
    "948$116.673846732,39.9315931593",
    "12$117.170321246,40.4356435644",
    "3$116.004308039,39.9675967597",
    "3$116.086532089,40.399639964",
    "247$116.168756139,39.7785778578",
    "2757$116.274472775,39.9495949595",
    "1432$116.438920874,39.8415841584",
    "59$116.650354146,40.3546354635",
    "3$116.29796536,40.6696669667",
    "487$116.568130096,39.9315931593",
    "1$115.88684511,40.4446444644",
    "7$115.992561746,40.5256525653",
    "1$116.121770967,39.8775877588",
    "22$116.168756139,39.6705670567",
    "304$116.250980189,40.0126012601",
    "317$116.286219067,40.0756075608",
    "21$116.70908561,39.7875787579",
    "10$116.732578196,39.9945994599",
    "638$116.203995017,39.9765976598",
    "549$116.21574131,40.1116111611",
    "1616$116.239233896,39.9315931593",
    "3$116.239233896,40.5886588659",
    "4137$116.29796536,40.1476147615",
    "898$116.485906046,39.8055805581",
    "31$116.54463751,39.6705670567",
    "12$115.957322868,40.4896489649",
    "327$116.556383803,39.7695769577",
    "5$116.685593024,40.2196219622",
    "1$116.826548539,40.0846084608",
    "2$116.838294831,40.1836183618",
    "100$116.54463751,39.7245724572",
    "5$116.568130096,40.2286228623",
    "18$116.732578196,40.1566156616",
    "5$116.756070781,40.3546354635",
    "1$115.522710032,39.9225922592",
    "8$116.673846732,40.300630063",
    "16$116.885280003,39.7875787579",
    "2$116.885280003,40.0486048605",
    "750$116.121770967,39.9585958596",
    "35$116.274472775,40.2646264626",
    "47$116.415428289,39.7065706571",
    "3$115.675411839,39.9675967597",
    "2$116.368443117,39.6795679568",
    "28$116.532891217,40.1386138614",
    "74$116.603368974,40.4446444644",
    "7$116.615115267,39.6165616562",
    "20$116.779563367,39.7515751575",
    "10$116.979250346,40.4446444644",
    "17$117.088097196,40.0936093609",
    "1$115.757635889,39.6525652565",
    "3$115.875098818,40.3636363636",
    "2$115.933830282,39.6165616562",
    "11$115.945576575,40.5166516652",
    "4180$116.450667167,39.9405940594",
    "23$116.579876389,39.6705670567",
    "1$116.640667699,41.0135013501",
    "66$116.603368974,40.0126012601",
    "7$116.826548539,40.4536453645",
    "12$116.850041124,39.8325832583",
    "6$116.87353371,40.3456345635",
    "417$115.957322868,39.7245724572",
    "1$116.05129321,40.3456345635",
    "477$116.274472775,39.8235823582",
    "8058$116.415428289,39.9495949595",
    "51$116.427174582,40.0846084608",
    "6$116.54463751,39.6345634563",
    "138$116.54463751,39.7875787579",
    "29$116.650354146,40.0666066607",
    "1$116.885280003,40.6336633663",
    "70$116.074785796,39.6255625563",
    "738$116.192248725,39.7605760576",
    "1$116.779563367,40.5796579658",
    "1$117.158574954,40.6786678668",
    "2$115.710650718,39.5895589559",
    "1$115.769382182,40.4446444644",
    "2$115.992561746,40.4356435644",
    "120$116.21574131,40.2916291629",
    "43$116.427174582,40.2106210621",
    "17$116.438920874,39.6795679568",
    "3$116.485906046,39.6525652565",
    "9$116.485906046,40.2466246625",
    "4$116.568130096,40.7056705671",
    "2$116.650354146,40.7146714671",
    "7$116.756070781,39.8055805581",
    "53$116.05129321,39.7245724572",
    "128$116.074785796,40.2196219622",
    "25$116.098278382,39.6525652565",
    "217$116.121770967,39.904590459",
    "215$116.203995017,40.2286228623",
    "16$116.474159753,40.0756075608",
    "145$116.697339317,40.1386138614",
    "76$116.732578196,39.7695769577",
    "25$116.79130966,39.7065706571",
    "2$117.088097196,40.3186318632",
    "393$116.157009846,39.7515751575",
    "298$116.192248725,39.8595859586",
    "36$116.450667167,39.697569757",
    "25$116.521144924,40.2376237624",
    "6$116.615115267,40.4086408641",
    "144$116.62686156,39.9585958596",
    "3$116.79130966,39.796579658",
    "2$115.88684511,39.8865886589",
    "1083$116.391935703,40.1116111611",
    "218$116.110024675,40.0486048605",
    "6$116.250980189,40.2556255626",
    "2$116.38018941,39.5175517552",
    "47$116.474159753,40.0576057606",
    "20$116.521144924,40.4626462646",
    "29$116.62686156,40.4266426643",
    "6$116.039546917,40.4446444644",
    "1659$116.239233896,39.9495949595",
    "1$116.262726482,39.6075607561",
    "1$116.321457946,40.5526552655",
    "1141$116.333204239,39.8325832583",
    "10179$116.344950532,39.9855985599",
    "305$116.556383803,39.7875787579",
    "15$116.932265174,40.201620162",
    "27$117.099843489,40.1296129613",
    "11$116.121770967,40.00360036",
    "12$116.203995017,40.3366336634",
    "137$116.29796536,39.5085508551",
    "304$116.556383803,39.8325832583",
    "76$116.803055953,40.0666066607",
    "273$116.110024675,39.9225922592",
    "1$116.391935703,39.5625562556",
    "1$116.427174582,40.1926192619",
    "111$116.532891217,39.7515751575",
    "60$116.532891217,39.7605760576",
    "3$116.532891217,40.1926192619",
    "10$116.591622682,40.3726372637",
    "61$116.697339317,39.7155715572",
    "60$116.79130966,40.2466246625",
    "3$116.826548539,40.4356435644",
    "2$115.769382182,39.598559856",
    "21$115.910337696,39.6255625563",
    "3$116.016054332,40.5256525653",
    "84$116.121770967,39.8685868587",
    "415$116.438920874,39.7605760576",
    "95$116.521144924,40.1296129613",
    "193$116.532891217,39.7425742574",
    "29$116.70908561,39.6885688569",
    "8$115.980815453,39.7515751575",
    "27$116.286219067,39.7335733573",
    "13049$116.356696825,39.9405940594",
    "1$116.415428289,39.4725472547",
    "434$116.697339317,39.904590459",
    "1$117.029365732,40.1566156616",
    "5$115.769382182,39.9945994599",
    "33$115.910337696,39.6165616562",
    "9$116.192248725,40.2646264626",
    "1225$116.262726482,40.0846084608",
    "7$116.403681996,40.4266426643",
    "234$116.673846732,40.1296129613",
    "76$117.088097196,40.1386138614",
    "5$115.96906916,39.9315931593",
    "4$116.415428289,39.4545454545",
    "223$116.438920874,39.796579658",
    "15$116.779563367,40.3636363636",
    "10$116.074785796,39.796579658",
    "67$116.321457946,39.8055805581",
    "10$116.368443117,39.6435643564",
    "13$116.79130966,39.7245724572",
    "3$117.041112025,40.1836183618",
    "1$117.064604611,40.6516651665",
    "1$115.839859939,39.8055805581",
    "202$116.121770967,40.2466246625",
    "8$116.46241346,39.6075607561",
    "3$116.603368974,40.6876687669",
    "30$116.720831903,40.1656165617",
    "4$116.814802246,40.2826282628",
    "93$116.885280003,40.3816381638",
    "10$116.074785796,39.7605760576",
    "4$116.192248725,40.3096309631",
    "909$116.274472775,40.1746174617",
    "1$116.46241346,39.6345634563",
    "23$116.638607853,40.3636363636",
    "36$116.05129321,39.6345634563",
    "153$116.110024675,39.7335733573",
    "765$116.450667167,39.8235823582",
    "11$116.521144924,39.6345634563",
    "475$116.556383803,39.7515751575",
    "78$116.615115267,39.8055805581",
    "120$116.685593024,40.1116111611",
    "2$116.685593024,40.2466246625",
    "1$115.581441496,40.0216021602",
    "7$115.898591403,40.4176417642",
    "6$115.945576575,39.7515751575",
    "1$116.227487603,40.6516651665",
    "29$116.239233896,39.6435643564",
    "1333$116.262726482,40.1386138614",
    "4$116.720831903,40.2376237624",
    "243$116.814802246,40.1566156616",
    "2$115.922083989,40.3816381638",
    "1$116.05129321,40.2736273627",
    "22$116.438920874,39.7065706571",
    "60$116.54463751,40.1386138614",
    "1$116.54463751,40.4536453645",
    "4$116.697339317,40.1926192619",
    "18$117.017619439,40.2376237624",
    "10$116.168756139,40.3186318632",
    "180$116.333204239,39.4905490549",
    "5075$116.38018941,40.00360036",
    "1$116.556383803,40.696669667",
    "2$116.673846732,40.5706570657",
    "3$116.685593024,39.6075607561",
    "28$116.803055953,39.7065706571",
    "1$117.076350904,40.3276327633",
    "9$117.182067539,40.6246624662",
    "6$116.697339317,40.0756075608",
    "2$116.016054332,40.4536453645",
    "3458$116.192248725,39.9135913591",
    "1461$116.485906046,39.9405940594",
    "145$116.497652339,40.1296129613",
    "364$116.521144924,39.8145814581",
    "77$116.603368974,40.102610261",
    "73$116.650354146,40.3366336634",
    "27$116.662100439,39.6795679568",
    "14$116.744324489,40.0666066607",
    "70$117.135082368,40.1566156616",
    "304$116.21574131,39.8865886589",
    "4754$116.333204239,39.9225922592",
    "261$116.356696825,39.7695769577",
    "40$116.368443117,40.1746174617",
    "543$116.568130096,39.796579658",
    "111$116.673846732,39.9855985599",
    "60$116.673846732,40.2916291629",
    "1$116.673846732,40.5886588659",
    "16$117.170321246,40.1206120612",
    "184$116.074785796,39.6705670567",
    "45$116.145263553,39.6795679568",
    "19$116.203995017,40.2916291629",
    "1773$116.368443117,40.0576057606",
    "1$116.403681996,39.5715571557",
    "8$116.509398632,40.0756075608",
    "2$116.556383803,39.6075607561",
    "9$116.814802246,40.1926192619",
    "14$117.170321246,40.4716471647",
    "17$116.016054332,39.904590459",
    "6$116.145263553,39.5805580558",
    "88$116.262726482,39.7875787579",
    "1260$116.368443117,39.796579658",
    "1$116.438920874,39.6255625563",
    "93$116.46241346,40.102610261",
    "173$116.70908561,39.8685868587",
    "5$116.70908561,40.3366336634",
    "13$115.734143303,39.5715571557",
    "7$116.110024675,39.598559856",
    "2203$116.168756139,39.9225922592",
    "1864$116.250980189,39.8595859586",
    "2$116.250980189,40.4176417642",
    "21$116.368443117,40.2106210621",
    "30$116.46241346,40.1926192619",
    "1$116.897026296,39.8505850585",
    "2$116.908772589,40.2736273627",
    "2$117.158574954,40.4086408641",
    "7$115.910337696,39.6345634563",
    "3$115.957322868,40.2736273627",
    "7$115.992561746,39.9855985599",
    "23$116.098278382,40.0756075608",
    "54$116.145263553,39.7875787579",
    "422$116.497652339,40.1656165617",
    "9$116.756070781,40.2826282628",
    "8$116.979250346,40.4536453645",
    "3$117.276037882,40.2106210621",
    "2$115.734143303,40.00360036",
    "7$115.875098818,39.5895589559",
    "9$115.96906916,39.6525652565",
    "88$116.157009846,39.8685868587",
    "3999$116.250980189,39.9135913591",
    "5$116.744324489,39.7245724572",
    "10$116.803055953,40.1926192619",
    "1$116.87353371,40.7686768677",
    "4$116.016054332,40.4626462646",
    "165$116.21574131,39.8685868587",
    "564$116.29796536,40.1116111611",
    "317$116.521144924,39.7605760576",
    "120$116.532891217,39.6795679568",
    "1$116.673846732,40.5436543654",
    "110$116.074785796,39.6615661566",
    "91$116.662100439,40.0666066607",
    "24$116.70908561,40.1656165617",
    "4$116.803055953,40.3726372637",
    "67$116.87353371,40.3906390639",
    "2$116.004308039,40.2106210621",
    "30$116.074785796,40.0756075608",
    "19$116.110024675,40.2106210621",
    "2355$116.250980189,39.9225922592",
    "5449$116.309711653,39.895589559",
    "840$116.532891217,40.0396039604",
    "175$116.568130096,40.0486048605",
    "32$116.767817074,39.8055805581",
    "20$116.803055953,39.7785778578",
    "9$115.734143303,39.5535553555",
    "15$115.898591403,39.8235823582",
    "176$116.262726482,40.201620162",
    "1$116.474159753,40.0666066607",
    "285$116.556383803,40.1206120612",
    "6$116.720831903,40.3186318632",
    "30$117.158574954,40.102610261",
    "188$116.063039503,39.6885688569",
    "3$116.427174582,39.5715571557",
    "1$116.54463751,40.3186318632",
    "337$116.697339317,39.9495949595",
    "3$116.826548539,40.2646264626",
    "24$116.861787417,40.4716471647",
    "4$115.839859939,39.6885688569",
    "107$116.13351726,39.8055805581",
    "13$116.756070781,40.0216021602",
    "4$116.779563367,40.4896489649",
    "23$116.838294831,40.1746174617",
    "10$116.027800625,39.9945994599",
    "2$116.13351726,39.6525652565",
    "297$116.145263553,39.9135913591",
    "11$116.391935703,40.4356435644",
    "1$116.403681996,39.4905490549",
    "1386$116.54463751,39.7605760576",
    "5$115.80462106,40.4626462646",
    "37$115.992561746,40.3456345635",
    "54$116.54463751,39.7785778578",
    "3$116.603368974,40.3636363636",
    "124$116.662100439,39.8325832583",
    "2$116.13351726,39.6075607561",
    "126$116.21574131,39.7065706571",
    "4$116.333204239,40.2556255626",
    "1$116.662100439,39.6255625563",
    "70$116.662100439,40.3276327633",
    "22$117.252545296,40.6246624662",
    "31$116.110024675,39.7065706571",
    "1$116.13351726,40.498649865",
    "110$116.450667167,40.1566156616",
    "14$116.086532089,40.201620162",
    "3$116.145263553,39.5895589559",
    "1773$116.274472775,40.00360036",
    "517$116.333204239,40.0936093609",
    "5$116.403681996,39.6435643564",
    "180$116.62686156,40.3276327633",
    "127$116.638607853,40.4356435644",
    "2$116.744324489,40.2466246625",
    "4$116.861787417,40.5076507651",
    "1$116.87353371,40.6246624662",
    "8$115.781128475,39.5715571557",
    "1$115.88684511,39.8775877588",
    "4$116.591622682,39.6345634563",
    "480$116.603368974,40.0486048605",
    "1$116.814802246,40.4896489649",
    "10$115.581441496,39.6345634563",
    "11$115.64017296,39.6435643564",
    "2$115.933830282,40.4176417642",
    "3$116.016054332,40.1836183618",
    "401$116.21574131,40.2106210621",
    "4036$116.29796536,39.9405940594",
    "5$116.638607853,40.7326732673",
    "14$116.95575776,40.0666066607",
    "1$117.170321246,40.696669667",
    "1$116.086532089,40.0126012601",
    "56$116.192248725,40.0126012601",
    "767$116.262726482,40.00360036",
    "104$116.344950532,40.1116111611",
    "8272$116.415428289,40.00360036",
    "330$116.485906046,40.0576057606",
    "1$116.556383803,40.2736273627",
    "4$116.638607853,40.2556255626",
    "15$116.756070781,40.1116111611",
    "5$116.861787417,40.1476147615",
    "2$116.95575776,40.3636363636",
    "8$116.121770967,40.5886588659",
    "1726$116.29796536,40.0756075608",
    "129$116.54463751,40.4176417642",
    "128$116.62686156,40.3366336634",
    "4$116.897026296,40.1386138614",
    "98$116.157009846,39.8505850585",
    "34$116.21574131,40.1386138614",
    "36$116.814802246,40.1206120612",
    "6$116.979250346,40.1926192619",
    "3$117.111589782,40.3276327633",
    "29$115.593187789,39.6705670567",
    "448$116.262726482,40.0756075608",
    "14$116.321457946,40.1566156616",
    "12$116.38018941,39.6345634563",
    "199$116.46241346,40.1296129613",
    "23$116.87353371,39.7245724572",
    "1$117.170321246,40.3546354635",
    "24$116.121770967,39.6525652565",
    "101$116.13351726,39.8865886589",
    "2$116.239233896,39.7785778578",
    "284$116.391935703,40.0666066607",
    "18$116.497652339,39.6255625563",
    "121$116.521144924,39.7425742574",
    "83$116.591622682,40.102610261",
    "28$116.638607853,40.1926192619",
    "150$116.814802246,39.8595859586",
    "17$116.95575776,40.5616561656",
    "5$116.086532089,40.498649865",
    "129$116.098278382,39.9945994599",
    "497$116.368443117,39.7695769577",
    "3595$116.368443117,40.0756075608",
    "1$116.509398632,40.3456345635",
    "15$116.556383803,39.697569757",
    "727$116.568130096,40.00360036",
    "17$116.685593024,40.2736273627",
    "668$116.29796536,40.00360036",
    "3845$116.321457946,40.0126012601",
    "1726$116.403681996,40.0306030603",
    "1$116.673846732,40.6606660666",
    "1$116.70908561,40.8586858686",
    "5$116.920518881,40.102610261",
    "23$115.945576575,39.7335733573",
    "11$116.039546917,40.0576057606",
    "219$116.239233896,40.1836183618",
    "4$116.29796536,39.5805580558",
    "26$116.333204239,39.6165616562",
    "144$116.415428289,39.7245724572",
    "16$116.54463751,40.1746174617",
    "79$116.673846732,40.0936093609",
    "38$116.826548539,39.7605760576",
    "59$116.13351726,39.9135913591",
    "3341$116.274472775,39.9225922592",
    "62$116.333204239,40.1386138614",
    "64$116.756070781,39.9405940594",
    "8$117.193813832,40.6336633663",
    "7620$116.356696825,39.9135913591",
    "213$116.415428289,40.1746174617",
    "1362$116.638607853,39.8865886589",
    "13$116.826548539,40.1926192619",
    "2$115.96906916,39.8055805581",
    "56$116.145263553,40.1476147615",
    "749$116.180502432,39.904590459",
    "213$116.29796536,39.7515751575",
    "1237$116.29796536,40.0576057606",
    "14$116.391935703,40.3636363636",
    "5$116.579876389,40.3096309631",
    "7$116.87353371,40.3546354635",
    "3$115.875098818,39.8055805581",
    "19$116.110024675,39.5895589559",
    "94$116.415428289,40.2196219622",
    "126$116.427174582,39.7695769577",
    "4$116.579876389,40.3906390639",
    "16$116.732578196,40.1746174617",
    "8$116.814802246,40.102610261",
    "1$116.990996639,40.3186318632",
    "199$116.180502432,39.8055805581",
    "33$116.485906046,39.7245724572",
    "2$115.816367353,39.5445544554",
    "273$116.321457946,39.5715571557",
    "421$116.333204239,40.102610261",
    "143$116.615115267,40.1386138614",
    "43$116.673846732,40.1656165617",
    "3$116.70908561,40.2466246625",
    "5$116.920518881,40.3906390639",
    "4547$116.168756139,39.7335733573",
    "48$116.403681996,39.6795679568",
    "7$116.720831903,40.0666066607",
    "10$116.344950532,40.4266426643",
    "13$115.593187789,39.6435643564",
    "1$116.79130966,39.697569757",
    "8$116.826548539,39.7785778578",
    "3$117.088097196,40.1206120612",
    "1$115.80462106,40.0486048605",
    "1$116.262726482,40.6786678668",
    "1248$116.46241346,39.8235823582",
    "679$116.497652339,39.8505850585",
    "104$116.509398632,40.2196219622",
    "329$116.556383803,39.7425742574",
    "52$116.650354146,39.9945994599",
    "15$116.662100439,40.4896489649",
    "2$116.885280003,39.6885688569",
    "11$117.123336075,40.102610261",
    "5913$116.250980189,39.904590459",
    "2$116.309711653,39.4905490549",
    "1023$116.521144924,39.8235823582",
    "216$116.720831903,40.0846084608",
    "13$116.732578196,40.1836183618",
    "3$116.039546917,40.4266426643",
    "3614$116.391935703,39.9945994599",
    "1$116.509398632,40.3906390639",
    "107$116.568130096,40.1296129613",
    "17$116.086532089,40.2376237624",
    "4427$116.356696825,39.8685868587",
    "980$116.579876389,40.00360036",
    "27$116.638607853,40.201620162",
    "7$116.650354146,40.1926192619",
    "59$116.673846732,40.0216021602",
    "16$116.098278382,40.1656165617",
    "2$116.098278382,40.5436543654",
    "2299$116.521144924,39.904590459",
    "17$116.803055953,39.7425742574",
    "15$117.041112025,40.0756075608",
    "5$116.145263553,39.9765976598",
    "105$116.168756139,39.8685868587",
    "11$116.192248725,40.1566156616",
    "82$116.603368974,40.1206120612",
    "9$116.720831903,40.2196219622",
    "23$117.135082368,40.3096309631",
    "3$115.839859939,39.6525652565",
    "503$116.21574131,39.9585958596",
    "34$116.227487603,40.0126012601",
    "90$116.521144924,40.0486048605",
    "19$116.615115267,40.0846084608",
    "100$116.638607853,40.0486048605",
    "36$116.70908561,40.1836183618",
    "11$115.957322868,39.6075607561",
    "710$116.227487603,40.0306030603",
    "544$116.262726482,40.102610261",
    "6$116.286219067,39.6435643564",
    "2$116.38018941,40.0486048605",
    "8079$116.438920874,39.9855985599",
    "1$116.79130966,40.4896489649",
    "8$116.885280003,39.796579658",
    "1$116.990996639,40.2826282628",
    "29$115.980815453,39.6255625563",
    "392$116.321457946,40.1296129613",
    "6942$116.450667167,39.8865886589",
    "2$116.509398632,40.201620162",
    "1$116.662100439,40.4626462646",
    "2$116.720831903,40.4176417642",
    "4$116.744324489,40.2196219622",
    "36$116.039546917,39.7695769577",
    "160$116.438920874,40.0936093609",
    "340$116.521144924,39.8055805581",
    "2$116.932265174,40.4626462646",
    "2$117.264291589,40.1386138614",
    "15$117.264291589,40.1656165617",
    "1$116.168756139,40.4806480648",
    "1125$116.333204239,39.8145814581",
    "267$116.438920874,40.1206120612",
    "714$116.497652339,40.0306030603",
    "4$115.781128475,40.4446444644",
    "4$116.027800625,40.1386138614",
    "188$116.063039503,39.6525652565",
    "1952$116.286219067,40.1116111611",
    "20$116.697339317,40.2826282628",
    "54$116.05129321,40.0216021602",
    "655$116.180502432,39.9585958596",
    "113$116.485906046,40.1116111611",
    "1$116.640667699,41.0225022502",
    "3$116.615115267,40.0126012601",
    "2$116.908772589,40.4446444644",
    "2$116.932265174,40.1386138614",
    "6$117.428739689,40.6516651665",
    "17$115.769382182,39.5445544554",
    "28$116.145263553,40.1206120612",
    "48$117.052858318,40.1476147615",
    "1$117.229052711,40.5796579658",
    "3$115.863352525,40.0576057606",
    "30$116.121770967,39.697569757",
    "240$116.227487603,39.9405940594",
    "527$116.250980189,40.0756075608",
    "2258$116.309711653,39.8325832583",
    "45$116.403681996,40.2376237624",
    "229$116.474159753,39.7695769577",
    "4$116.79130966,40.0486048605",
    "80$115.698904425,39.6345634563",
    "1170$116.227487603,40.2286228623",
    "129$116.286219067,40.4176417642",
    "6$116.368443117,39.6525652565",
    "11$116.509398632,40.3366336634",
    "2$116.532891217,40.2286228623",
    "32$116.756070781,40.2376237624",
    "50$117.158574954,40.1116111611",
    "23$116.603368974,39.7695769577",
    "6$116.662100439,40.3726372637",
    "6$116.979250346,40.399639964",
    "1$115.757635889,39.7425742574",
    "10$115.792874768,40.4446444644",
    "1$115.945576575,40.4176417642",
    "1852$116.344950532,39.7605760576",
    "543$116.403681996,40.1566156616",
    "1$116.450667167,39.6525652565",
    "66$116.485906046,40.1206120612",
    "29$116.509398632,40.1206120612",
    "68$116.591622682,39.6795679568",
    "23$116.638607853,40.2466246625",
    "8$116.063039503,40.2196219622",
    "261$116.474159753,40.1116111611",
    "515$116.54463751,39.8505850585",
    "25$116.591622682,39.7335733573",
    "87$116.62686156,39.7335733573",
    "63$116.697339317,40.0936093609",
    "1$116.720831903,39.7515751575",
    "10$116.979250346,40.0486048605",
    "1$116.990996639,40.1926192619",
    "17$116.086532089,39.7785778578",
    "19$116.110024675,40.1206120612",
    "8301$116.333204239,39.9765976598",
    "260$116.497652339,40.102610261",
    "151$116.579876389,39.9495949595",
    "33$116.650354146,40.3096309631",
    "20$116.662100439,40.2736273627",
    "26$115.698904425,39.5805580558",
    "1$115.839859939,40.0216021602",
    "139$115.898591403,40.3726372637",
    "12$116.157009846,40.1926192619",
    "39$116.180502432,39.7875787579",
    "1340$116.250980189,40.0396039604",
    "6$116.286219067,39.5805580558",
    "300$116.368443117,39.7425742574",
    "52$116.403681996,40.1386138614",
    "303$116.638607853,39.9765976598",
    "7$116.767817074,40.201620162",
    "1$116.826548539,40.2916291629",
    "71$115.992561746,39.796579658",
    "178$116.074785796,39.6435643564",
    "167$116.203995017,40.1476147615",
    "30$116.21574131,40.2736273627",
    "179$116.415428289,39.7155715572",
    "1$116.767817074,40.4176417642",
    "5$115.839859939,39.5895589559",
    "7$116.074785796,39.7875787579",
    "428$116.13351726,39.7425742574",
    "235$116.13351726,40.2466246625",
    "892$116.21574131,39.9315931593",
    "2$116.250980189,40.4266426643",
    "5091$116.309711653,40.0396039604",
    "6483$116.403681996,39.9405940594",
    "11$116.509398632,40.4176417642",
    "98$116.521144924,40.0756075608",
    "734$116.650354146,40.1206120612",
    "21$116.685593024,39.6435643564",
    "6$116.685593024,40.3096309631",
    "376$116.756070781,39.9315931593",
    "1$117.182067539,40.6336633663",
    "46$116.086532089,39.7695769577",
    "19$116.121770967,39.5805580558",
    "26$116.274472775,39.8055805581",
    "7$116.29796536,39.7335733573",
    "7$116.368443117,39.5805580558",
    "3$116.54463751,39.598559856",
    "737$116.54463751,39.7515751575",
    "190$116.603368974,39.9585958596",
    "8$116.87353371,40.1746174617",
    "14$115.945576575,39.5895589559",
    "12$116.168756139,40.0216021602",
    "3$116.497652339,39.5715571557",
    "30$116.568130096,40.3366336634",
    "55$116.145263553,40.1746174617",
    "226$116.192248725,40.0486048605",
    "8$116.239233896,40.3456345635",
    "5850$116.438920874,39.9135913591",
    "1$116.509398632,40.4086408641",
    "920$116.54463751,39.9675967597",
    "23$116.62686156,39.7875787579",
    "67$116.70908561,39.9855985599",
    "5$116.756070781,39.6255625563",
    "80$116.004308039,39.7065706571",
    "3$116.074785796,40.5346534653",
    "1$116.157009846,39.9945994599",
    "38$116.485906046,39.5625562556",
    "17$116.756070781,40.3906390639",
    "11$116.79130966,39.6615661566",
    "1$117.287784175,40.1386138614",
    "17$115.88684511,39.5805580558",
    "18$115.922083989,39.7155715572",
    "21$116.074785796,39.9945994599",
    "12$116.168756139,40.102610261",
    "189$116.168756139,40.1836183618",
    "5522$116.321457946,39.904590459",
    "66$116.497652339,39.7245724572",
    "203$116.615115267,40.0396039604",
    "48$116.650354146,39.8145814581",
    "1$116.650354146,40.4266426643",
    "10$116.685593024,40.2556255626",
    "53$116.732578196,39.9585958596",
    "3$116.814802246,40.1836183618",
    "3$116.944011467,40.1566156616",
    "11$116.086532089,39.8595859586",
    "188$116.262726482,40.0576057606",
    "6$116.344950532,39.4725472547",
    "44$116.391935703,40.2106210621",
    "3673$116.427174582,39.8055805581",
    "6$116.673846732,40.5346534653",
    "1$116.803055953,40.3096309631",
    "3$116.861787417,40.2556255626",
    "9$117.076350904,40.0936093609",
    "31$116.027800625,40.3456345635",
    "9$116.063039503,40.2826282628",
    "109$116.180502432,40.0666066607",
    "301$116.286219067,40.2106210621",
    "2411$116.344950532,40.0486048605",
    "34$116.885280003,39.7245724572",
    "3$116.95575776,40.1836183618",
    "3$116.990996639,40.4086408641",
    "11$117.135082368,40.2916291629",
    "239$115.980815453,40.4446444644",
    "179$116.157009846,39.7155715572",
    "152$116.21574131,39.7785778578",
    "5$116.391935703,40.3546354635",
    "5$117.029365732,40.1656165617",
    "7$117.252545296,40.201620162",
    "155$115.898591403,40.3546354635",
    "141$116.227487603,40.2916291629",
    "513$116.250980189,39.8505850585",
    "5122$116.356696825,40.0846084608",
    "5$116.509398632,39.7065706571",
    "3$116.54463751,39.9945994599",
    "3$116.732578196,40.2466246625",
    "43$116.87353371,39.8055805581",
    "1$116.203995017,40.2556255626",
    "4106$116.356696825,39.8415841584",
    "188$116.650354146,40.1116111611",
    "51$116.650354146,40.3816381638",
    "1195$116.685593024,39.895589559",
    "4$116.767817074,39.9855985599",
    "17$116.814802246,39.7065706571",
    "33$117.205560125,40.597659766",
    "2$115.72239701,40.0396039604",
    "3$115.957322868,40.3546354635",
    "141$116.250980189,40.1296129613",
    "6179$116.38018941,39.8595859586",
    "57$116.603368974,39.7515751575",
    "3$116.70908561,39.6075607561",
    "4$117.017619439,40.2196219622",
    "69$115.792874768,39.5445544554",
    "33$116.110024675,39.6795679568",
    "19$116.309711653,39.6075607561",
    "4964$116.309711653,40.0306030603",
    "13$116.427174582,40.201620162",
    "6$116.438920874,39.5355535554",
    "113$116.521144924,39.9855985599",
    "90$116.720831903,40.0936093609",
    "36$116.732578196,40.201620162",
    "4$117.240799003,40.1566156616",
    "1$115.851606232,39.5535553555",
    "855$116.309711653,39.8145814581",
    "5$116.356696825,39.6345634563",
    "83$116.509398632,39.7515751575",
    "2$116.579876389,40.1836183618",
    "805$116.662100439,39.8685868587",
    "20$116.803055953,40.1656165617",
    "2$117.370008225,40.6426642664",
    "398$116.180502432,39.8775877588",
    "34$116.274472775,39.697569757",
    "3$116.427174582,39.5895589559",
    "18$116.485906046,39.6885688569",
    "6$116.532891217,40.4176417642",
    "13$116.673846732,39.7425742574",
    "40$116.70908561,39.9675967597",
    "28$116.732578196,40.1206120612",
    "2$116.814802246,40.2466246625",
    "2$117.076350904,40.300630063",
    "44$116.05129321,39.904590459",
    "39$116.180502432,39.7065706571",
    "9$116.368443117,39.5625562556",
    "37$116.415428289,39.6165616562",
    "27$116.556383803,40.3726372637",
    "19$116.803055953,40.5616561656",
    "30$116.861787417,40.0666066607",
    "2$117.029365732,40.1746174617",
    "10$115.96906916,39.5895589559",
    "6$116.239233896,39.6795679568",
    "50$116.333204239,40.1656165617",
    "37$116.591622682,40.2106210621",
    "1$116.62686156,40.201620162",
    "31$116.638607853,39.7605760576",
    "27$116.004308039,40.4716471647",
    "157$116.250980189,40.102610261",
    "11$116.29796536,40.3546354635",
    "3$116.38018941,39.6255625563",
    "1150$116.591622682,40.0756075608",
    "1$116.62686156,41.00270027",
    "8$116.662100439,39.7425742574",
    "25$116.779563367,39.8775877588",
    "1$115.769382182,39.7065706571",
    "4$116.121770967,40.3456345635",
    "13$116.168756139,39.5895589559",
    "24$116.180502432,40.2106210621",
    "2524$116.29796536,39.8235823582",
    "18$116.391935703,39.6345634563",
    "650$116.450667167,40.0846084608",
    "2222$116.509398632,39.9405940594",
    "29$116.650354146,40.300630063",
    "5$115.734143303,39.6525652565",
    "16$116.063039503,39.8145814581",
    "2065$116.497652339,40.0126012601",
    "168$116.568130096,39.9675967597",
    "1$116.579876389,39.6435643564",
    "1$117.002742931,40.6606660666",
    "1$117.217306418,40.3456345635",
    "20$116.063039503,40.1836183618",
    "6$116.344950532,40.3276327633",
    "9486$116.450667167,39.8775877588",
    "36$116.638607853,40.1836183618",
    "1837$116.662100439,39.8775877588",
    "502$116.697339317,39.8775877588",
    "88$116.110024675,39.6885688569",
    "582$116.29796536,40.0666066607",
    "7$116.391935703,39.5445544554",
    "6$116.427174582,39.7515751575",
    "83$116.532891217,39.6705670567",
    "282$116.650354146,39.9405940594",
    "4$116.70908561,40.00360036",
    "1$116.779563367,40.4356435644",
    "15$116.814802246,40.3456345635",
    "17$115.88684511,39.6255625563",
    "20$116.309711653,40.1926192619",
    "6731$116.356696825,40.0306030603",
    "6$115.863352525,40.4626462646",
    "15$115.945576575,39.6345634563",
    "160$116.145263553,39.796579658",
    "1157$116.262726482,40.1566156616",
    "36$116.29796536,39.5175517552",
    "3$116.697339317,40.2196219622",
    "3$117.002742931,40.1926192619",
    "63$117.158574954,40.1656165617",
    "30$116.309711653,40.1836183618",
    "3111$116.438920874,39.9945994599",
    "68$116.438920874,40.2376237624",
    "36$116.697339317,39.9675967597",
    "21$116.697339317,39.9765976598",
    "8$115.792874768,40.4536453645",
    "134$116.203995017,39.796579658",
    "1$116.274472775,40.5796579658",
    "18$116.62686156,39.7155715572",
    "49$116.697339317,39.6075607561",
    "7$116.767817074,39.8685868587",
    "13$116.803055953,40.2106210621",
    "3$117.064604611,40.1206120612",
    "1$117.182067539,40.1386138614",
    "1$116.063039503,40.5526552655",
    "259$116.145263553,39.9315931593",
    "435$116.286219067,40.0666066607",
    "301$116.333204239,40.1116111611",
    "11$116.38018941,39.6615661566",
    "5137$116.46241346,39.9855985599",
    "4570$116.474159753,39.8595859586",
    "174$116.474159753,40.0846084608",
    "193$116.579876389,40.2916291629",
    "19$116.850041124,39.6795679568",
    "1$116.908772589,40.1836183618",
    "26$117.005873146,40.0486048605",
    "41$117.123336075,40.0846084608",
    "62$115.96906916,39.7065706571",
    "17$116.098278382,40.0576057606",
    "1$116.145263553,40.5796579658",
    "2$116.157009846,39.6885688569",
    "99$116.227487603,40.1386138614",
    "239$116.474159753,40.1206120612",
    "1$116.262726482,40.4446444644",
    "6349$116.391935703,39.8505850585",
    "6852$116.391935703,40.00360036",
    "119$116.438920874,39.7245724572",
    "2$116.438920874,40.6876687669",
    "288$116.474159753,39.7875787579",
    "22$117.099843489,40.2646264626",
    "1$115.698904425,39.9405940594",
    "11$115.851606232,39.8235823582",
    "1$115.945576575,40.1926192619",
    "3$116.074785796,39.8415841584",
    "56$116.21574131,40.3186318632",
    "1$116.239233896,40.4356435644",
    "3$116.638607853,40.1566156616",
    "109$116.826548539,40.3816381638",
    "11$116.850041124,40.102610261",
    "1$115.757635889,39.5895589559",
    "53$115.957322868,39.7605760576",
    "1$116.05129321,40.5616561656",
    "83$116.13351726,39.8145814581",
    "122$116.157009846,39.9405940594",
    "1$116.333204239,40.696669667",
    "5209$116.438920874,40.0666066607",
    "41$116.62686156,40.4356435644",
    "29$116.744324489,39.9495949595",
    "24$116.497652339,40.0846084608",
    "3$116.54463751,40.2286228623",
    "38$116.579876389,39.7065706571",
    "1$116.603368974,40.3456345635",
    "312$116.697339317,39.9315931593",
    "8$116.861787417,39.6705670567",
    "1$117.135082368,40.2556255626",
    "12$117.146828661,40.399639964",
    "15$115.957322868,40.5256525653",
    "11$116.121770967,39.7785778578",
    "4464$116.274472775,39.8865886589",
    "243$116.274472775,40.2106210621",
    "131$116.29796536,40.201620162",
    "4930$116.427174582,39.9135913591",
    "2$116.438920874,40.3816381638",
    "5$116.673846732,40.5256525653",
    "31$116.744324489,39.6345634563",
    "10$116.168756139,39.6345634563",
    "1656$116.29796536,40.0306030603",
    "3$116.403681996,39.598559856",
    "4$117.064604611,40.3906390639",
    "27$115.957322868,39.7515751575",
    "9364$116.333204239,39.9855985599",
    "98$116.344950532,39.6615661566",
    "2133$116.650354146,40.1296129613",
    "232$116.70908561,39.8865886589",
    "6$116.838294831,39.8415841584",
    "2$116.110024675,40.4806480648",
    "20$116.356696825,40.1296129613",
    "176$116.415428289,39.7785778578",
    "5$116.70908561,39.5895589559",
    "15$115.792874768,39.5265526553",
    "4$116.145263553,40.5256525653",
    "716$116.356696825,40.0936093609",
    "134$116.521144924,40.0396039604",
    "277$116.309711653,40.1476147615",
    "274$116.321457946,39.5805580558",
    "5359$116.403681996,39.9315931593",
    "321$116.568130096,39.8685868587",
    "1$116.685593024,40.4446444644",
    "3$116.767817074,40.3906390639",
    "4$116.803055953,39.6795679568",
    "1$115.64017296,39.7425742574",
    "61$116.004308039,39.697569757",
    "7$116.074785796,39.8325832583",
    "4$116.074785796,39.9495949595",
    "119$116.157009846,40.0576057606",
    "44$116.203995017,40.1566156616",
    "11$116.485906046,39.598559856",
    "2511$116.556383803,39.9225922592",
    "6$116.70908561,39.7515751575",
    "5$116.732578196,40.300630063",
    "22$116.897026296,39.796579658",
    "15$117.146828661,40.3816381638",
    "3$117.229052711,40.1566156616",
    "2$115.875098818,40.3906390639",
    "3$116.168756139,40.00360036",
    "13$116.368443117,40.201620162",
    "17$116.509398632,40.4536453645",
    "848$116.662100439,39.9405940594",
    "1$116.850041124,40.1206120612",
    "18$116.932265174,40.4266426643",
    "3$115.698904425,39.9675967597",
    "2$115.875098818,39.6885688569",
    "19$116.027800625,39.6165616562",
    "7$116.180502432,40.2556255626",
    "104$116.450667167,40.0396039604",
    "1722$116.673846732,39.895589559",
    "10$116.70908561,39.6615661566",
    "3$116.767817074,40.3186318632",
    "17$116.039546917,40.3186318632",
    "83$116.157009846,39.9675967597",
    "6725$116.344950532,39.8865886589",
    "1$116.356696825,40.4086408641",
    "173$116.521144924,40.1206120612",
    "12$116.673846732,40.3456345635",
    "12$116.673846732,40.3816381638",
    "30$116.885280003,39.8055805581",
    "4$117.135082368,40.2736273627",
    "41$116.110024675,39.8505850585",
    "9$116.192248725,40.300630063",
    "1308$116.239233896,39.9225922592",
    "148$116.638607853,40.2196219622",
    "3$117.088097196,40.102610261",
    "2$117.252545296,40.1566156616",
    "60$116.121770967,39.8145814581",
    "514$116.121770967,39.9315931593",
    "562$116.427174582,39.8235823582",
    "9$116.485906046,40.201620162",
    "1058$116.509398632,39.796579658",
    "17$116.70908561,40.0846084608",
    "13$116.779563367,39.9225922592",
    "3$116.850041124,39.7155715572",
    "12$117.076350904,40.1116111611",
    "35$116.110024675,39.7785778578",
    "463$116.250980189,40.201620162",
    "893$116.321457946,39.8595859586",
    "10570$116.356696825,40.00360036",
    "2$116.368443117,39.598559856",
    "25$116.62686156,40.2646264626",
    "4$115.957322868,40.4806480648",
    "787$116.098278382,39.9315931593",
    "1380$116.532891217,39.8505850585",
    "1$116.568130096,39.6435643564",
    "1$116.650354146,40.2826282628",
    "22$116.720831903,40.1926192619",
    "2$115.828113646,39.8235823582",
    "1$116.016054332,40.1656165617",
    "106$116.110024675,40.0666066607",
    "3005$116.192248725,39.9315931593",
    "52$116.38018941,40.2196219622",
    "343$116.650354146,39.8685868587",
    "10$116.779563367,39.8415841584",
    "4$116.87353371,39.796579658",
    "16$115.957322868,39.796579658",
    "20$116.016054332,39.6615661566",
    "4678$116.356696825,39.8775877588",
    "6915$116.368443117,39.9405940594",
    "28$116.391935703,39.5535553555",
    "9$117.005873146,40.2466246625",
    "2$115.957322868,40.0936093609",
    "1$115.992561746,39.8235823582",
    "135$115.992561746,40.3546354635",
    "14$116.086532089,39.7875787579",
    "63$116.121770967,39.796579658",
    "568$116.180502432,39.895589559",
    "4871$116.29796536,39.9675967597",
    "5$116.697339317,39.6435643564",
    "4$116.744324489,40.1746174617",
    "11$116.744324489,40.3906390639",
    "3$116.826548539,40.1386138614",
    "218$116.098278382,40.102610261",
    "515$116.110024675,39.904590459",
    "92$116.13351726,40.1476147615",
    "424$116.250980189,39.9855985599",
    "1$116.356696825,40.7236723672",
    "1$116.756070781,40.2646264626",
    "1$115.72239701,39.6435643564",
    "228$116.333204239,39.598559856",
    "96$116.638607853,39.9405940594",
    "7$116.756070781,40.0576057606",
    "7$116.908772589,40.2106210621",
    "7$115.863352525,39.5895589559",
    "55$116.29796536,40.1656165617",
    "48$116.391935703,40.1476147615",
    "5987$116.415428289,40.0486048605",
    "33$116.46241346,40.2376237624",
    "6$116.720831903,40.1836183618",
    "2$115.757635889,39.8235823582",
    "2$116.004308039,39.8685868587",
    "79$116.673846732,40.4086408641",
    "49$116.720831903,40.102610261",
    "3$116.826548539,39.6885688569",
    "10$116.861787417,39.8145814581",
    "8$116.145263553,40.3456345635",
    "6$116.157009846,40.3186318632",
    "211$116.203995017,40.1386138614",
    "11128$116.438920874,39.9225922592",
    "3$116.650354146,39.7065706571",
    "1$116.720831903,40.4086408641",
    "12$116.920518881,40.0756075608",
    "1$117.252545296,40.1386138614",
    "65$116.05129321,39.8865886589",
    "1$116.110024675,39.9765976598",
    "25$116.70908561,39.796579658",
    "6$116.979250346,40.0666066607",
    "5$117.099843489,40.1746174617",
    "11$115.910337696,39.5895589559",
    "252$116.168756139,40.2376237624",
    "11$116.474159753,39.6615661566",
    "49$116.70908561,39.7155715572",
    "12$116.720831903,39.7425742574",
    "1$116.027800625,39.9495949595",
    "147$116.039546917,39.9585958596",
    "39$116.344950532,39.6255625563",
    "151$116.415428289,40.1656165617",
    "21$116.450667167,40.1746174617",
    "42$116.521144924,40.1566156616",
    "6$116.720831903,40.3096309631",
    "2$116.908772589,40.4896489649",
    "4$116.932265174,40.4086408641",
    "1$115.757635889,39.9945994599",
    "1$115.816367353,40.0396039604",
    "63$116.074785796,39.697569757",
    "109$116.098278382,40.1296129613",
    "84$116.110024675,39.697569757",
    "27$116.110024675,40.2646264626",
    "54$116.286219067,39.7245724572",
    "5536$116.286219067,39.8505850585",
    "1111$116.29796536,39.8505850585",
    "1$116.356696825,40.5526552655",
    "15$116.662100439,39.8145814581",
    "17$116.662100439,39.9765976598",
    "11$117.017619439,40.1926192619",
    "71$116.05129321,39.9585958596",
    "131$116.121770967,39.7425742574",
    "1$116.192248725,40.5256525653",
    "1$116.274472775,40.3186318632",
    "371$116.438920874,39.8235823582",
    "22$116.603368974,39.7425742574",
    "30$116.662100439,40.00360036",
    "42$116.70908561,40.0756075608",
    "1$116.720831903,40.300630063",
    "320$116.732578196,39.9405940594",
    "17$116.732578196,40.3366336634",
    "7$116.744324489,39.7695769577",
    "1$116.767817074,40.3816381638",
    "1$115.72239701,39.7245724572",
    "1$115.851606232,40.4446444644",
    "37$116.063039503,39.6345634563",
    "15$116.168756139,40.0936093609",
    "285$116.203995017,39.7515751575",
    "4593$116.262726482,39.895589559",
    "3379$116.333204239,39.9135913591",
    "5417$116.333204239,39.9495949595",
    "697$116.497652339,39.8325832583",
    "183$116.615115267,39.8595859586",
    "20$115.745889596,39.5625562556",
    "2$115.922083989,40.1116111611",
    "336$116.192248725,39.7335733573",
    "2162$116.203995017,39.904590459",
    "9380$116.368443117,39.9765976598",
    "4$116.756070781,39.9225922592",
    "8$117.193813832,40.1476147615",
    "10$115.96906916,40.5166516652",
    "9232$116.286219067,39.9585958596",
    "84$116.356696825,39.6795679568",
    "12$116.368443117,40.3816381638",
    "6831$116.38018941,39.8775877588",
    "957$116.509398632,39.8145814581",
    "1$116.62686156,40.9756975698",
    "2$116.662100439,40.6246624662",
    "7$116.732578196,39.8055805581",
    "8$116.779563367,40.0756075608",
    "2$116.861787417,40.102610261",
    "7$116.932265174,40.1746174617",
    "16$117.252545296,40.1746174617",
    "4502$116.368443117,40.0126012601",
    "121$116.450667167,40.1386138614",
    "5$116.62686156,39.7785778578",
    "161$116.227487603,40.1836183618",
    "1522$116.29796536,39.8145814581",
    "5027$116.344950532,40.0846084608",
    "4$116.474159753,40.2466246625",
    "4587$116.54463751,39.9135913591",
    "2$116.650354146,39.6795679568",
    "3$116.70908561,40.1116111611",
    "2$115.781128475,39.7155715572",
    "12$115.863352525,39.5805580558",
    "31$116.016054332,39.6705670567",
    "12$116.70908561,40.0486048605",
    "34$116.720831903,40.1746174617",
    "1$116.79130966,39.6075607561",
    "1$115.557948911,39.7785778578",
    "10$116.227487603,40.4356435644",
    "2987$116.321457946,40.0576057606",
    "11687$116.344950532,40.00360036",
    "8044$116.38018941,39.9765976598",
    "1$116.744324489,40.1116111611",
    "59$116.767817074,39.9135913591",
    "26$116.803055953,40.300630063",
    "13$116.908772589,40.0576057606",
    "228$116.286219067,40.1386138614",
    "8472$116.333204239,40.0756075608",
    "2$116.662100439,40.300630063",
    "50$116.767817074,40.00360036",
    "124$116.074785796,39.7245724572",
    "29$116.13351726,39.7785778578",
    "69$116.192248725,40.2106210621",
    "1788$116.262726482,40.0396039604",
    "1$115.88684511,39.9495949595",
    "28$116.121770967,40.1746174617",
    "126$116.227487603,39.8325832583",
    "4$116.250980189,39.5175517552",
    "170$116.438920874,40.1296129613",
    "6$116.579876389,40.2106210621",
    "22$116.756070781,39.8775877588",
    "3$117.111589782,40.5616561656",
    "12$117.276037882,40.1746174617",
    "1$115.80462106,40.0126012601",
    "6$115.910337696,39.6705670567",
    "2$116.54463751,40.1836183618",
    "8$116.568130096,40.3906390639",
    "1$116.756070781,39.7605760576",
    "11$116.897026296,39.7695769577",
    "13$116.920518881,40.1656165617",
    "53$117.005873146,40.1836183618",
    "1$117.193813832,40.1836183618",
    "5$117.370008225,40.201620162",
    "10$116.098278382,40.5076507651",
    "95$116.121770967,39.7155715572",
    "122$116.13351726,40.1386138614",
    "11$116.603368974,39.8235823582",
    "85$116.662100439,39.9585958596",
    "21$116.70908561,40.1566156616",
    "13$116.803055953,40.1746174617",
    "1$117.217306418,40.3636363636",
    "2$115.96906916,39.796579658",
    "5$116.250980189,39.796579658",
    "2050$116.286219067,39.9675967597",
    "144$116.415428289,39.7695769577",
    "141$116.579876389,39.8235823582",
    "1$116.615115267,40.2466246625",
    "4$116.756070781,40.2286228623",
    "12$117.017619439,40.1116111611",
    "1$117.170321246,40.3186318632",
    "81$116.145263553,39.8505850585",
    "652$116.250980189,40.2106210621",
    "91$116.62686156,39.796579658",
    "4$116.662100439,40.2646264626",
    "61$116.697339317,39.8055805581",
    "1$116.87353371,39.7515751575",
    "15$116.086532089,40.2736273627",
    "68$116.098278382,40.0666066607",
    "4$116.333204239,40.1566156616",
    "205$116.356696825,39.7335733573",
    "242$116.54463751,40.0126012601",
    "2$116.861787417,39.697569757",
    "440$116.38018941,39.8145814581",
    "1$116.438920874,40.3456345635",
    "156$116.450667167,39.7425742574",
    "64$116.450667167,40.201620162",
    "654$116.521144924,39.8415841584",
    "26$116.662100439,39.6615661566",
    "1$116.180502432,40.5166516652",
    "81$116.485906046,40.1836183618",
    "12$116.79130966,39.8865886589",
    "1$116.920518881,40.2646264626",
    "101$116.05129321,39.5895589559",
    "874$116.21574131,39.8415841584",
    "32$116.239233896,40.1296129613",
    "1$116.54463751,39.6615661566",
    "127$116.54463751,39.796579658",
    "132$116.603368974,39.7605760576",
    "71$116.62686156,39.8505850585",
    "1$117.002742931,40.399639964",
    "1$117.264291589,40.6786678668",
    "126$115.72239701,39.6075607561",
    "4$115.757635889,39.9855985599",
    "3$116.098278382,40.4716471647",
    "2$116.110024675,40.3546354635",
    "10$116.203995017,39.7785778578",
    "28$116.356696825,39.5895589559",
    "1637$116.415428289,40.0126012601",
    "24$116.46241346,40.1656165617",
    "13$116.650354146,39.6705670567",
    "71$116.650354146,40.0216021602",
    "20$116.814802246,40.2376237624",
    "48$117.111589782,40.102610261",
    "2$117.158574954,40.6606660666",
    "16$116.074785796,39.5805580558",
    "13$116.344950532,40.3636363636",
    "190$116.579876389,40.1296129613",
    "168$116.650354146,40.2106210621",
    "383$116.180502432,39.9405940594",
    "2873$116.29796536,39.895589559",
    "6968$116.309711653,39.9225922592",
    "2990$116.403681996,39.8775877588",
    "47$116.697339317,40.1116111611",
    "1$116.720831903,39.6885688569",
    "6$116.990996639,40.1116111611",
    "10$116.286219067,39.5265526553",
    "202$116.29796536,39.697569757",
    "2433$116.391935703,40.0216021602",
    "3519$116.403681996,39.9135913591",
    "2897$116.474159753,40.0126012601",
    "333$116.591622682,39.9495949595",
    "75$116.662100439,39.6525652565",
    "1$116.767817074,40.6156615662",
    "3$116.861787417,39.7335733573",
    "18$116.897026296,40.3726372637",
    "306$116.603368974,40.0396039604",
    "19$116.744324489,39.9675967597",
    "9$116.744324489,39.9765976598",
    "20$115.863352525,39.6435643564",
    "7$115.863352525,40.4086408641",
    "55$115.910337696,40.3726372637",
    "14$115.933830282,40.5166516652",
    "28$116.039546917,39.5895589559",
    "2$116.427174582,39.5445544554",
    "62$116.438920874,40.1746174617",
    "7007$116.474159753,39.8685868587",
    "2354$116.474159753,39.9405940594",
    "67$116.521144924,39.6795679568",
    "24$116.532891217,40.2196219622",
    "25$116.673846732,39.7605760576",
    "4$116.920518881,40.1296129613",
    "8$117.135082368,40.1116111611",
    "11$115.863352525,40.4806480648",
    "1$115.933830282,40.3726372637",
    "28$115.992561746,39.9675967597",
    "39$116.239233896,40.102610261",
    "11107$116.368443117,39.8865886589",
    "11$116.732578196,39.796579658",
    "89$116.027800625,40.4176417642",
    "59$116.086532089,39.6885688569",
    "422$116.157009846,39.8145814581",
    "3$116.250980189,39.6165616562",
    "2$116.485906046,40.300630063",
    "234$116.62686156,40.3096309631",
    "1354$116.685593024,39.9315931593",
    "44$116.685593024,40.1836183618",
    "28$116.779563367,40.0666066607",
    "2$116.87353371,39.8325832583",
    "6$116.87353371,40.2106210621",
    "4$117.052858318,40.1386138614",
    "1$116.063039503,40.0126012601",
    "8624$116.344950532,39.9405940594",
    "25$116.650354146,39.7425742574",
    "182$116.697339317,39.9405940594",
    "11$115.88684511,40.3546354635",
    "92$116.168756139,40.0396039604",
    "84$116.21574131,40.2466246625",
    "16$116.227487603,40.2466246625",
    "161$116.239233896,40.0576057606",
    "2$116.344950532,40.696669667",
    "6531$116.427174582,39.9225922592",
    "1$116.497652339,39.6615661566",
    "472$116.556383803,40.0936093609",
    "1$116.004308039,39.904590459",
    "10$116.145263553,40.0486048605",
    "66$116.180502432,40.2466246625",
    "231$116.262726482,40.1746174617",
    "7$116.403681996,39.5355535554",
    "7627$116.46241346,39.9945994599",
    "262$116.579876389,39.8865886589",
    "4$115.96906916,40.102610261",
    "5765$116.368443117,40.00360036",
    "2817$116.38018941,39.9405940594",
    "235$116.403681996,39.7425742574",
    "6107$116.415428289,40.0396039604",
    "3120$116.497652339,39.8775877588",
    "332$116.638607853,40.3366336634",
    "9$116.039546917,40.0396039604",
    "36$116.074785796,39.6075607561",
    "652$116.180502432,39.9945994599",
    "9644$116.427174582,39.9945994599",
    "154$116.591622682,40.0936093609",
    "16$116.732578196,39.8235823582",
    "3$116.838294831,39.7065706571",
    "3$116.932265174,40.102610261",
    "34$115.534456325,40.0756075608",
    "2$116.086532089,40.2196219622",
    "237$116.168756139,39.7425742574",
    "1392$116.250980189,40.0666066607",
    "1$116.286219067,40.5796579658",
    "90$116.756070781,39.895589559",
    "27$117.299530468,40.1836183618",
    "3$116.333204239,39.4635463546",
    "7965$116.391935703,39.9495949595",
    "1115$116.46241346,40.0306030603",
    "58$116.767817074,39.8325832583",
    "1$116.239233896,40.3906390639",
    "10593$116.309711653,39.9585958596",
    "25$116.767817074,39.7515751575",
    "2$116.110024675,39.7515751575",
    "1$116.262726482,40.3546354635",
    "274$116.309711653,39.7425742574",
    "6$116.438920874,40.3546354635",
    "182$116.615115267,39.8865886589",
    "2$116.850041124,40.2286228623",
    "3$116.95575776,40.1296129613",
    "24$117.158574954,40.2466246625",
    "1$115.769382182,39.8775877588",
    "5$116.110024675,39.6165616562",
    "11$116.13351726,40.2106210621",
    "66$116.192248725,40.1926192619",
    "116$116.556383803,39.8865886589",
    "661$116.650354146,39.8775877588",
    "7$116.944011467,40.1206120612",
    "1$117.088097196,40.3636363636",
    "11$115.992561746,39.8685868587",
    "1$116.227487603,40.4536453645",
    "1$116.532891217,40.6516651665",
    "37$116.615115267,40.1926192619",
    "20$116.662100439,39.8505850585",
    "2$116.70908561,40.2196219622",
    "4$116.979250346,40.1566156616",
    "52$115.933830282,39.6435643564",
    "251$116.063039503,40.0666066607",
    "94$116.168756139,39.8505850585",
    "28$116.203995017,39.697569757",
    "104$116.838294831,39.796579658",
    "4$116.850041124,39.7875787579",
    "114$116.239233896,40.1566156616",
    "2409$116.286219067,39.9495949595",
    "7468$116.38018941,39.895589559",
    "1009$116.46241346,40.0846084608",
    "9$117.041112025,40.4806480648",
    "11$117.205560125,40.2106210621",
    "25$115.980815453,40.3546354635",
    "1$116.039546917,40.5616561656",
    "6$116.074785796,40.5256525653",
    "18$116.086532089,39.6255625563",
    "60$116.368443117,40.2196219622",
    "10$116.54463751,40.2916291629",
    "2$115.839859939,39.9315931593",
    "103$116.180502432,39.9495949595",
    "6882$116.356696825,39.895589559",
    "46$116.650354146,40.102610261",
    "1$116.732578196,40.3816381638",
    "2$116.756070781,39.6615661566",
    "149$116.756070781,39.8595859586",
    "1$116.004308039,40.1116111611",
    "29$116.157009846,39.8325832583",
    "65$116.192248725,40.1296129613",
    "6381$116.485906046,39.8775877588",
    "354$116.591622682,39.796579658",
    "4$116.850041124,39.7335733573",
    "3$117.111589782,40.399639964",
    "3$115.88684511,40.0486048605",
    "3$116.180502432,39.6255625563",
    "644$116.309711653,39.796579658",
    "39$116.756070781,40.0846084608",
    "10$116.803055953,40.1116111611",
    "5$117.017619439,40.3906390639",
    "1$117.029365732,40.1296129613",
    "12$116.086532089,39.6165616562",
    "59$116.086532089,39.9855985599",
    "27$116.262726482,39.6885688569",
    "8$116.509398632,40.1476147615",
    "9$116.70908561,40.2106210621",
    "2$117.323023053,40.1656165617",
    "971$116.227487603,39.8865886589",
    "4$116.497652339,40.4626462646",
    "132$116.509398632,40.2106210621",
    "7$116.603368974,40.2286228623",
    "1$116.87353371,40.2826282628",
    "14$115.980815453,39.796579658",
    "103$116.157009846,39.9765976598",
    "213$116.21574131,40.2286228623",
    "314$116.638607853,39.8685868587",
    "8$116.826548539,39.8325832583",
    "44$116.286219067,39.697569757",
    "8148$116.638607853,39.904590459",
    "1$117.041112025,40.498649865",
    "1$117.052858318,40.2826282628",
    "1$115.522710032,39.9315931593",
    "2$115.875098818,39.6435643564",
    "3$116.039546917,40.4716471647",
    "596$116.227487603,39.8415841584",
    "1842$116.474159753,39.8325832583",
    "12$116.720831903,39.7155715572",
    "1$117.005873146,40.1566156616",
    "1$117.170321246,40.2196219622",
    "1$115.769382182,39.7695769577",
    "70$115.828113646,39.6525652565",
    "13$116.474159753,39.6075607561",
    "1$116.62686156,40.6336633663",
    "1$116.638607853,40.8856885689",
    "36$116.826548539,40.3456345635",
    "84$116.62686156,40.3816381638",
    "103$116.673846732,39.7335733573",
    "2$116.720831903,40.4266426643",
    "103$116.732578196,39.8415841584",
    "5$116.990996639,40.4536453645",
    "1$117.182067539,40.1746174617",
    "3$115.581441496,39.7875787579",
    "13$115.851606232,39.8145814581",
    "15$116.086532089,40.5526552655",
    "2$116.250980189,39.5445544554",
    "5$116.321457946,40.2286228623",
    "301$116.333204239,40.1206120612",
    "1$116.70908561,40.2376237624",
    "4$116.979250346,40.0756075608",
    "39$116.168756139,40.0126012601",
    "2$116.250980189,40.3636363636",
    "7135$116.474159753,39.904590459",
    "1$117.005873146,40.5886588659",
    "21$116.039546917,39.6345634563",
    "1$116.192248725,40.2916291629",
    "31$116.203995017,39.6435643564",
    "1$116.474159753,40.2286228623",
    "1217$116.54463751,39.9315931593",
    "7$116.615115267,40.696669667",
    "20$116.650354146,39.796579658",
    "18$117.029365732,40.1926192619",
    "14$115.957322868,39.5715571557",
    "125$116.274472775,39.7695769577",
    "23$116.321457946,40.1926192619",
    "4$116.87353371,39.8235823582",
    "6$116.920518881,40.1746174617",
    "2$115.839859939,40.4536453645",
    "60$116.203995017,40.1926192619",
    "31$116.344950532,39.5535553555",
    "5081$116.391935703,39.895589559",
    "53$116.70908561,39.9585958596",
    "1$117.264291589,40.2106210621",
    "22$115.933830282,40.3636363636",
    "5$116.098278382,40.2466246625",
    "4$116.227487603,40.3276327633",
    "1$116.286219067,39.5355535554",
    "497$116.38018941,39.7785778578",
    "6862$116.403681996,39.904590459",
    "4$116.415428289,40.2556255626",
    "118$116.591622682,40.00360036",
    "27$116.62686156,40.3456345635",
    "3$115.980815453,39.9675967597",
    "7$116.063039503,39.9855985599",
    "1819$116.262726482,39.9495949595",
    "1$116.356696825,39.5805580558",
    "10$116.54463751,40.1926192619",
    "103$116.591622682,40.1116111611",
    "16$116.744324489,39.7515751575",
    "82$116.016054332,40.3456345635",
    "6099$116.333204239,40.0306030603",
    "1064$116.509398632,39.9945994599",
    "6$117.217306418,40.6786678668",
    "15$116.05129321,39.9855985599",
    "344$116.121770967,39.9225922592",
    "34$116.145263553,39.8685868587",
    "349$116.203995017,39.8055805581",
    "349$116.579876389,39.8505850585",
    "82$115.957322868,39.7335733573",
    "5348$116.309711653,40.0486048605",
    "25$116.415428289,40.1926192619",
    "315$116.54463751,40.0936093609",
    "1138$116.54463751,40.102610261",
    "2$116.920518881,39.8505850585",
    "3$116.063039503,40.1926192619",
    "49$116.344950532,40.1656165617",
    "3$116.568130096,40.2376237624",
    "4$116.673846732,39.6255625563",
    "8$116.744324489,40.1566156616",
    "9$116.95575776,40.3816381638",
    "6$117.064604611,40.0936093609",
    "1$116.13351726,39.6165616562",
    "1201$116.203995017,39.8415841584",
    "1$116.779563367,40.4806480648",
    "75$115.957322868,40.4626462646",
    "1$116.05129321,39.5715571557",
    "2$116.227487603,39.5805580558",
    "15$116.309711653,40.2286228623",
    "1$116.46241346,40.3546354635",
    "1$116.497652339,40.6246624662",
    "10$116.803055953,40.0936093609",
    "19$117.217306418,40.1836183618",
    "20$115.651919253,39.6345634563",
    "2$115.933830282,40.4896489649",
    "7$115.992561746,39.7335733573",
    "7$116.415428289,39.7515751575",
    "18$116.932265174,40.4356435644",
    "20$117.276037882,40.2826282628",
    "2$117.287784175,40.6516651665",
    "44$116.756070781,40.0936093609",
    "3$115.96906916,39.8325832583",
    "4$116.098278382,39.6435643564",
    "7608$116.321457946,39.9315931593",
    "106$116.391935703,40.0396039604",
    "13$116.556383803,40.1836183618",
    "53$116.62686156,40.0936093609",
    "9$117.158574954,40.1476147615",
    "2$116.039546917,39.796579658",
    "116$116.168756139,39.796579658",
    "87$116.262726482,39.7605760576",
    "54$116.509398632,40.0936093609",
    "4$116.004308039,40.201620162",
    "2$116.098278382,39.6075607561",
    "565$116.168756139,39.7605760576",
    "248$116.239233896,40.2826282628",
    "15$116.262726482,39.7425742574",
    "8$116.497652339,40.0666066607",
    "21$116.615115267,40.1746174617",
    "5$115.96906916,40.3546354635",
    "1598$116.274472775,40.0666066607",
    "6982$116.321457946,40.0216021602",
    "1$116.38018941,39.6075607561",
    "66$116.403681996,39.7335733573",
    "10$116.474159753,40.3546354635",
    "88$116.497652339,39.6885688569",
    "24$116.673846732,39.8595859586",
    "11$117.217306418,40.3366336634",
    "19$116.074785796,39.9315931593",
    "90$116.180502432,40.2286228623",
    "147$116.192248725,40.2376237624",
    "32$116.250980189,39.6885688569",
    "1436$116.286219067,40.1566156616",
    "46$116.309711653,40.201620162",
    "167$116.321457946,39.5175517552",
    "881$116.556383803,40.0126012601",
    "321$116.650354146,40.1746174617",
    "18$116.885280003,39.7515751575",
    "11$115.875098818,39.6075607561",
    "26$115.957322868,39.5805580558",
    "50$115.96906916,39.6255625563",
    "3$116.250980189,40.2466246625",
    "27$116.615115267,39.7065706571",
    "53$116.62686156,39.8865886589",
    "16$116.767817074,39.6345634563",
    "14$116.920518881,39.8235823582",
    "5$117.052858318,40.0576057606",
    "34$117.158574954,40.3726372637",
    "7$117.158574954,40.6876687669",
    "17$115.898591403,39.6255625563",
    "1$116.168756139,40.3276327633",
    "25$116.203995017,39.5805580558",
    "3944$116.391935703,39.9225922592",
    "2$116.803055953,40.2286228623",
    "981$116.356696825,39.7605760576",
    "1001$116.427174582,40.102610261",
    "105$116.603368974,39.8685868587",
    "9$116.05129321,40.0396039604",
    "3$116.074785796,39.895589559",
    "378$116.203995017,40.1296129613",
    "293$116.29796536,39.796579658",
    "538$116.344950532,39.7695769577",
    "9$116.474159753,39.5625562556",
    "35$116.685593024,40.2916291629",
    "31$116.803055953,40.102610261",
    "2$116.908772589,40.0936093609",
    "1$115.863352525,39.9315931593",
    "1$115.88684511,40.4536453645",
    "192$116.391935703,40.1206120612",
    "44$116.767817074,39.8505850585",
    "8$116.814802246,40.201620162",
    "16$117.287784175,40.1926192619",
    "1$116.004308039,39.8865886589",
    "1$116.004308039,40.102610261",
    "31$116.110024675,39.8595859586",
    "3$116.157009846,40.5076507651",
    "4$116.157009846,40.6336633663",
    "7849$116.415428289,39.9765976598",
    "42$116.591622682,40.3096309631",
    "11$116.697339317,40.0846084608",
    "15$116.70908561,39.7695769577",
    "1450$116.403681996,39.8055805581",
    "90$116.46241346,39.7155715572",
    "8$116.474159753,40.2106210621",
    "1050$116.662100439,39.895589559",
    "100$115.945576575,39.9315931593",
    "11$116.004308039,39.9765976598",
    "3$116.016054332,40.00360036",
    "5$116.110024675,39.6075607561",
    "7537$116.344950532,39.904590459",
    "9143$116.415428289,40.0756075608",
    "9$116.779563367,40.0936093609",
    "4$116.803055953,40.2556255626",
    "19$116.826548539,40.0666066607",
    "10$116.897026296,40.102610261",
    "2$116.932265174,40.3726372637",
    "1$117.005873146,40.4356435644",
    "162$116.697339317,39.8595859586",
    "55$116.814802246,39.8775877588",
    "5$117.182067539,40.6156615662",
    "4$115.922083989,39.7335733573",
    "3$115.933830282,39.7065706571",
    "3$115.945576575,40.1836183618",
    "49$116.110024675,39.7605760576",
    "216$116.321457946,39.5895589559",
    "2$116.885280003,39.8235823582",
    "37$116.192248725,40.0936093609",
    "4$116.262726482,39.5805580558",
    "1870$116.497652339,39.9405940594",
    "31$116.685593024,40.00360036",
    "16$115.980815453,40.498649865",
    "16$116.286219067,39.6705670567",
    "186$116.309711653,40.1206120612",
    "35$116.685593024,40.2646264626",
    "3$117.276037882,40.1656165617",
    "1$116.016054332,40.0126012601",
    "5$116.039546917,40.4356435644",
    "22$116.086532089,39.7515751575",
    "3543$116.274472775,39.9585958596",
    "20$116.497652339,39.5625562556",
    "4566$116.556383803,39.9135913591",
    "10$117.002742931,40.0486048605",
    "20$115.933830282,39.7155715572",
    "1$115.957322868,39.697569757",
    "5$116.063039503,40.2916291629",
    "1$116.098278382,40.5706570657",
    "9$116.110024675,40.597659766",
    "102$116.356696825,40.1746174617",
    "4698$116.391935703,39.9855985599",
    "2$116.638607853,40.6156615662",
    "16$116.897026296,39.8055805581",
    "5$115.792874768,39.5175517552",
    "5$116.497652339,39.6525652565",
    "3$116.826548539,39.7515751575",
    "3$115.816367353,39.8685868587",
    "1$116.004308039,39.7605760576",
    "854$116.004308039,40.00360036",
    "1$116.039546917,39.904590459",
    "23$116.05129321,40.0126012601",
    "15$116.110024675,40.1386138614",
    "63$116.121770967,39.8235823582",
    "1$116.615115267,39.8235823582",
    "12$116.979250346,40.0576057606",
    "6$116.697339317,39.6525652565",
    "2$116.850041124,40.201620162",
    "6$116.13351726,39.7605760576",
    "65$116.180502432,40.1836183618",
    "6$116.756070781,39.7425742574",
    "8$116.779563367,40.3456345635",
    "19$115.769382182,39.5625562556",
    "2$115.769382182,39.8055805581",
    "4$116.05129321,39.6435643564",
    "1183$116.227487603,40.201620162",
    "44$116.403681996,39.6345634563",
    "46$116.497652339,40.2466246625",
    "17$116.556383803,40.3906390639",
    "24$116.697339317,39.8145814581",
    "12$117.193813832,40.3546354635",
    "8$115.957322868,39.6255625563",
    "2$115.992561746,39.6255625563",
    "7$116.415428289,39.5625562556",
    "3$116.838294831,39.6885688569",
    "2$116.027800625,40.399639964",
    "34$116.591622682,39.7065706571",
    "4$116.779563367,40.2646264626",
    "9$117.170321246,40.1746174617",
    "11$115.898591403,40.0756075608",
    "59$116.05129321,40.0306030603",
    "1050$116.145263553,39.7245724572",
    "1553$116.192248725,39.904590459",
    "3292$116.227487603,39.895589559",
    "1$116.004308039,39.9495949595",
    "103$116.086532089,39.7245724572",
    "1$116.29796536,39.5715571557",
    "39$116.29796536,40.1746174617",
    "14$116.720831903,39.8235823582",
    "54$116.720831903,40.1296129613",
    "21$116.779563367,39.7335733573",
    "16$116.79130966,40.201620162",
    "2$116.79130966,40.5616561656",
    "4$115.898591403,39.9495949595",
    "3$116.039546917,39.8505850585",
    "6$116.063039503,40.5706570657",
    "2$116.157009846,40.5616561656",
    "11$116.568130096,40.696669667",
    "75$116.673846732,40.399639964",
    "23$117.146828661,40.5526552655",
    "3$117.182067539,40.5256525653",
    "2$115.781128475,39.598559856",
    "4$115.792874768,40.0216021602",
    "22$116.192248725,39.697569757",
    "6492$116.38018941,39.8685868587",
    "5$116.603368974,40.0846084608",
    "10$116.767817074,40.3636363636",
    "121$116.098278382,40.00360036",
    "215$116.21574131,39.9855985599",
    "1463$116.62686156,39.904590459",
    "18$116.673846732,39.7515751575",
    "1$116.673846732,40.8586858686",
    "44$116.192248725,40.1836183618",
    "6$116.227487603,39.6165616562",
    "1567$116.368443117,39.8055805581",
    "6$116.438920874,39.5895589559",
    "682$116.438920874,40.00360036",
    "16$116.485906046,40.2376237624",
    "24$116.497652339,39.7065706571",
    "26$116.603368974,39.7335733573",
    "39$116.732578196,39.8145814581",
    "11$116.814802246,39.6525652565",
    "189$116.004308039,39.7155715572",
    "1$116.063039503,39.7695769577",
    "90$116.203995017,40.1836183618",
    "160$116.532891217,39.7875787579",
    "99$116.568130096,39.9855985599",
    "9$116.697339317,40.0126012601",
    "1$115.72239701,40.0666066607",
    "8$115.933830282,40.4806480648",
    "41$116.086532089,39.6615661566",
    "1163$116.274472775,40.0396039604",
    "2436$116.450667167,39.9765976598",
    "20$116.685593024,39.8505850585",
    "7$117.135082368,40.1926192619",
    "9$116.438920874,40.1656165617",
    "741$116.509398632,39.7695769577",
    "2$117.041112025,40.1296129613",
    "42$115.957322868,39.8235823582",
    "2907$116.239233896,39.895589559",
    "2154$116.286219067,39.9945994599",
    "6296$116.29796536,39.8865886589",
    "251$116.450667167,40.1116111611",
    "6$117.064604611,40.3636363636",
    "147$115.710650718,39.6345634563",
    "21$116.016054332,39.697569757",
    "42$116.13351726,39.7065706571",
    "145$116.427174582,40.1386138614",
    "358$116.556383803,39.8145814581",
    "9$116.62686156,40.2826282628",
    "1$116.673846732,40.5166516652",
    "1$116.861787417,40.4806480648",
    "87$116.05129321,39.7065706571",
    "396$116.427174582,39.7785778578",
    "1$116.485906046,40.4626462646",
    "15$116.532891217,40.1116111611",
    "338$116.814802246,39.6435643564",
    "20$116.826548539,40.5706570657",
    "39$116.039546917,39.7335733573",
    "450$116.157009846,40.0666066607",
    "6$116.203995017,39.7335733573",
    "20$116.309711653,40.2196219622",
    "43$116.579876389,39.697569757",
    "1088$116.685593024,39.9135913591",
    "12$116.779563367,39.6075607561",
    "93$116.227487603,39.7785778578",
    "11$116.556383803,40.3276327633",
    "1$117.076350904,40.2106210621",
    "7$116.004308039,39.6615661566",
    "2564$116.29796536,40.102610261",
    "13$116.532891217,40.3816381638",
    "5$117.076350904,40.1926192619",
    "1$117.123336075,40.3186318632",
    "12$117.170321246,40.4806480648",
    "11$116.027800625,40.5256525653",
    "37$116.685593024,40.3366336634",
    "1$116.814802246,40.399639964",
    "11$116.027800625,39.9765976598",
    "3$116.29796536,40.4086408641",
    "102$116.368443117,40.1836183618",
    "18$116.391935703,39.7515751575",
    "7$116.509398632,39.7245724572",
    "9733$116.521144924,39.9225922592",
    "43$116.650354146,39.7695769577",
    "29$116.70908561,40.1926192619",
    "1$116.756070781,40.2556255626",
    "1$116.239233896,40.4266426643",
    "7$116.274472775,39.598559856",
    "1353$116.450667167,39.8145814581",
    "9$116.063039503,39.7605760576",
    "1052$116.239233896,40.0756075608",
    "12$116.591622682,40.2286228623",
    "8$116.87353371,40.102610261",
    "21$117.029365732,40.0756075608",
    "1$117.146828661,40.201620162",
    "26$116.074785796,39.6885688569",
    "96$116.180502432,40.1206120612",
    "56$116.203995017,40.102610261",
    "23$116.767817074,40.102610261",
    "44$117.111589782,40.0846084608",
    "14$117.135082368,40.300630063",
    "2$115.96906916,39.9405940594",
    "3$116.074785796,39.7695769577",
    "313$116.21574131,39.9675967597",
    "6740$116.403681996,39.9495949595",
    "1$116.850041124,40.2556255626",
    "5$117.370008225,40.2196219622",
    "16$117.123336075,40.1206120612",
    "2$116.110024675,39.6255625563",
    "6384$116.356696825,40.0126012601",
    "5169$116.368443117,40.0846084608",
    "17$116.415428289,39.5355535554",
    "64$116.415428289,40.1386138614",
    "8524$116.438920874,39.9315931593",
    "7$116.556383803,39.9945994599",
    "108$116.579876389,39.9765976598",
    "2851$116.615115267,39.9225922592",
    "152$116.615115267,40.1566156616",
    "12$116.756070781,40.3726372637",
    "8$116.908772589,40.2196219622",
    "3$117.005873146,40.0936093609",
    "25$115.980815453,40.4806480648",
    "684$116.38018941,39.796579658",
    "176$116.403681996,40.1926192619",
    "1052$116.568130096,39.9405940594",
    "51$116.685593024,39.6525652565",
    "13$115.828113646,39.5535553555",
    "44$116.110024675,39.6525652565",
    "54$116.110024675,39.8685868587",
    "1802$116.168756139,39.9315931593",
    "5$116.286219067,39.6255625563",
    "68$116.29796536,40.3366336634",
    "1$116.391935703,39.5805580558",
    "22$116.568130096,39.6615661566",
    "7$115.96906916,39.6885688569",
    "1$115.980815453,39.7695769577",
    "26$116.110024675,39.5805580558",
    "2$116.110024675,40.1656165617",
    "158$116.21574131,40.1656165617",
    "51$116.157009846,40.1116111611",
    "6$116.157009846,40.2736273627",
    "17$116.673846732,39.6705670567",
    "7$116.697339317,40.0216021602",
    "6$116.509398632,39.6615661566",
    "20$116.603368974,40.0756075608",
    "5761$116.474159753,40.00360036",
    "96$116.016054332,39.5895589559",
    "29$116.039546917,39.697569757",
    "1$116.05129321,40.5346534653",
    "22$116.098278382,39.7065706571",
    "5$116.29796536,40.1836183618",
    "1288$116.403681996,40.0396039604",
    "1216$116.532891217,40.00360036",
    "2$116.767817074,39.6615661566",
    "9$116.861787417,40.1296129613",
    "1$116.87353371,39.7695769577",
    "12$117.252545296,40.6606660666",
    "3$115.781128475,40.00360036",
    "6$115.88684511,40.3816381638",
    "4$116.074785796,40.1836183618",
    "339$116.180502432,39.7515751575",
    "1779$116.286219067,39.8145814581",
    "3461$116.344950532,39.8235823582",
    "7940$116.474159753,39.9945994599",
    "7$116.603368974,40.3096309631",
    "13$116.62686156,39.697569757",
    "1$116.70908561,40.8496849685",
    "2$116.803055953,40.2916291629",
    "9$116.979250346,40.1656165617",
    "6$117.123336075,40.5436543654",
    "2$116.027800625,40.4716471647",
    "44$116.13351726,40.1116111611",
    "383$116.145263553,40.102610261",
    "23$116.309711653,39.5445544554",
    "418$116.333204239,39.7155715572",
    "33$117.005873146,40.0756075608",
    "121$117.041112025,40.1566156616",
    "24$117.158574954,40.5616561656",
    "1$115.792874768,40.0576057606",
    "6$115.992561746,40.2196219622",
    "2$116.063039503,40.3456345635",
    "6076$116.368443117,39.9315931593",
    "69$116.415428289,39.6615661566",
    "5$116.016054332,40.4716471647",
    "1$116.039546917,40.3456345635",
    "176$116.168756139,39.7515751575",
    "27$116.274472775,40.2466246625",
    "1$116.344950532,39.4815481548",
    "7684$116.391935703,39.8865886589",
    "7135$116.438920874,39.8595859586",
    "4381$116.485906046,39.904590459",
    "14$116.662100439,39.697569757",
    "1$116.662100439,40.4716471647",
    "6$116.803055953,40.4086408641",
    "1$116.38018941,39.598559856",
    "8117$116.438920874,39.895589559",
    "726$116.54463751,39.8595859586",
    "19$116.697339317,40.1656165617",
    "4$116.79130966,40.3366336634",
    "1$117.041112025,40.1926192619",
    "1$115.922083989,39.6795679568",
    "86$116.110024675,40.0846084608",
    "426$116.180502432,39.7605760576",
    "4$116.403681996,39.5535553555",
    "3$116.591622682,40.2736273627",
    "102$116.638607853,39.6615661566",
    "13$116.779563367,40.0306030603",
    "26$117.005873146,40.1296129613",
    "5$115.687158132,39.9675967597",
    "11$115.88684511,39.5535553555",
    "10$115.910337696,39.7335733573",
    "279$116.157009846,40.0756075608",
    "11585$116.344950532,39.9765976598",
    "23$116.344950532,40.1836183618",
    "28$116.38018941,40.2106210621",
    "197$116.591622682,40.0306030603",
    "17$116.756070781,39.7695769577",
    "36$116.779563367,40.102610261",
    "19$117.205560125,40.6426642664",
    "9$115.898591403,40.201620162",
    "39$116.063039503,39.9225922592",
    "4$116.098278382,40.1746174617",
    "412$116.110024675,39.8865886589",
    "36$116.110024675,40.0396039604",
    "5684$116.309711653,40.0936093609",
    "21$116.38018941,40.2286228623",
    "26$116.932265174,40.0576057606",
    "12$115.992561746,39.6705670567",
    "148$116.145263553,39.8235823582",
    "193$116.157009846,39.7425742574",
    "4$116.309711653,39.4725472547",
    "4$116.356696825,40.1926192619",
    "8$116.591622682,40.2556255626",
    "221$116.673846732,40.0396039604",
    "49$116.673846732,40.0666066607",
    "2$116.344950532,40.2376237624",
    "810$116.54463751,40.0396039604",
    "18$116.556383803,40.4266426643",
    "29$116.579876389,40.300630063",
    "33$116.62686156,40.3546354635",
    "84$116.638607853,40.2826282628",
    "1$116.814802246,40.5436543654",
    "1$116.908772589,40.5706570657",
    "2$117.041112025,40.2196219622",
    "11$117.146828661,40.1566156616",
    "2$115.875098818,39.5535553555",
    "63$115.96906916,40.4446444644",
    "8$116.110024675,40.3726372637",
    "27$116.13351726,39.697569757",
    "1709$116.415428289,39.8055805581",
    "743$116.54463751,40.0846084608",
    "1$116.603368974,40.3546354635",
    "6$116.779563367,40.0846084608",
    "33$116.920518881,40.0846084608",
    "1$117.205560125,40.3546354635",
    "1$115.922083989,40.4536453645",
    "33$115.945576575,40.3546354635",
    "19$116.720831903,40.3276327633",
    "9$115.663665546,39.6255625563",
    "19$115.875098818,39.6615661566",
    "44$116.039546917,39.9855985599",
    "3472$116.145263553,40.2556255626",
    "30$116.250980189,39.7335733573",
    "25$116.309711653,39.499549955",
    "8685$116.344950532,39.895589559",
    "2735$116.450667167,39.8055805581",
    "11$116.756070781,39.697569757",
    "90$116.838294831,39.8595859586",
    "25$116.908772589,40.399639964",
    "2$117.064604611,40.5076507651",
    "1$115.898591403,39.6345634563",
    "2$116.086532089,40.0576057606",
    "292$116.121770967,39.8865886589",
    "1$116.13351726,40.1926192619",
    "6$116.180502432,40.1746174617",
    "2614$116.29796536,40.0486048605",
    "6$116.450667167,39.598559856",
    "24$116.650354146,40.2376237624",
    "195$115.534456325,40.0306030603",
    "7$115.80462106,40.4536453645",
    "5$115.96906916,39.9855985599",
    "38$116.016054332,39.6795679568",
    "480$116.180502432,39.7425742574",
    "397$116.250980189,39.9585958596",
    "147$116.250980189,40.2826282628",
    "37$116.344950532,40.1206120612",
    "966$116.38018941,39.8055805581",
    "72$116.54463751,39.7155715572",
    "582$116.662100439,40.1386138614",
    "20$116.662100439,40.696669667",
    "3$116.685593024,39.7335733573",
    "62$116.885280003,40.3906390639",
    "65$116.239233896,40.2916291629",
    "164$116.591622682,39.8775877588",
    "2$116.662100439,40.6336633663",
    "2$116.685593024,39.8145814581",
    "15$116.779563367,39.895589559",
    "1$116.814802246,39.6705670567",
    "186$116.192248725,39.8685868587",
    "456$116.250980189,40.1116111611",
    "786$116.286219067,40.1656165617",
    "27$116.333204239,39.5355535554",
    "1$116.356696825,39.5715571557",
    "211$116.662100439,39.8595859586",
    "119$116.814802246,40.3636363636",
    "2$116.979250346,40.1206120612",
    "17$116.62686156,39.8055805581",
    "1$116.039546917,40.4896489649",
    "14$116.063039503,39.9675967597",
    "594$116.21574131,40.0396039604",
    "9398$116.368443117,39.9135913591",
    "8$116.673846732,39.6165616562",
    "1$116.756070781,40.804680468",
    "1$116.004308039,40.4806480648",
    "149$116.157009846,39.904590459",
    "19$116.227487603,40.3186318632",
    "285$116.262726482,39.8325832583",
    "10$116.591622682,40.2826282628",
    "275$116.673846732,40.0306030603",
    "28$116.673846732,40.1836183618",
    "3$116.885280003,39.697569757",
    "204$116.145263553,39.8055805581",
    "2$116.203995017,40.4176417642",
    "1302$116.21574131,39.7605760576",
    "3570$116.46241346,39.9405940594",
    "1$116.556383803,39.7065706571",
    "18$116.779563367,39.8055805581",
    "23$116.838294831,39.7875787579",
    "10$115.734143303,40.0396039604",
    "190$116.145263553,39.7605760576",
    "10527$116.344950532,39.9675967597",
    "1$116.509398632,40.2736273627",
    "22$116.603368974,40.2916291629",
    "10$116.732578196,39.7785778578",
    "34$116.779563367,39.796579658",
    "7$117.041112025,40.0576057606",
    "1$115.792874768,40.4626462646",
    "1$115.88684511,40.4356435644",
    "1$116.027800625,39.6435643564",
    "87$116.321457946,39.8145814581",
    "47$116.427174582,39.697569757",
    "3$116.509398632,39.6255625563",
    "19$116.591622682,39.7515751575",
    "6$116.662100439,40.4536453645",
    "23$116.826548539,39.6345634563",
    "4$117.052858318,40.3906390639",
    "1$117.182067539,40.6786678668",
    "4$115.628426668,39.6435643564",
    "6$115.710650718,39.5625562556",
    "1730$116.333204239,39.7245724572",
    "6$116.532891217,39.6345634563",
    "6$116.54463751,39.6165616562",
    "115$116.650354146,40.2196219622",
    "26$116.720831903,39.8415841584",
    "26$116.732578196,39.8325832583",
    "25$117.099843489,40.0846084608",
    "2$116.016054332,40.5436543654",
    "1138$116.321457946,39.8325832583",
    "14975$116.321457946,39.9765976598",
    "2$116.403681996,39.5805580558",
    "9$116.662100439,39.6345634563",
    "111$116.756070781,39.904590459",
    "2$115.851606232,39.6435643564",
    "379$116.13351726,40.102610261",
    "14$116.438920874,39.5715571557",
    "151$116.838294831,40.3906390639",
    "29$116.039546917,39.5805580558",
    "3$116.05129321,39.7695769577",
    "3$116.05129321,40.4626462646",
    "38$116.180502432,40.2196219622",
    "1$116.180502432,40.5796579658",
    "4$116.192248725,40.0216021602",
    "336$116.403681996,40.1836183618",
    "13$116.650354146,40.2286228623",
    "1$117.052858318,40.6606660666",
    "6$117.064604611,40.1656165617",
    "313$116.121770967,40.0756075608",
    "5$116.344950532,39.6345634563",
    "205$116.568130096,39.8775877588",
    "3$116.779563367,39.6435643564",
    "4$117.146828661,40.4896489649",
    "2$116.086532089,40.5886588659",
    "202$116.098278382,39.7245724572",
    "5$116.157009846,40.4626462646",
    "31$116.239233896,39.6705670567",
    "56$116.403681996,40.2106210621",
    "372$116.556383803,39.8775877588",
    "9$116.744324489,39.7065706571",
    "2$116.838294831,40.0846084608",
    "14$116.885280003,40.0846084608",
    "20$116.05129321,40.3186318632",
    "240$116.21574131,39.9495949595",
    "11$116.250980189,39.6435643564",
    "5$116.344950532,39.4635463546",
    "78$116.38018941,40.1206120612",
    "54$116.415428289,39.697569757",
    "7$116.532891217,40.1746174617",
    "67$116.697339317,40.4446444644",
    "16$116.70908561,40.1206120612",
    "8$117.135082368,40.3276327633",
    "4$117.135082368,40.4176417642",
    "1$117.217306418,40.1386138614",
    "4$115.933830282,40.3906390639",
    "431$115.96906916,40.4626462646",
    "42$116.098278382,39.6885688569",
    "14$116.13351726,40.1836183618",
    "39$116.485906046,40.2106210621",
    "2$116.521144924,39.6885688569",
    "19$116.720831903,40.1206120612",
    "10$116.744324489,40.2106210621",
    "1$115.945576575,40.0216021602",
    "46$116.192248725,40.1116111611",
    "59$116.227487603,39.8235823582",
    "7$116.29796536,39.5535553555",
    "4176$116.29796536,39.9585958596",
    "3690$116.29796536,39.9765976598",
    "1$116.391935703,39.4815481548",
    "5310$116.485906046,39.9765976598",
    "75$116.591622682,40.2916291629",
    "55$116.603368974,39.6795679568",
    "209$116.62686156,39.9945994599",
    "4$116.779563367,40.300630063",
    "128$116.05129321,40.0846084608",
    "1385$116.286219067,40.0396039604",
    "2382$116.427174582,40.00360036",
    "2$116.485906046,40.4086408641",
    "2$116.509398632,40.4806480648",
    "82$116.521144924,39.8775877588",
    "216$116.556383803,40.0756075608",
    "12$116.850041124,39.7245724572",
    "4$117.005873146,40.3906390639",
    "281$117.123336075,40.1476147615",
    "2$115.734143303,39.6615661566",
    "19$115.957322868,40.4356435644",
    "46$116.192248725,40.0756075608",
    "103$116.203995017,40.2106210621",
    "76$116.485906046,40.1476147615",
    "58$116.509398632,40.0576057606",
    "5$115.781128475,39.6795679568",
    "13$116.098278382,39.8775877588",
    "9$116.168756139,40.1206120612",
    "12$116.192248725,39.7065706571",
    "7123$116.344950532,39.9315931593",
    "13$116.427174582,39.4635463546",
    "186$116.427174582,39.7245724572",
    "57$116.532891217,40.0756075608",
    "35$116.650354146,40.00360036",
    "20$116.157009846,40.2286228623",
    "73$116.286219067,39.7065706571",
    "1$116.732578196,40.0576057606",
    "2$116.814802246,40.0396039604",
    "23$116.826548539,40.3276327633",
    "2$117.182067539,40.5076507651",
    "4$115.898591403,40.0576057606",
    "69$116.180502432,40.1656165617",
    "422$116.239233896,40.1926192619",
    "100$116.274472775,40.4176417642",
    "1000$116.321457946,39.7785778578",
    "2$116.344950532,39.5355535554",
    "7$116.391935703,39.598559856",
    "4$116.70908561,39.6435643564",
    "5$116.814802246,40.2556255626",
    "134$115.710650718,39.6075607561",
    "1$115.863352525,39.6255625563",
    "3$116.415428289,39.4635463546",
    "1$116.556383803,40.3546354635",
    "64$116.568130096,39.8235823582",
    "1$116.70908561,40.0126012601",
    "115$116.70908561,40.1296129613",
    "48$117.193813832,40.1296129613",
    "1$117.252545296,40.2376237624",
    "26$116.121770967,39.6795679568",
    "1584$116.21574131,39.9135913591",
    "2$116.274472775,40.4086408641",
    "90$116.497652339,40.0756075608",
    "188$116.579876389,39.9405940594",
    "5$116.38018941,40.3906390639",
    "33$116.556383803,40.3366336634",
    "1$116.603368974,40.4176417642",
    "234$116.638607853,40.0306030603",
    "85$116.638607853,40.102610261",
    "9$116.673846732,39.7875787579",
    "11$116.803055953,40.201620162",
    "5$116.838294831,40.4896489649",
    "1$116.885280003,40.300630063",
    "16$116.086532089,39.8055805581",
    "24$116.157009846,40.2646264626",
    "108$116.309711653,39.6705670567",
    "63$116.638607853,40.0936093609",
    "120$116.638607853,40.4176417642",
    "1$116.850041124,40.4806480648",
    "14$116.885280003,40.0576057606",
    "2$115.96906916,39.7425742574",
    "23$116.098278382,39.6615661566",
    "6$116.21574131,39.6165616562",
    "212$116.356696825,39.7875787579",
    "1037$116.356696825,40.1116111611",
    "51$116.685593024,40.4176417642",
    "15$116.767817074,40.2106210621",
    "5$116.814802246,39.7515751575",
    "17$117.052858318,40.0666066607",
    "6$117.217306418,40.1926192619",
    "4$115.922083989,40.3636363636",
    "219$116.450667167,39.7875787579",
    "29$116.474159753,39.6255625563",
    "143$116.568130096,40.0846084608",
    "23$116.744324489,40.2826282628",
    "1$116.79130966,40.1836183618",
    "31$116.814802246,40.1746174617",
    "8$115.992561746,40.0306030603",
    "5$116.180502432,39.6885688569",
    "7$116.262726482,40.2736273627",
    "8$116.321457946,39.598559856",
    "16$116.662100439,40.3096309631",
    "2$116.897026296,40.1476147615",
    "8$116.95575776,40.1566156616",
    "9496$116.309711653,39.9405940594",
    "36$116.46241346,39.6885688569",
    "1$116.591622682,40.4446444644",
    "411$116.861787417,40.3726372637",
    "5$117.052858318,40.1926192619",
    "5$117.205560125,40.1926192619",
    "3$117.323023053,40.6426642664",
    "604$116.13351726,39.7245724572",
    "103$116.168756139,39.9945994599",
    "5$116.274472775,39.5445544554",
    "9$116.286219067,39.5445544554",
    "256$116.321457946,39.5085508551",
    "7$116.391935703,39.6435643564",
    "1$116.591622682,40.9216921692",
    "39$116.638607853,40.0666066607",
    "1$116.70908561,39.6345634563",
    "1$116.932265174,40.2826282628",
    "1$117.170321246,40.6606660666",
    "96$116.180502432,40.201620162",
    "3$116.192248725,39.6615661566",
    "4755$116.274472775,39.8775877588",
    "56$116.579876389,39.6795679568",
    "137$116.638607853,40.300630063",
    "10$116.850041124,39.8145814581",
    "3$117.099843489,40.399639964",
    "6$117.111589782,40.201620162",
    "62$116.063039503,39.7245724572",
    "10$116.121770967,39.6885688569",
    "424$116.121770967,39.8595859586",
    "2$116.29796536,40.2556255626",
    "1541$116.532891217,39.8595859586",
    "291$116.556383803,39.8415841584",
    "2$116.756070781,39.6345634563",
    "1$116.333204239,39.5535553555",
    "63$116.662100439,40.1476147615",
    "1$116.861787417,40.1386138614",
    "2$116.908772589,40.1206120612",
    "4$117.158574954,40.4536453645",
    "119$116.21574131,39.8775877588",
    "1$116.356696825,40.2916291629",
    "17$116.509398632,39.697569757",
    "445$116.568130096,40.1116111611",
    "4836$116.250980189,39.895589559",
    "105$116.309711653,39.6165616562",
    "3$116.356696825,39.5625562556",
    "3997$116.403681996,40.0756075608",
    "2$116.497652339,39.6075607561",
    "3$116.532891217,40.4266426643",
    "2$116.54463751,39.9855985599",
    "41$116.638607853,39.7875787579",
    "1$116.685593024,39.6165616562",
    "5$116.897026296,39.7875787579",
    "4$117.217306418,40.4266426643",
    "1$116.05129321,40.5796579658",
    "3422$116.274472775,40.0216021602",
    "171$116.29796536,40.1296129613",
    "3672$116.309711653,40.0756075608",
    "33$116.356696825,40.1656165617",
    "80$116.391935703,40.1566156616",
    "126$116.438920874,40.1476147615",
    "145$116.450667167,40.0576057606",
    "19$116.497652339,40.1116111611",
    "980$116.532891217,40.0126012601",
    "1088$116.591622682,40.0846084608",
    "16$116.615115267,39.7515751575",
    "3$116.720831903,40.1116111611",
    "2$115.781128475,39.8865886589",
    "10$115.816367353,39.5355535554",
    "7$116.039546917,39.7515751575",
    "1166$116.227487603,39.9225922592",
    "693$116.485906046,39.7605760576",
    "17$116.509398632,39.6345634563",
    "35$116.591622682,39.9855985599",
    "1163$116.638607853,39.8775877588",
    "9$116.673846732,40.0756075608",
    "11$116.908772589,40.5616561656",
    "2$117.099843489,40.597659766",
    "29$115.933830282,39.6255625563",
    "11927$116.415428289,39.9135913591",
    "2442$116.438920874,39.8055805581",
    "11$117.041112025,40.1206120612",
    "9$117.146828661,40.4176417642",
    "23$115.781128475,39.6075607561",
    "1$115.980815453,39.9315931593",
    "7$116.121770967,39.7515751575",
    "593$116.403681996,39.7875787579",
    "40$117.135082368,40.1836183618",
    "1$115.781128475,40.4536453645",
    "10$115.816367353,39.7155715572",
    "2$116.086532089,40.1656165617",
    "3820$116.203995017,39.9225922592",
    "33$116.321457946,39.5445544554",
    "910$116.579876389,39.9585958596",
    "1$116.744324489,40.7866786679",
    "54$116.474159753,40.1836183618",
    "5$116.532891217,40.300630063",
    "319$116.638607853,40.3276327633",
    "50$116.673846732,39.8325832583",
    "4$116.990996639,40.399639964",
    "2$117.052858318,40.3816381638",
    "45$117.146828661,40.102610261",
    "6$117.205560125,40.5706570657",
    "2$115.569695203,39.8685868587",
    "59$116.110024675,40.1836183618",
    "6$116.110024675,40.1926192619",
    "139$116.145263553,39.8865886589",
    "204$116.274472775,40.0576057606",
    "31$116.344950532,39.6165616562",
    "14$116.779563367,40.3546354635",
    "2$116.95575776,40.3906390639",
    "6$116.990996639,40.0936093609",
    "6$117.005873146,40.4626462646",
    "17$117.229052711,40.1476147615",
    "39$115.992561746,39.9765976598",
    "274$116.203995017,39.9675967597",
    "382$116.274472775,40.201620162",
    "5$116.063039503,39.9405940594",
    "651$116.203995017,39.8145814581",
    "5438$116.227487603,39.904590459",
    "16$116.250980189,40.2376237624",
    "38$116.333204239,39.6795679568",
    "8101$116.450667167,39.9585958596",
    "2$116.46241346,39.5805580558",
    "1$116.826548539,40.5076507651",
    "14$117.205560125,40.1296129613",
    "26$117.287784175,40.1836183618",
    "213$116.29796536,39.6885688569",
    "7$116.309711653,39.5355535554",
    "11$116.603368974,40.1746174617",
    "10$116.685593024,40.0666066607",
    "2$116.897026296,40.1116111611",
    "3$117.041112025,40.2286228623",
    "2$117.052858318,40.498649865",
    "31$116.098278382,39.9855985599",
    "11$116.13351726,39.6435643564",
    "9$116.13351726,40.0126012601",
    "6435$116.38018941,39.9495949595",
    "197$116.403681996,39.697569757",
    "15$116.615115267,40.2106210621",
    "42$116.685593024,39.9945994599",
    "16$116.826548539,39.8055805581",
    "4$115.734143303,39.9855985599",
    "2$115.781128475,40.4626462646",
    "54$116.145263553,39.9585958596",
    "1545$116.344950532,39.7425742574",
    "1$116.579876389,40.3726372637",
    "2747$116.638607853,39.895589559",
    "20$116.756070781,40.300630063",
    "13$117.182067539,40.1656165617",
    "9$117.252545296,40.2196219622",
    "5$115.88684511,39.5895589559",
    "2485$116.368443117,40.0216021602",
    "2$116.403681996,39.5445544554",
    "12998$116.46241346,39.8775877588",
    "47$116.532891217,40.1296129613",
    "8$116.662100439,40.4446444644",
    "77$116.685593024,40.1386138614",
    "8$116.779563367,39.9315931593",
    "43$116.05129321,39.5805580558",
    "170$116.203995017,40.2826282628",
    "92$116.250980189,40.0306030603",
    "13$116.391935703,39.5895589559",
    "5$116.979250346,40.0846084608",
    "3$117.017619439,40.3636363636",
    "3$116.016054332,40.5166516652",
    "8702$116.321457946,39.895589559",
    "2$116.532891217,39.6255625563",
    "17$116.920518881,40.399639964",
    "3$116.932265174,40.2106210621",
    "9$115.898591403,40.1476147615",
    "1$115.980815453,39.9495949595",
    "882$116.192248725,39.8325832583",
    "3$116.615115267,39.6885688569",
    "743$116.650354146,39.9135913591",
    "11$116.732578196,40.4536453645",
    "2$117.064604611,40.6426642664",
    "6077$116.239233896,39.904590459",
    "39$116.391935703,40.1386138614",
    "27$116.450667167,39.6705670567",
    "1410$116.497652339,39.9945994599",
    "883$116.556383803,40.0846084608",
    "694$116.697339317,39.9135913591",
    "14$117.123336075,40.2376237624",
    "4$115.828113646,40.0216021602",
    "25$116.121770967,40.201620162",
    "1157$116.203995017,39.895589559",
    "1288$116.239233896,40.2286228623",
    "59$116.286219067,40.2556255626",
    "1$116.286219067,40.3636363636",
    "8657$116.415428289,39.904590459",
    "23$116.497652339,40.2556255626",
    "56$116.521144924,39.7515751575",
    "395$116.591622682,39.8325832583",
    "7$117.064604611,40.1386138614",
    "2$115.898591403,40.4536453645",
    "4$115.898591403,40.498649865",
    "94$116.145263553,39.7065706571",
    "1364$116.368443117,40.0666066607",
    "208$116.568130096,39.7515751575",
    "1$116.640667699,41.0585058506",
    "2$116.744324489,40.0936093609",
    "22$116.767817074,40.0306030603",
    "4$116.897026296,40.1656165617",
    "6$116.180502432,40.5256525653",
    "1$116.62686156,40.9396939694",
    "1$116.662100439,40.4176417642",
    "4$116.720831903,40.0576057606",
    "9$116.744324489,39.6795679568",
    "646$116.744324489,39.9315931593",
    "8$116.157009846,40.4536453645",
    "4$116.239233896,39.5625562556",
    "1480$116.239233896,39.8505850585",
    "3$116.262726482,40.6876687669",
    "2$116.274472775,39.6165616562",
    "611$116.286219067,39.7515751575",
    "2$116.427174582,40.2916291629",
    "2$116.556383803,40.2376237624",
    "23$116.720831903,39.8865886589",
    "188$116.157009846,40.0486048605",
    "3$116.227487603,39.6615661566",
    "1$116.274472775,39.5085508551",
    "5$116.368443117,39.6165616562",
    "5443$116.509398632,39.8595859586",
    "112$116.568130096,40.1386138614",
    "8$116.685593024,39.8235823582",
    "82$116.720831903,39.796579658",
    "10$117.135082368,40.5436543654",
    "10$115.922083989,39.6615661566",
    "1$116.086532089,39.6075607561",
    "122$116.262726482,40.0936093609",
    "104$116.29796536,39.499549955",
    "5$116.521144924,40.4176417642",
    "3$116.62855945,41.00450045",
    "1$115.957322868,40.300630063",
    "61$116.13351726,39.9225922592",
    "146$116.556383803,39.796579658",
    "14$116.838294831,40.2106210621",
    "585$116.203995017,39.9495949595",
    "9$116.262726482,39.5625562556",
    "1$116.415428289,39.5085508551",
    "4903$116.415428289,39.8865886589",
    "38$116.509398632,39.7425742574",
    "19$116.579876389,40.2556255626",
    "1545$116.603368974,39.895589559",
    "1$116.685593024,40.0756075608",
    "26$116.814802246,40.5346534653",
    "1$116.908772589,40.0846084608",
    "16$116.333204239,39.5085508551",
    "24$116.415428289,39.5265526553",
    "17$116.579876389,40.2826282628",
    "8$116.838294831,40.4356435644",
    "5$115.875098818,40.4086408641",
    "802$116.556383803,39.8685868587",
    "34$116.673846732,40.2196219622",
    "11$116.814802246,39.7695769577",
    "27$116.826548539,40.4266426643",
    "13$115.898591403,40.3816381638",
    "4$116.262726482,40.3906390639",
    "246$116.274472775,40.1926192619",
    "6477$116.344950532,40.0666066607",
    "1455$116.427174582,40.0576057606",
    "1260$116.450667167,40.00360036",
    "50$116.615115267,40.00360036",
    "58$116.650354146,40.4176417642",
    "2$116.697339317,40.1836183618",
    "10$117.088097196,40.3906390639",
    "349$116.21574131,39.796579658",
    "25$116.274472775,40.2916291629",
    "332$116.29796536,39.8055805581",
    "1535$116.333204239,39.7425742574",
    "3$116.368443117,40.1566156616",
    "11$116.556383803,40.4536453645",
    "121$116.744324489,39.8865886589",
    "7$116.908772589,40.1656165617",
    "121$117.135082368,40.1476147615",
    "9$117.252545296,40.2106210621",
    "2$115.628426668,39.6525652565",
    "3$115.698904425,39.6255625563",
    "1$115.745889596,39.7425742574",
    "1726$116.262726482,40.1296129613",
    "10$116.450667167,40.4536453645",
    "179$116.638607853,39.9855985599",
    "2040$116.274472775,39.9675967597",
    "1$116.438920874,40.1926192619",
    "5646$116.450667167,39.904590459",
    "2$116.62686156,40.4446444644",
    "147$116.673846732,40.4176417642",
    "5$117.323023053,40.2466246625",
    "51$116.027800625,40.0756075608",
    "90$116.262726482,39.796579658",
    "121$116.29796536,40.1386138614",
    "274$115.816367353,39.6885688569",
    "70$116.274472775,39.7155715572",
    "3$116.403681996,40.2736273627",
    "1$116.450667167,40.4086408641",
    "18$116.485906046,40.2196219622",
    "2$116.662100439,40.3366336634",
    "2$116.967504053,40.4086408641",
    "1$115.616680375,39.6525652565",
    "2$115.933830282,40.4266426643",
    "547$116.344950532,39.7155715572",
    "9439$116.368443117,39.9495949595",
    "11$116.70908561,39.6705670567",
    "2$116.756070781,40.4626462646",
    "7$116.803055953,40.3366336634",
    "1$116.838294831,39.6525652565",
    "2835$116.368443117,39.8145814581",
    "55$116.70908561,39.9315931593",
    "349$116.720831903,39.9495949595",
    "4$116.767817074,40.0576057606",
    "14$116.004308039,39.6165616562",
    "38$116.027800625,40.3366336634",
    "3813$116.29796536,39.9315931593",
    "2292$116.403681996,40.0126012601",
    "868$116.474159753,40.0306030603",
    "1$116.521144924,40.2736273627",
    "1$116.591622682,40.1746174617",
    "2$116.62686156,39.6345634563",
    "8$116.697339317,40.2106210621",
    "14$116.861787417,40.2286228623",
    "1$116.885280003,40.5886588659",
    "4$116.920518881,39.8325832583",
    "10$116.098278382,40.498649865",
    "38$116.192248725,39.895589559",
    "8$116.227487603,39.5895589559",
    "2291$116.638607853,39.9225922592",
    "1$116.650354146,40.7506750675",
    "11$116.79130966,40.3186318632",
    "4$116.944011467,40.1836183618",
    "3$115.992561746,40.2376237624",
    "632$116.368443117,39.7605760576",
    "5742$116.368443117,39.9675967597",
    "4$116.38018941,39.5265526553",
    "3$116.497652339,39.5805580558",
    "196$116.673846732,39.9135913591",
    "12$116.814802246,40.1116111611",
    "2$115.851606232,40.4806480648",
    "276$116.063039503,39.7065706571",
    "1$116.356696825,39.6255625563",
    "7582$116.38018941,39.8865886589",
    "4$116.603368974,40.2196219622",
    "4$116.697339317,40.3546354635",
    "1$115.980815453,40.5256525653",
    "162$116.21574131,39.697569757",
    "14$116.29796536,40.4176417642",
    "4897$116.309711653,40.0846084608",
    "71$116.333204239,39.6705670567",
    "4$116.344950532,40.3726372637",
    "4$116.779563367,40.4086408641",
    "4$116.086532089,40.5076507651",
    "3$116.286219067,40.5706570657",
    "8182$116.333204239,39.8865886589",
    "1$116.344950532,39.5265526553",
    "6592$116.427174582,39.9315931593",
    "1$116.662100439,39.6165616562",
    "63$116.744324489,39.8505850585",
    "1$116.932265174,39.8055805581",
    "20$117.146828661,40.5616561656",
    "2$115.769382182,40.5256525653",
    "2$115.792874768,39.5805580558",
    "1$115.88684511,39.8505850585",
    "76$115.992561746,39.9495949595",
    "5$116.039546917,39.6075607561",
    "8$116.168756139,39.9585958596",
    "1$116.227487603,39.6075607561",
    "34$116.391935703,39.697569757",
    "236$116.568130096,40.0666066607",
    "11$116.814802246,39.7425742574",
    "25$116.897026296,40.4626462646",
    "4$117.170321246,40.5616561656",
    "18$115.781128475,39.5355535554",
    "78$116.21574131,40.0216021602",
    "2$116.227487603,39.5715571557",
    "214$116.321457946,39.6075607561",
    "50$116.415428289,40.2286228623",
    "8$116.697339317,40.2376237624",
    "1$115.745889596,40.0306030603",
    "10$116.344950532,40.3366336634",
    "38$116.556383803,40.201620162",
    "19$116.568130096,40.3636363636",
    "9$116.803055953,39.8415841584",
    "4$116.932265174,40.0846084608",
    "9$117.052858318,40.201620162",
    "1$115.96906916,39.8415841584",
    "4$116.016054332,39.8145814581",
    "2$117.099843489,40.5166516652",
    "9$115.64017296,40.00360036",
    "41$116.098278382,39.697569757",
    "712$116.239233896,39.8865886589",
    "50$116.262726482,40.2826282628",
    "70$116.286219067,40.1206120612",
    "331$116.368443117,40.1206120612",
    "3210$116.391935703,39.9135913591",
    "6548$116.427174582,39.904590459",
    "1$115.628426668,40.00360036",
    "42$116.039546917,39.7245724572",
    "348$116.239233896,40.0396039604",
    "36$116.344950532,40.2196219622",
    "2$116.485906046,39.6345634563",
    "1$116.662100439,40.7416741674",
    "13$116.744324489,39.6255625563",
    "22$116.157009846,40.1656165617",
    "160$116.262726482,40.300630063",
    "5$115.910337696,39.6795679568",
    "12$115.945576575,39.9675967597",
    "12$115.945576575,40.4806480648",
    "70$115.980815453,39.6435643564",
    "27$116.027800625,39.6075607561",
    "59$116.074785796,40.2286228623",
    "7$116.438920874,40.2556255626",
    "65$116.46241346,39.7875787579",
    "42$116.662100439,39.796579658",
    "363$116.826548539,40.3726372637",
    "20$116.920518881,39.7875787579",
    "2$117.029365732,40.4716471647",
    "6$117.064604611,40.1836183618",
    "71$115.992561746,39.6435643564",
    "13$116.074785796,40.4176417642",
    "1479$116.157009846,39.9315931593",
    "40$116.227487603,40.2556255626",
    "12$116.250980189,39.6345634563",
    "1117$116.274472775,40.102610261",
    "172$116.309711653,39.6255625563",
    "218$116.485906046,40.0846084608",
    "963$116.497652339,39.7875787579",
    "658$116.662100439,39.9135913591",
    "14$116.767817074,39.9495949595",
    "11$117.323023053,40.2736273627",
    "1$115.992561746,39.8145814581",
    "36$116.157009846,40.201620162",
    "3076$116.344950532,39.8685868587",
    "6155$116.344950532,39.8775877588",
    "3$116.391935703,39.499549955",
    "74$116.579876389,40.1206120612",
    "69$116.650354146,40.3456345635",
    "9$116.697339317,40.1746174617",
    "8$116.838294831,39.8235823582",
    "4$116.920518881,40.3816381638",
    "385$117.099843489,40.1476147615",
    "1$116.063039503,40.2376237624",
    "10$116.074785796,39.5895589559",
    "30$116.180502432,40.102610261",
    "31$116.450667167,40.2556255626",
    "3544$116.485906046,39.8685868587",
    "3$116.685593024,39.598559856",
    "4$116.744324489,39.8325832583",
    "1$115.80462106,39.5715571557",
    "40$116.13351726,40.2556255626",
    "16$116.239233896,40.300630063",
    "835$116.274472775,40.0846084608",
    "5166$116.344950532,39.9225922592",
    "5$116.391935703,39.6525652565",
    "913$116.485906046,39.8415841584",
    "2$116.509398632,39.6525652565",
    "957$116.568130096,40.0126012601",
    "18$116.673846732,39.796579658",
    "2$116.70908561,40.201620162",
    "18$116.838294831,40.5886588659",
    "16$116.086532089,40.2286228623",
    "14$116.203995017,39.7875787579",
    "16$116.509398632,39.6885688569",
    "20$116.673846732,40.3546354635",
    "19$116.744324489,40.1656165617",
    "2$115.628426668,39.7335733573",
    "94$115.72239701,39.598559856",
    "5$116.086532089,39.9225922592",
    "8$116.098278382,39.9225922592",
    "369$116.321457946,39.5625562556",
    "11$116.46241346,39.697569757",
    "3$117.170321246,40.2286228623",
    "118$116.239233896,40.2646264626",
    "181$116.262726482,40.2646264626",
    "2$116.579876389,40.2196219622",
    "10$116.697339317,39.9585958596",
    "5$116.885280003,39.7065706571",
    "4$117.170321246,40.1386138614",
    "9$116.039546917,39.8145814581",
    "62$116.086532089,39.6795679568",
    "187$116.180502432,40.0936093609",
    "146$116.239233896,39.9405940594",
    "42$116.29796536,39.7425742574",
    "2$116.415428289,39.5715571557",
    "24$116.497652339,40.1926192619",
    "13$116.756070781,40.3816381638",
    "2$116.885280003,40.1206120612",
    "16$116.908772589,40.1746174617",
    "6$116.098278382,39.7875787579",
    "335$116.309711653,40.1566156616",
    "15$116.38018941,40.1836183618",
    "961$116.568130096,40.0306030603",
    "21$116.579876389,40.399639964",
    "20$116.744324489,39.697569757",
    "22$116.744324489,40.1296129613",
    "11$116.744324489,40.3276327633",
    "2$115.757635889,39.8145814581",
    "1$116.227487603,40.5256525653",
    "5428$116.368443117,39.9945994599",
    "8$116.521144924,39.7335733573",
    "6$115.96906916,40.4266426643",
    "22$116.098278382,39.9765976598",
    "48$116.110024675,39.796579658",
    "8504$116.427174582,39.8505850585",
    "63$116.438920874,39.7425742574",
    "11$116.814802246,40.4806480648",
    "57$116.897026296,40.3906390639",
    "3$116.920518881,40.0576057606",
    "20$116.168756139,40.1656165617",
    "9$116.180502432,39.6705670567",
    "124$116.262726482,39.7515751575",
    "77$116.286219067,39.7695769577",
    "35$116.662100439,39.7605760576",
    "16$116.662100439,40.3906390639",
    "42$116.838294831,39.7605760576",
    "21$117.017619439,40.1746174617",
    "12$116.027800625,40.4356435644",
    "33$116.063039503,39.9135913591",
    "17$116.121770967,39.6435643564",
    "1$116.239233896,40.6606660666",
    "10435$116.438920874,39.9405940594",
    "8722$116.474159753,39.8775877588",
    "4$116.838294831,40.0666066607",
    "2$116.908772589,40.4626462646",
    "5622$116.29796536,39.9225922592",
    "5$116.673846732,40.1476147615",
    "1$116.697339317,40.7686768677",
    "9$116.732578196,39.8775877588",
    "20$116.779563367,40.1476147615",
    "2$117.146828661,40.6876687669",
    "3$117.323023053,40.6336633663",
    "31$116.027800625,39.6705670567",
    "3313$116.403681996,40.0486048605",
    "35$116.732578196,39.7065706571",
    "19$116.732578196,39.8865886589",
    "12$116.897026296,40.201620162",
    "7$115.88684511,40.498649865",
    "19$115.945576575,39.6525652565",
    "5$116.027800625,39.7335733573",
    "5$116.227487603,39.7155715572",
    "81$116.474159753,39.7155715572",
    "332$116.54463751,40.0216021602",
    "14$116.803055953,40.3906390639",
    "2$117.264291589,40.1746174617",
    "1$115.651919253,39.9675967597",
    "1$115.933830282,39.7425742574",
    "4$116.05129321,39.9315931593",
    "11$116.086532089,40.0936093609",
    "93$116.110024675,40.2286228623",
    "175$116.415428289,40.1566156616",
    "1$116.579876389,39.6345634563",
    "51$116.650354146,40.0846084608",
    "7$116.662100439,39.8055805581",
    "206$116.720831903,39.904590459",
    "1$116.779563367,39.9945994599",
    "2$116.826548539,40.0576057606",
    "27$116.826548539,40.498649865",
    "11$115.992561746,39.6165616562",
    "756$116.239233896,39.9135913591",
    "65$116.309711653,39.5265526553",
    "4$116.309711653,40.2466246625",
    "7$116.391935703,39.6615661566",
    "3$116.450667167,39.6435643564",
    "1944$116.521144924,39.9495949595",
    "45$116.826548539,40.3366336634",
    "30$116.29796536,39.6435643564",
    "7$116.450667167,40.4176417642",
    "7$116.579876389,40.3186318632",
    "2$116.720831903,39.6705670567",
    "33$116.779563367,39.8505850585",
    "50$116.920518881,40.201620162",
    "82$115.933830282,39.6615661566",
    "4609$116.309711653,39.9495949595",
    "28$116.333204239,39.499549955",
    "35$116.497652339,40.0486048605",
    "16$116.521144924,39.6165616562",
    "735$116.591622682,39.904590459",
    "5$116.767817074,39.7335733573",
    "1$116.227487603,40.3636363636",
    "2$116.286219067,39.5625562556",
    "7$116.403681996,39.5895589559",
    "2$116.427174582,40.3456345635",
    "1$116.920518881,40.4896489649",
    "1$116.979250346,40.4266426643",
    "2$117.017619439,40.4446444644",
    "24$115.980815453,39.6615661566",
    "40$116.016054332,40.4176417642",
    "239$116.157009846,40.2466246625",
    "10525$116.321457946,39.9855985599",
    "1$116.356696825,40.5796579658",
    "83$116.450667167,39.5535553555",
    "3$117.029365732,40.102610261",
    "612$117.111589782,40.1476147615",
    "5$115.875098818,40.498649865",
    "4$116.016054332,39.9945994599",
    "9$116.074785796,39.8775877588",
    "6$116.333204239,39.6255625563",
    "3385$116.356696825,40.0396039604",
    "221$116.568130096,39.8415841584",
    "12$116.814802246,40.3186318632",
    "1$117.111589782,40.3816381638",
    "28$116.180502432,40.1386138614",
    "161$116.21574131,40.300630063",
    "2525$116.250980189,39.9315931593",
    "195$116.29796536,40.1206120612",
    "77$116.427174582,40.1746174617",
    "2$116.497652339,39.5535553555",
    "20$116.650354146,39.6255625563",
    "4$115.875098818,40.3816381638",
    "628$116.321457946,39.8235823582",
    "15$116.344950532,39.5895589559",
    "780$116.391935703,39.8145814581",
    "39$116.532891217,40.1656165617",
    "26$116.603368974,40.0216021602",
    "34$116.673846732,39.7155715572",
    "2$117.052858318,40.102610261",
    "100$117.123336075,40.1296129613",
    "70$115.957322868,40.2826282628",
    "50$116.309711653,40.2106210621",
    "368$116.321457946,39.6255625563",
    "211$116.720831903,39.9585958596",
    "4$116.767817074,40.2466246625",
    "7$117.064604611,40.3546354635",
    "19$117.205560125,40.1386138614",
    "2$116.027800625,40.4626462646",
    "43$116.13351726,40.0846084608",
    "59$116.192248725,40.102610261",
    "8903$116.438920874,39.9675967597",
    "633$116.662100439,40.1116111611",
    "7$116.662100439,40.2286228623",
    "228$116.70908561,39.895589559",
    "19$116.814802246,39.7335733573",
    "1$117.146828661,40.696669667",
    "1$115.88684511,39.8235823582",
    "2$116.110024675,40.5706570657",
    "28$116.168756139,39.6795679568",
    "4205$116.438920874,40.0306030603",
    "54$116.615115267,39.7425742574",
    "459$116.356696825,39.8235823582",
    "2$116.427174582,40.3816381638",
    "77$116.532891217,40.2106210621",
    "2$116.70908561,40.3816381638",
    "1$116.779563367,39.6525652565",
    "3$117.017619439,40.3816381638",
    "4$117.193813832,40.696669667",
    "12$115.698904425,39.9765976598",
    "11$115.96906916,40.4086408641",
    "11$116.039546917,39.6615661566",
    "130$116.356696825,40.2106210621",
    "14$116.391935703,40.1656165617",
    "127$116.532891217,39.7785778578",
    "51$116.70908561,39.7335733573",
    "13$116.885280003,39.7425742574",
    "26$115.88684511,39.6615661566",
    "8$116.027800625,40.1926192619",
    "3251$116.286219067,39.904590459",
    "219$116.438920874,39.7335733573",
    "12$116.556383803,39.6165616562",
    "1$116.767817074,40.4806480648",
    "1$117.123336075,40.2826282628",
    "1$115.828113646,39.7695769577",
    "76$116.13351726,39.904590459",
    "128$116.333204239,39.5895589559",
    "54$116.638607853,39.9495949595",
    "145$116.180502432,40.1296129613",
    "3330$116.29796536,40.0396039604",
    "434$116.356696825,39.796579658",
    "868$116.38018941,40.0936093609",
    "9$116.427174582,39.6705670567",
    "29$116.556383803,40.0396039604",
    "42$116.556383803,40.1566156616",
    "15$115.96906916,39.6345634563",
    "53$116.427174582,40.2286228623",
    "23$117.064604611,40.1296129613",
    "1$115.96906916,40.0486048605",
    "1421$116.474159753,39.9585958596",
    "5$116.62686156,40.3636363636",
    "2$116.744324489,40.4536453645",
    "3$116.826548539,40.1206120612",
    "4791$116.274472775,39.9135913591",
    "1$116.286219067,39.499549955",
    "251$116.356696825,39.6615661566",
    "1$116.403681996,39.4725472547",
    "9$116.450667167,39.6615661566",
    "498$116.497652339,39.7695769577",
    "85$116.54463751,40.1296129613",
    "3$117.346515639,40.2106210621",
    "7$115.604934082,39.6345634563",
    "4$115.781128475,40.0216021602",
    "62$115.922083989,39.6075607561",
    "14$116.157009846,40.1476147615",
    "5586$116.438920874,40.0756075608",
    "22$116.615115267,40.1656165617",
    "34$116.720831903,40.0486048605",
    "8$116.756070781,39.9585958596",
    "2$116.814802246,40.0756075608",
    "4$116.814802246,40.5526552655",
    "244$116.38018941,39.7065706571",
    "3242$116.474159753,39.8415841584",
    "2$116.697339317,40.7776777678",
    "2$116.039546917,40.0666066607",
    "12$116.274472775,39.6075607561",
    "1$116.333204239,39.5715571557",
    "12$116.344950532,40.4086408641",
    "15$116.415428289,39.6435643564",
    "1$116.509398632,40.1116111611",
    "5$116.521144924,39.6255625563",
    "2$116.767817074,39.697569757",
    "5$116.063039503,39.904590459",
    "43$116.450667167,39.7335733573",
    "4$116.826548539,39.697569757",
    "6152$116.368443117,39.9855985599",
    "12$116.368443117,40.3906390639",
    "135$116.391935703,39.7605760576",
    "38$116.427174582,39.7605760576",
    "13$116.697339317,39.6255625563",
    "5$115.745889596,40.0396039604",
    "34$115.933830282,39.8145814581",
    "20$116.110024675,40.0306030603",
    "2$116.509398632,40.3726372637",
    "141$116.54463751,39.8415841584",
    "3$116.62686156,39.6705670567",
    "23$116.638607853,39.796579658",
    "286$116.685593024,40.4086408641",
    "15$116.826548539,40.201620162",
    "55$116.838294831,40.4716471647",
    "2$117.017619439,40.4536453645",
    "7$117.193813832,40.1656165617",
    "3$115.828113646,39.8145814581",
    "2788$116.192248725,39.9225922592",
    "135$116.262726482,39.8235823582",
    "4$116.62686156,40.0576057606",
    "31$116.662100439,39.7515751575",
    "30$116.779563367,39.6615661566",
    "4$116.814802246,40.3096309631",
    "3$115.604934082,39.6435643564",
    "19$116.004308039,39.598559856",
    "5$116.098278382,40.1926192619",
    "235$116.180502432,39.9675967597",
    "50$116.250980189,40.1746174617",
    "166$116.391935703,39.7875787579",
    "16$116.603368974,40.201620162",
    "7$116.638607853,39.6705670567",
    "13$116.673846732,40.0576057606",
    "1$116.767817074,39.9765976598",
    "15$115.863352525,39.5535553555",
    "198$116.309711653,39.8055805581",
    "40$116.415428289,39.6795679568",
    "1$116.579876389,40.2376237624",
    "33$116.615115267,39.9405940594",
    "14$116.662100439,39.6705670567",
    "5$116.744324489,40.2916291629",
    "4$116.767817074,39.7155715572",
    "12$116.767817074,40.1206120612",
    "4$116.861787417,39.7875787579",
    "9$117.358261932,40.201620162",
    "30$115.816367353,39.5625562556",
    "4$115.957322868,40.3906390639",
    "44$116.13351726,39.8505850585",
    "484$116.180502432,39.7695769577",
    "387$116.54463751,40.1116111611",
    "13$116.720831903,39.6795679568",
    "52$116.79130966,40.0936093609",
    "30$116.803055953,40.3546354635",
    "15$116.814802246,39.6795679568",
    "2$116.932265174,40.1206120612",
    "1$117.311276761,40.6606660666",
    "1$115.745889596,39.598559856",
    "20$116.391935703,40.0936093609",
    "25$116.403681996,40.3546354635",
    "35$116.485906046,39.7065706571",
    "21$116.509398632,40.1836183618",
    "2$116.521144924,39.6525652565",
    "6$115.839859939,39.8235823582",
    "6$115.875098818,40.4536453645",
    "1$116.027800625,40.2376237624",
    "155$116.262726482,39.8415841584",
    "4$116.262726482,40.2556255626",
    "2131$116.286219067,39.8865886589",
    "1809$116.321457946,39.6885688569",
    "1781$116.38018941,40.0846084608",
    "1908$116.403681996,39.8145814581",
    "232$116.497652339,40.1386138614",
    "507$116.532891217,40.0846084608",
    "35$116.556383803,40.1926192619",
    "93$116.615115267,40.1116111611",
    "9$116.779563367,40.1926192619",
    "270$116.861787417,40.3816381638",
    "7$116.990996639,40.0756075608",
    "97$115.898591403,39.5715571557",
    "3$115.910337696,39.9495949595",
    "228$116.438920874,39.7875787579",
    "7$116.438920874,40.201620162",
    "6$116.720831903,40.2646264626",
    "23$116.779563367,39.7245724572",
    "3$117.005873146,40.3456345635",
    "44$116.074785796,40.2826282628",
    "806$116.227487603,40.0756075608",
    "62$116.250980189,40.0216021602",
    "28$116.450667167,39.5625562556",
    "6443$116.46241346,40.00360036",
    "543$116.485906046,39.8145814581",
    "3$116.54463751,40.3456345635",
    "33$116.556383803,40.3636363636",
    "85$116.568130096,40.4356435644",
    "2$116.720831903,40.1386138614",
    "11$116.756070781,39.9765976598",
    "2$117.123336075,40.0936093609",
    "46$116.098278382,39.7155715572",
    "250$116.13351726,40.0936093609",
    "15$116.168756139,39.8235823582",
    "15$116.203995017,39.7425742574",
    "5403$116.38018941,39.9315931593",
    "137$116.650354146,40.3276327633",
    "1$116.662100439,40.6426642664",
    "1$117.170321246,40.5256525653",
    "1$116.13351726,40.6156615662",
    "137$116.239233896,39.9855985599",
    "5007$116.485906046,39.8865886589",
    "13$116.509398632,40.1926192619",
    "5$116.662100439,40.2826282628",
    "67$116.685593024,40.0306030603",
    "6509$116.38018941,39.9855985599",
    "280$116.591622682,39.7695769577",
    "52$116.697339317,40.0396039604",
    "4$116.744324489,39.9855985599",
    "71$116.756070781,40.0666066607",
    "41$116.779563367,40.3186318632",
    "2$116.098278382,39.5805580558",
    "1$116.121770967,40.4896489649",
    "1$116.403681996,40.5436543654",
    "564$116.509398632,39.8325832583",
    "25$116.532891217,40.1836183618",
    "453$116.568130096,39.8595859586",
    "10$116.87353371,40.0576057606",
    "1$115.710650718,39.7335733573",
    "1$115.933830282,40.201620162",
    "9$116.039546917,39.5715571557",
    "37$116.063039503,39.6255625563",
    "1$116.110024675,40.201620162",
    "956$116.509398632,39.9765976598",
    "8$116.509398632,40.2286228623",
    "19$116.756070781,40.2916291629",
    "22$116.803055953,40.1476147615",
    "15$117.052858318,40.1836183618",
    "1$116.110024675,40.4716471647",
    "1$116.274472775,39.5535553555",
    "35$116.274472775,39.6525652565",
    "331$116.509398632,39.7785778578",
    "525$116.54463751,39.7695769577",
    "8$116.744324489,40.102610261",
    "27$116.908772589,40.1566156616",
    "6$115.980815453,40.4176417642",
    "3$116.13351726,39.6885688569",
    "1874$116.227487603,39.8505850585",
    "3$116.239233896,40.0126012601",
    "2290$116.333204239,39.7605760576",
    "8561$116.391935703,39.9675967597",
    "235$116.650354146,40.0936093609",
    "3$116.732578196,40.4356435644",
    "19$117.158574954,40.5076507651",
    "5$116.239233896,39.6885688569",
    "49$116.427174582,39.7065706571",
    "17$116.474159753,40.2376237624",
    "99$116.497652339,39.7425742574",
    "12$116.897026296,40.4086408641",
    "8$116.344950532,39.5805580558",
    "2$116.46241346,40.7506750675",
    "52$116.556383803,40.4086408641",
    "3$116.004308039,40.4356435644",
    "3876$116.333204239,40.0666066607",
    "15$116.579876389,39.8415841584",
    "3$116.967504053,40.300630063",
    "15$117.005873146,40.1206120612",
    "1$117.205560125,40.5886588659",
    "332$115.980815453,40.4536453645",
    "83$116.650354146,40.0576057606",
    "10$116.87353371,40.1566156616",
    "1$115.72239701,39.7155715572",
    "20$116.039546917,39.6705670567",
    "8$116.180502432,39.6165616562",
    "276$116.203995017,39.8505850585",
    "14$116.239233896,39.598559856",
    "2035$116.54463751,39.904590459",
    "3$116.70908561,39.697569757",
    "6$117.064604611,40.0756075608",
    "2$117.264291589,40.6606660666",
    "42$115.593187789,39.6345634563",
    "2$116.05129321,40.5076507651",
    "98$116.262726482,40.2916291629",
    "2927$116.450667167,39.8595859586",
    "273$116.46241346,39.7245724572",
    "903$116.532891217,39.8055805581",
    "6$116.756070781,39.9135913591",
    "1$116.885280003,40.0936093609",
    "2$115.863352525,39.9405940594",
    "3$115.96906916,40.4806480648",
    "22$116.074785796,39.9765976598",
    "402$116.157009846,40.2556255626",
    "19$116.286219067,39.5085508551",
    "1$116.826548539,39.7245724572",
    "12$117.323023053,40.2556255626",
    "2$116.098278382,40.5256525653",
    "6191$116.309711653,40.0666066607",
    "25$116.356696825,39.6885688569",
    "12$116.579876389,40.1386138614",
    "64$116.756070781,40.1206120612",
    "2757$116.203995017,39.9945994599",
    "2$116.427174582,40.3096309631",
    "6$116.732578196,39.6705670567",
    "20$116.826548539,39.7065706571",
    "4$116.838294831,39.7245724572",
    "19$117.135082368,40.2826282628",
    "1$115.64017296,39.7245724572",
    "2$116.250980189,40.3096309631",
    "4361$116.333204239,39.8775877588",
    "784$116.497652339,40.0216021602",
    "26$117.334769346,40.2196219622",
    "18$116.803055953,40.0846084608",
    "8$117.017619439,40.1476147615",
    "9$116.027800625,39.7515751575",
    "363$116.098278382,39.9585958596",
    "27$116.110024675,40.102610261",
    "2$116.333204239,39.5175517552",
    "4279$116.485906046,39.9945994599",
    "58$116.814802246,40.3726372637",
    "19$116.87353371,40.201620162",
    "6$116.944011467,40.0576057606",
    "5$115.910337696,39.8145814581",
    "1$116.074785796,40.201620162",
    "24$116.391935703,40.1926192619",
    "162$116.497652339,40.1746174617",
    "11$116.826548539,39.7155715572",
    "14$117.017619439,40.1206120612",
    "55$115.88684511,39.5715571557",
    "16$116.427174582,39.6885688569",
    "1$116.438920874,40.7506750675",
    "19$116.615115267,39.6525652565",
    "102$116.673846732,40.0126012601",
    "16$116.885280003,40.3726372637",
    "4$116.932265174,39.7875787579",
    "9$116.95575776,40.399639964",
    "1$117.193813832,40.4536453645",
    "1$116.368443117,40.399639964",
    "1$116.474159753,40.4536453645",
    "1446$116.509398632,39.8415841584",
    "2$116.579876389,40.1566156616",
    "34$116.615115267,39.6615661566",
    "17$117.076350904,40.1206120612",
    "434$116.203995017,39.8865886589",
    "124$116.485906046,40.1386138614",
    "434$116.697339317,40.1296129613",
    "3$116.756070781,40.1566156616",
    "1$117.135082368,40.102610261",
    "7189$116.274472775,39.904590459",
    "10601$116.403681996,39.8505850585",
    "2$116.615115267,40.7236723672",
    "27$117.041112025,40.0846084608",
    "14$116.203995017,39.5895589559",
    "155$116.333204239,39.697569757",
    "2104$116.38018941,39.8325832583",
    "24$116.427174582,39.6615661566",
    "403$116.532891217,40.0936093609",
    "160$116.591622682,40.1296129613",
    "30$116.70908561,40.0306030603",
    "46$117.017619439,40.1836183618",
    "4$115.875098818,39.6705670567",
    "8$115.957322868,40.4536453645",
    "72$116.227487603,40.1476147615",
    "2$116.532891217,40.4716471647",
    "135$116.579876389,39.7155715572",
    "47$116.591622682,40.1386138614",
    "214$116.662100439,40.3636363636",
    "3$117.029365732,40.201620162",
    "4595$116.427174582,39.8865886589",
    "808$116.54463751,40.0306030603",
    "19$116.650354146,39.6885688569",
    "2$116.673846732,40.4446444644",
    "11$116.697339317,40.3186318632",
    "1$117.029365732,40.3636363636",
    "13$117.111589782,40.1926192619",
    "2$115.945576575,39.6165616562",
    "95$116.638607853,39.8235823582",
    "6$115.851606232,40.4716471647",
    "4$115.898591403,40.4266426643",
    "5$116.168756139,39.7875787579",
    "2$116.403681996,39.5085508551",
    "20$116.497652339,39.6795679568",
    "2$116.615115267,40.2556255626",
    "3$116.70908561,40.2646264626",
    "33$116.803055953,39.8775877588",
    "1$116.850041124,40.0846084608",
    "6$115.710650718,39.9765976598",
    "113$116.239233896,40.1476147615",
    "5$116.70908561,40.2916291629",
    "42$116.767817074,39.9945994599",
    "8$117.146828661,40.1206120612",
    "6$117.170321246,40.4266426643",
    "6$116.027800625,39.8685868587",
    "42$116.145263553,40.2286228623",
    "1$116.250980189,39.7875787579",
    "1$116.027800625,40.4896489649",
    "121$116.38018941,40.1476147615",
    "17$116.603368974,40.0936093609",
    "12$115.88684511,40.4176417642",
    "1$115.945576575,39.7605760576",
    "2$115.957322868,39.8055805581",
    "51$116.180502432,40.0126012601",
    "6127$116.321457946,40.0306030603",
    "69$116.344950532,40.1746174617",
    "118$116.391935703,39.7245724572",
    "2$117.135082368,40.0666066607",
    "12$115.816367353,39.5715571557",
    "3$115.863352525,39.7875787579",
    "35$115.933830282,39.6885688569",
    "54$116.039546917,39.8775877588",
    "415$116.13351726,40.2376237624",
    "2621$116.38018941,40.0126012601",
    "3051$116.485906046,39.9585958596",
    "15$116.556383803,40.1656165617",
    "69$116.697339317,39.9855985599",
    "4$116.814802246,39.6255625563",
    "1$117.123336075,40.3366336634",
    "4$117.229052711,40.1746174617",
    "1$115.534456325,39.7335733573",
    "66$115.933830282,39.6525652565",
    "17$115.96906916,40.4176417642",
    "10$116.039546917,39.7875787579",
    "17$116.086532089,40.1926192619",
    "1$116.110024675,40.3906390639",
    "1$116.227487603,40.4446444644",
    "7016$116.356696825,39.904590459",
    "1$116.427174582,40.2736273627",
    "4560$116.485906046,39.9675967597",
    "80$116.485906046,40.1566156616",
    "37$116.497652339,40.2376237624",
    "650$116.509398632,40.0306030603",
    "2202$116.532891217,39.9495949595",
    "7$116.603368974,40.3726372637",
    "21$116.673846732,39.9675967597",
    "1$115.581441496,39.9855985599",
    "1$116.098278382,39.6345634563",
    "2$116.157009846,39.6075607561",
    "1$116.274472775,40.6786678668",
    "4$116.286219067,39.6345634563",
    "1$116.286219067,40.3096309631",
    "26$116.333204239,40.1926192619",
    "132$116.344950532,39.7065706571",
    "3$116.356696825,39.6075607561",
    "2$116.756070781,39.6705670567",
    "3$116.990996639,40.2556255626",
    "1$115.88684511,39.8055805581",
    "2$115.945576575,40.4446444644",
    "24$116.168756139,39.6525652565",
    "162$116.192248725,39.8865886589",
    "25$116.203995017,40.0846084608",
    "5256$116.321457946,39.9945994599",
    "3$116.368443117,40.5436543654",
    "13$116.38018941,39.5535553555",
    "3$116.591622682,40.3276327633",
    "79$116.685593024,40.0396039604",
    "415$116.685593024,40.399639964",
    "1$115.698904425,39.5625562556",
    "5$115.957322868,40.399639964",
    "331$116.21574131,40.0936093609",
    "8857$116.427174582,39.8685868587",
    "2$116.521144924,39.7245724572",
    "3126$116.532891217,39.9585958596",
    "6$116.556383803,39.6345634563",
    "1$116.826548539,40.6246624662",
    "9$117.052858318,40.0936093609",
    "21$116.027800625,39.5895589559",
    "10$116.145263553,40.2646264626",
    "16210$116.356696825,39.9855985599",
    "7$116.46241346,39.7605760576",
    "2343$116.603368974,39.9135913591",
    "86$116.814802246,40.1656165617",
    "13$116.826548539,40.4446444644",
    "2$116.87353371,39.7065706571",
    "2$115.992561746,40.5076507651",
    "88$116.29796536,40.2646264626",
    "1766$116.438920874,39.8325832583",
    "142$116.615115267,39.7605760576",
    "1091$116.662100439,39.9225922592",
    "1$116.720831903,40.3456345635",
    "5$116.979250346,40.2736273627",
    "16$115.898591403,40.2196219622",
    "8$116.05129321,40.1206120612",
    "3$116.838294831,39.8325832583",
    "4$116.885280003,40.1476147615",
    "11$116.039546917,39.7425742574",
    "89$116.074785796,39.6165616562",
    "40$116.086532089,40.2826282628",
    "5153$116.321457946,39.9405940594",
    "2$116.368443117,39.6345634563",
    "65$116.591622682,39.8235823582",
    "92$116.603368974,40.1386138614",
    "9$116.861787417,40.201620162",
    "22$115.546202618,40.0306030603",
    "10339$116.427174582,39.9765976598",
    "33$116.521144924,40.0666066607",
    "245$116.591622682,39.6615661566",
    "7$116.79130966,40.3726372637",
    "12$116.861787417,39.6795679568",
    "4$115.88684511,39.8145814581",
    "12$115.957322868,39.6345634563",
    "12$116.110024675,40.0756075608",
    "16$116.13351726,39.9675967597",
    "138$116.145263553,40.1296129613",
    "124$116.227487603,39.7335733573",
    "9$116.286219067,39.5175517552",
    "1$116.521144924,39.6435643564",
    "2$116.897026296,39.8235823582",
    "4$117.002742931,40.2466246625",
    "17$117.217306418,40.1746174617",
    "26$115.757635889,40.0396039604",
    "18$116.05129321,39.9675967597",
    "2$116.086532089,40.3096309631",
    "45$116.286219067,39.7605760576",
    "1$116.897026296,40.1296129613",
    "1$117.002742931,40.1656165617",
    "3584$116.344950532,39.8325832583",
    "100$116.474159753,40.0486048605",
    "5$116.603368974,40.2376237624",
    "292$116.62686156,39.9225922592",
    "52$115.957322868,39.6795679568",
    "327$116.027800625,39.598559856",
    "1734$116.274472775,40.1206120612",
    "6501$116.450667167,39.8685868587",
    "5914$116.46241346,39.9585958596",
    "16$116.603368974,39.9765976598",
    "9$116.662100439,39.7245724572",
    "8$116.932265174,40.2196219622",
    "13$117.135082368,40.5256525653",
    "1$115.898591403,39.697569757",
    "11580$116.344950532,39.9495949595",
    "3241$116.368443117,40.102610261",
    "5$116.850041124,39.8595859586",
    "1$117.064604611,40.1566156616",
    "15$117.099843489,40.1656165617",
    "3$117.123336075,40.2106210621",
    "713$117.264291589,40.6426642664",
    "1$117.323023053,40.1566156616",
    "42$115.898591403,40.2376237624",
    "2961$116.368443117,40.0306030603",
    "110$116.415428289,39.7605760576",
    "101$117.017619439,40.0846084608",
    "751$116.157009846,39.8055805581",
    "273$116.180502432,39.7245724572",
    "3$116.180502432,40.4086408641",
    "151$116.227487603,40.2646264626",
    "255$116.321457946,40.1116111611",
    "12$116.497652339,39.6435643564",
    "2$116.732578196,39.6885688569",
    "5$116.027800625,40.0666066607",
    "76$116.145263553,39.8595859586",
    "2251$116.450667167,39.8505850585",
    "1842$116.497652339,39.8595859586",
    "10$116.591622682,39.7785778578",
    "55$116.62686156,39.8685868587",
    "1$116.016054332,40.4896489649",
    "1$116.262726482,40.4356435644",
    "216$116.286219067,39.7425742574",
    "9177$116.321457946,39.9585958596",
    "8566$116.356696825,39.9225922592",
    "34$116.532891217,40.4446444644",
    "21$116.838294831,40.4536453645",
    "47$116.744324489,39.9405940594",
    "8$116.944011467,39.7875787579",
    "3$117.193813832,40.1746174617",
    "16$116.121770967,39.7875787579",
    "137$116.203995017,39.8775877588",
    "517$116.21574131,39.7695769577",
    "6265$116.46241346,40.0126012601",
    "808$116.509398632,39.9495949595",
    "10$116.685593024,40.3816381638",
    "3$116.885280003,40.1836183618",
    "23$116.990996639,40.2646264626",
    "1$117.005873146,40.4266426643",
    "80$117.240799003,40.2376237624",
    "43$115.839859939,39.697569757",
    "9$116.192248725,39.598559856",
    "214$116.321457946,40.1656165617",
    "3$116.356696825,40.1476147615",
    "31$116.391935703,39.7155715572",
    "1817$116.403681996,40.1296129613",
    "7214$116.474159753,39.9225922592",
    "3$116.767817074,40.2916291629",
    "11$117.076350904,40.102610261",
    "2$115.828113646,39.6075607561",
    "15$115.898591403,39.6615661566",
    "2$116.13351726,40.5166516652",
    "561$116.556383803,40.0306030603",
    "614$116.579876389,39.796579658",
    "194$116.850041124,40.3906390639",
    "3$115.898591403,40.5076507651",
    "9$116.086532089,39.895589559",
    "400$116.239233896,40.1116111611",
    "78$116.309711653,39.697569757",
    "30$116.450667167,40.0486048605",
    "436$116.62686156,40.0216021602",
    "3$116.121770967,40.4626462646",
    "3$116.168756139,39.598559856",
    "91$116.203995017,39.9585958596",
    "1$116.21574131,40.498649865",
    "135$116.344950532,39.6705670567",
    "181$116.673846732,39.9225922592",
    "710$116.685593024,39.9225922592",
    "1$116.814802246,39.796579658",
    "5$115.72239701,39.9765976598",
    "108$116.356696825,39.7065706571",
    "200$116.427174582,40.1476147615",
    "831$116.485906046,39.9495949595",
    "890$116.532891217,39.8865886589",
    "1$116.579876389,39.6255625563",
    "38$116.615115267,40.0936093609",
    "3$116.685593024,40.2286228623",
    "5$116.744324489,40.0486048605",
    "8$115.957322868,39.6165616562",
    "58$115.980815453,39.6795679568",
    "7$115.980815453,39.9855985599",
    "66$115.980815453,40.3366336634",
    "84$116.356696825,39.6705670567",
    "28$116.368443117,40.1656165617",
    "7652$116.403681996,39.9945994599",
    "15$116.485906046,39.7335733573",
    "2$116.720831903,40.2826282628",
    "31$116.744324489,39.9225922592",
    "76$117.005873146,40.0576057606",
    "2$117.099843489,40.102610261",
    "3$115.522710032,39.6705670567",
    "32$116.157009846,39.6795679568",
    "16$116.227487603,40.2376237624",
    "66$116.309711653,40.1656165617",
    "2$116.38018941,39.6885688569",
    "1$116.427174582,40.8856885689",
    "17$116.744324489,40.1926192619",
    "10$116.814802246,39.8235823582",
    "523$116.239233896,40.0666066607",
    "48$116.368443117,39.6615661566",
    "1$116.920518881,40.0486048605",
    "107$117.111589782,40.1116111611",
    "3$117.299530468,40.6606660666",
    "696$116.321457946,39.7695769577",
    "3755$116.321457946,40.0846084608",
    "242$116.321457946,40.1206120612",
    "19$116.427174582,40.2196219622",
    "2$116.474159753,40.8316831683",
    "228$116.497652339,40.0576057606",
    "42$116.603368974,39.9675967597",
    "237$115.980815453,40.4716471647",
    "1$116.110024675,40.5616561656",
    "4$116.650354146,40.2466246625",
    "178$116.685593024,39.8595859586",
    "4$116.908772589,39.7695769577",
    "2$116.95575776,40.3726372637",
    "6$117.029365732,40.1476147615",
    "5$117.299530468,40.2196219622",
    "2$115.898591403,39.8055805581",
    "1$115.898591403,40.0666066607",
    "5$116.074785796,40.5886588659",
    "8513$116.344950532,40.0306030603",
    "4$116.415428289,39.6075607561",
    "28$116.650354146,39.7785778578",
    "14$116.732578196,39.9855985599",
    "38$116.87353371,39.8145814581",
    "13$115.851606232,39.6165616562",
    "10$115.863352525,39.6885688569",
    "1810$116.21574131,39.9945994599",
    "8$116.250980189,40.3546354635",
    "6$116.603368974,39.6705670567",
    "60$116.685593024,40.102610261",
    "2$116.13351726,40.00360036",
    "1$116.356696825,40.3546354635",
    "50$116.450667167,39.7785778578",
    "320$116.521144924,39.9585958596",
    "1$116.662100439,40.4806480648",
    "56$117.052858318,40.1656165617",
    "16$117.182067539,40.1476147615",
    "3$117.182067539,40.6066606661",
    "1$116.21574131,39.6255625563",
    "438$116.227487603,39.8685868587",
    "1012$116.309711653,39.7605760576",
    "14$116.38018941,40.1296129613",
    "3063$116.450667167,39.8325832583",
    "10$116.62686156,40.4086408641",
    "1$117.205560125,40.6516651665",
    "9$117.346515639,40.1836183618",
    "1$115.816367353,40.00360036",
    "45$115.945576575,39.7245724572",
    "1688$116.250980189,39.8775877588",
    "186$116.321457946,39.697569757",
    "10380$116.391935703,39.8595859586",
    "7$116.427174582,39.6255625563",
    "282$116.427174582,39.7335733573",
    "9$117.158574954,40.5796579658",
    "3$117.252545296,40.2916291629",
    "6$116.039546917,40.0486048605",
    "1$116.21574131,40.4356435644",
    "18$116.403681996,40.201620162",
    "1$116.403681996,40.2646264626",
    "7$116.732578196,40.0666066607",
    "26$116.192248725,40.1746174617",
    "195$116.29796536,39.7605760576",
    "33$116.427174582,39.6075607561",
    "6834$116.474159753,39.8865886589",
    "5$116.732578196,40.1656165617",
    "1$117.064604611,40.2646264626",
    "8$115.922083989,39.8145814581",
    "1$115.945576575,40.0936093609",
    "235$115.992561746,39.9405940594",
    "1$116.274472775,40.2826282628",
    "89$116.321457946,40.1746174617",
    "348$116.532891217,39.8235823582",
    "2848$116.321457946,39.7875787579",
    "26$116.450667167,39.7155715572",
    "1672$116.568130096,39.904590459",
    "1$116.744324489,39.7875787579",
    "5$116.861787417,40.399639964",
    "1$115.992561746,40.1566156616",
    "107$116.063039503,40.0756075608",
    "16$116.38018941,39.6435643564",
    "1$116.603368974,40.2826282628",
    "26$116.70908561,40.3096309631",
    "20$116.826548539,40.2376237624",
    "9$116.908772589,39.7425742574",
    "8$115.546202618,39.6525652565",
    "3$115.745889596,40.0846084608",
    "2$115.792874768,39.8865886589",
    "4$115.933830282,39.8235823582",
    "3$116.250980189,39.7605760576",
    "1610$116.333204239,39.8685868587",
    "184$116.368443117,40.0486048605",
    "8444$116.46241346,39.9135913591",
    "584$116.521144924,39.796579658",
    "911$116.521144924,39.8505850585",
    "203$116.556383803,40.0576057606",
    "197$116.673846732,40.00360036",
    "32$116.685593024,40.0936093609",
    "35$116.450667167,40.2106210621",
    "11$116.485906046,39.6075607561",
    "1$116.521144924,40.2466246625",
    "6$116.591622682,40.4356435644",
    "514$116.662100439,40.1206120612",
    "17$116.720831903,40.0756075608",
    "38$116.732578196,40.2106210621",
    "6$117.158574954,40.1746174617",
    "28$115.863352525,39.6345634563",
    "1867$116.403681996,39.8325832583",
    "50$116.568130096,40.2556255626",
    "75$116.638607853,40.2736273627",
    "76$116.673846732,40.2106210621",
    "21$116.932265174,40.1116111611",
    "12$117.005873146,40.1476147615",
    "9$116.05129321,40.2826282628",
    "12$116.074785796,39.7515751575",
    "354$116.239233896,40.2736273627",
    "5542$116.46241346,39.9765976598",
    "9$116.532891217,39.6615661566",
    "169$116.579876389,40.2646264626",
    "1$116.744324489,39.796579658",
    "5$116.767817074,39.9225922592",
    "2$117.334769346,40.2466246625",
    "73$116.086532089,40.3816381638",
    "164$116.203995017,40.0936093609",
    "18$116.438920874,39.5535553555",
    "706$116.521144924,39.9945994599",
    "401$116.532891217,39.8325832583",
    "8$116.79130966,40.1656165617",
    "4$116.861787417,40.1926192619",
    "38$117.123336075,40.5346534653",
    "1$115.522710032,39.7785778578",
    "2$115.72239701,39.9855985599",
    "16$116.027800625,39.9675967597",
    "172$116.192248725,39.7875787579",
    "5$116.521144924,39.6615661566",
    "69$116.720831903,39.895589559",
    "56$116.850041124,40.399639964",
    "12$117.076350904,40.2646264626",
    "7$117.088097196,40.1566156616",
    "6$117.205560125,40.2286228623",
    "1$116.145263553,40.5616561656",
    "1$116.944011467,40.2736273627",
    "6$117.029365732,40.0936093609",
    "1$117.099843489,40.0756075608",
    "2$117.276037882,40.6606660666",
    "36$116.321457946,40.1836183618",
    "36$116.450667167,39.6885688569",
    "3708$116.509398632,39.904590459",
    "26$116.54463751,39.6885688569",
    "47$116.579876389,40.0756075608",
    "27$116.62686156,39.8235823582",
    "1$116.744324489,39.6435643564",
    "94$116.79130966,39.7695769577",
    "2$116.908772589,39.8325832583",
    "1$115.933830282,39.9585958596",
    "7$116.027800625,39.6885688569",
    "76$116.05129321,39.9765976598",
    "12$116.838294831,39.7785778578",
    "23$116.861787417,40.1746174617",
    "24$116.990996639,40.2736273627",
    "4$115.910337696,40.4536453645",
    "1$115.957322868,39.8505850585",
    "4$116.180502432,40.4896489649",
    "4595$116.438920874,39.9765976598",
    "8175$116.450667167,39.9315931593",
    "4606$116.46241346,39.8595859586",
    "546$116.532891217,39.7695769577",
    "312$116.697339317,39.8505850585",
    "13$116.732578196,39.7155715572",
    "5$115.757635889,39.6165616562",
    "1$116.274472775,39.499549955",
    "3517$116.344950532,39.8415841584",
    "324$116.568130096,39.895589559",
    "33$116.756070781,40.1746174617",
    "4$116.87353371,40.0756075608",
    "10$116.897026296,40.2106210621",
    "16$117.135082368,40.5166516652",
    "7$117.334769346,40.1926192619",
    "3$116.203995017,40.5256525653",
    "22$116.46241346,39.7065706571",
    "1612$116.497652339,39.8235823582",
    "24$116.615115267,40.3726372637",
    "23$116.838294831,40.597659766",
    "303$117.111589782,40.1566156616",
    "42$116.039546917,39.7785778578",
    "4$116.063039503,40.5076507651",
    "1$116.13351726,39.9945994599",
    "360$116.192248725,40.2286228623",
    "3$116.591622682,40.1566156616",
    "35$116.673846732,39.9945994599",
    "4$115.945576575,40.2196219622",
    "1$115.992561746,40.5166516652",
    "130$116.13351726,39.8595859586",
    "13659$116.309711653,39.9765976598",
    "9307$116.46241346,39.9315931593",
    "2$116.70908561,39.8235823582",
    "3$116.803055953,39.7245724572",
    "6$116.897026296,39.6885688569",
    "1$116.979250346,40.2556255626",
    "4$116.838294831,40.2466246625",
    "225$116.861787417,40.3906390639",
    "16$117.111589782,40.1746174617",
    "259$116.203995017,40.0126012601",
    "362$116.556383803,40.00360036",
    "57$116.685593024,39.8415841584",
    "254$116.838294831,40.3546354635",
    "2$117.002742931,40.4626462646",
    "5$116.227487603,40.300630063",
    "8925$116.485906046,39.9855985599",
    "136$117.111589782,40.1296129613",
    "1$115.933830282,39.7245724572",
    "4$115.980815453,40.0486048605",
    "114$116.157009846,40.1836183618",
    "18$116.368443117,39.5265526553",
    "4$116.603368974,39.796579658",
    "9$116.932265174,40.1656165617",
    "7$117.052858318,40.2106210621",
    "4$116.438920874,40.4356435644",
    "18$116.62686156,40.2916291629",
    "170$116.673846732,39.9495949595",
    "1$117.111589782,40.6426642664",
    "590$116.168756139,39.8055805581",
    "1$116.203995017,40.3186318632",
    "4$116.474159753,40.4176417642",
    "40$116.920518881,40.5076507651",
    "16$116.086532089,39.697569757",
    "1$116.121770967,40.5616561656",
    "17$116.29796536,39.6165616562",
    "7705$116.344950532,40.0396039604",
    "199$116.54463751,39.8055805581",
    "5$116.568130096,40.1656165617",
    "1$116.697339317,40.399639964",
    "8$116.803055953,40.2736273627",
    "10$117.052858318,40.0846084608",
    "6$115.757635889,39.5265526553",
    "12$116.13351726,39.6705670567",
    "9$116.250980189,39.5895589559",
    "25$116.38018941,40.399639964",
    "304$116.603368974,39.9945994599",
    "112$116.638607853,39.8415841584",
    "4$116.897026296,40.4716471647",
    "9$116.908772589,39.8235823582",
    "17$115.922083989,40.2466246625",
    "4$116.05129321,40.201620162",
    "24$116.344950532,40.1566156616",
    "3$116.415428289,39.5535553555",
    "21$116.474159753,40.1926192619",
    "2$117.002742931,40.0396039604",
    "4$117.182067539,40.2196219622",
    "1$115.980815453,39.8685868587",
    "71$116.262726482,40.1836183618",
    "10$116.521144924,40.3276327633",
    "4285$116.54463751,39.9405940594",
    "1$116.673846732,40.8856885689",
    "3$116.756070781,40.4446444644",
    "29$117.123336075,40.2286228623",
    "17$117.193813832,40.1386138614",
    "315$116.54463751,39.7335733573",
    "5$116.591622682,39.7155715572",
    "21$116.615115267,39.7695769577",
    "107$117.252545296,40.6336633663",
    "2$115.898591403,39.8145814581",
    "8$116.145263553,39.6615661566",
    "3221$116.333204239,39.7875787579",
    "213$116.485906046,40.0396039604",
    "6$116.532891217,40.201620162",
    "1$116.685593024,40.1566156616",
    "220$116.70908561,39.9135913591",
    "2$116.814802246,40.6156615662",
    "79$115.980815453,40.3636363636",
    "15$116.05129321,39.6705670567",
    "3$116.110024675,40.4626462646",
    "61$116.145263553,39.697569757",
    "2$116.21574131,39.6795679568",
    "94$116.556383803,39.9765976598",
    "3$116.673846732,40.7596759676",
    "3$115.816367353,39.6705670567",
    "6$116.638607853,40.3726372637",
    "15$116.814802246,40.2106210621",
    "5$116.826548539,39.6255625563",
    "1$116.95575776,40.3276327633",
    "4$116.967504053,40.3906390639",
    "245$116.121770967,40.0846084608",
    "2$116.262726482,39.6525652565",
    "7$116.321457946,40.3726372637",
    "4445$116.391935703,40.0126012601",
    "57$116.556383803,40.0486048605",
    "38$116.756070781,40.0306030603",
    "22$116.838294831,40.0576057606",
    "20$116.861787417,40.3546354635",
    "1$116.87353371,40.0666066607",
    "13$116.05129321,39.8055805581",
    "43$116.098278382,39.7425742574",
    "118$116.250980189,40.1386138614",
    "833$116.262726482,40.2196219622",
    "7118$116.29796536,39.9135913591",
    "1$116.532891217,39.6435643564",
    "1$116.568130096,40.7146714671",
    "64$116.79130966,40.3546354635",
    "15$115.910337696,40.2466246625",
    "1$116.145263553,39.6345634563",
    "18$116.157009846,40.3276327633",
    "6$116.250980189,39.8145814581",
    "105$116.309711653,39.5175517552",
    "269$116.321457946,39.7245724572",
    "1170$116.333204239,39.8055805581",
    "454$116.450667167,39.7605760576",
    "1$116.62686156,40.903690369",
    "2$116.685593024,40.2376237624",
    "26$116.70908561,40.1476147615",
    "3$115.980815453,39.7605760576",
    "344$116.368443117,39.7515751575",
    "8514$116.403681996,40.00360036",
    "685$116.474159753,39.8055805581",
    "19$116.591622682,40.300630063",
    "7$116.638607853,39.6165616562",
    "13$116.814802246,40.1296129613",
    "57$116.850041124,40.4086408641",
    "26$115.828113646,39.6615661566",
    "3$115.980815453,40.5166516652",
    "8182$116.321457946,40.0756075608",
    "7$117.135082368,40.3366336634",
    "29$117.240799003,40.6606660666",
    "558$116.110024675,39.9585958596",
    "660$116.250980189,40.00360036",
    "44$116.568130096,39.6885688569",
    "42$116.826548539,40.1656165617",
    "80$116.838294831,40.399639964",
    "17$117.135082368,40.1296129613",
    "6$115.769382182,39.5355535554",
    "1$116.063039503,39.7515751575",
    "2583$116.286219067,39.9135913591",
    "26$116.767817074,40.3366336634",
    "9$116.779563367,40.6336633663",
    "1$115.604934082,39.6795679568",
    "20$116.086532089,39.7335733573",
    "12$116.203995017,40.0216021602",
    "2$116.227487603,39.6255625563",
    "2784$116.415428289,39.8775877588",
    "3640$116.427174582,40.0486048605",
    "1$116.556383803,40.7146714671",
    "3$117.123336075,40.6066606661",
    "6883$116.38018941,39.8415841584",
    "3$116.662100439,40.498649865",
    "34$116.87353371,40.4716471647",
    "2$115.922083989,39.6165616562",
    "7$116.70908561,39.9945994599",
    "44$116.803055953,39.8145814581",
    "102$116.885280003,39.8145814581",
    "16$116.274472775,39.6795679568",
    "5198$116.391935703,39.9765976598",
    "6$116.62686156,39.6255625563",
    "11$116.650354146,40.1566156616",
    "7$116.697339317,40.0576057606",
    "1$116.720831903,40.4536453645",
    "19$116.756070781,39.6795679568",
    "315$116.38018941,40.1746174617",
    "7$116.744324489,40.00360036",
    "24$116.79130966,40.0666066607",
    "10$116.990996639,40.1656165617",
    "8$116.13351726,39.8325832583",
    "4697$116.286219067,39.8595859586",
    "983$116.427174582,39.796579658",
    "2$116.861787417,40.3366336634",
    "9$116.203995017,39.7245724572",
    "99$116.485906046,40.1746174617",
    "3$116.814802246,40.3276327633",
    "4$117.205560125,40.1476147615",
    "1$116.145263553,39.6255625563",
    "1976$116.250980189,39.8865886589",
    "247$116.368443117,39.7785778578",
    "6560$116.474159753,39.9855985599",
    "1695$116.521144924,39.8595859586",
    "6$116.568130096,39.7065706571",
    "4$116.591622682,40.2376237624",
    "17$116.732578196,39.6255625563",
    "3$116.826548539,40.4896489649",
    "21$116.063039503,39.6795679568",
    "34$116.086532089,39.8685868587",
    "16$116.227487603,39.7065706571",
    "47$116.29796536,40.3456345635",
    "1681$116.391935703,40.102610261",
    "60$116.46241346,39.7335733573",
    "195$116.532891217,39.9765976598",
    "141$116.70908561,39.8775877588",
    "105$116.29796536,39.6705670567",
    "2$116.415428289,39.5895589559",
    "1$116.662100439,40.2556255626",
    "2$116.720831903,39.7065706571",
    "1$116.920518881,40.4806480648",
    "1$115.546202618,39.6345634563",
    "26$115.922083989,39.7425742574",
    "696$116.145263553,39.7425742574",
    "200$116.145263553,39.8145814581",
    "113$116.180502432,39.8505850585",
    "63$116.250980189,40.2646264626",
    "9$116.427174582,39.598559856",
    "1941$116.497652339,39.8055805581",
    "7$116.556383803,40.2916291629",
    "2$117.029365732,40.2646264626",
    "20$115.898591403,40.2106210621",
    "2$115.992561746,40.00360036",
    "3$116.004308039,39.7335733573",
    "1256$116.098278382,39.9405940594",
    "78$116.121770967,40.2556255626",
    "1$116.885280003,40.2196219622",
    "11$116.990996639,40.1476147615",
    "14$115.980815453,39.6705670567",
    "2$115.980815453,40.00360036",
    "39$116.274472775,39.5625562556",
    "247$116.356696825,39.7785778578",
    "40$116.356696825,40.2286228623",
    "2$116.356696825,40.7056705671",
    "4$116.438920874,39.6435643564",
    "93$116.474159753,40.102610261",
    "98$116.568130096,39.7605760576",
    "297$116.673846732,40.1206120612",
    "7$116.685593024,40.3186318632",
    "283$116.21574131,39.8505850585",
    "1$116.21574131,40.3366336634",
    "1$116.391935703,39.4635463546",
    "234$116.615115267,40.1296129613",
    "11$116.62686156,40.0666066607",
    "2$116.697339317,40.2466246625",
    "3$116.967504053,40.3726372637",
    "86$117.088097196,40.5166516652",
    "3$117.135082368,40.6066606661",
    "44$117.158574954,40.3276327633",
    "6$116.027800625,39.6615661566",
    "27$116.063039503,39.6075607561",
    "12653$116.415428289,39.895589559",
    "158$116.603368974,40.1476147615",
    "45$116.62686156,39.7605760576",
    "137$116.697339317,39.7605760576",
    "9$116.826548539,40.1116111611",
    "5$115.980815453,39.7425742574",
    "17$116.145263553,40.3366336634",
    "20$116.157009846,39.6435643564",
    "6094$116.391935703,39.8415841584",
    "7255$116.415428289,39.8415841584",
    "11$116.415428289,40.4086408641",
    "5622$116.438920874,39.9495949595",
    "328$116.485906046,39.5535553555",
    "1$116.004308039,39.9315931593",
    "1$116.05129321,40.5886588659",
    "259$116.063039503,39.598559856",
    "225$116.121770967,39.8505850585",
    "7$116.121770967,40.5166516652",
    "38$116.168756139,39.904590459",
    "12$116.180502432,40.1116111611",
    "1422$116.250980189,39.9495949595",
    "11$116.286219067,39.6615661566",
    "4$116.450667167,40.3546354635",
    "12$116.767817074,39.7605760576",
    "1$116.967504053,40.4446444644",
    "16$117.170321246,40.6876687669",
    "54$115.898591403,39.5805580558",
    "483$115.992561746,40.3636363636",
    "16$116.004308039,40.3096309631",
    "788$116.521144924,39.8685868587",
    "4$116.697339317,39.697569757",
    "56$116.697339317,40.1206120612",
    "3$117.158574954,40.1296129613",
    "400$116.203995017,39.7695769577",
    "5$116.333204239,40.4086408641",
    "5580$116.427174582,40.0756075608",
    "2$117.005873146,40.4446444644",
    "3$117.146828661,40.5256525653",
    "2$115.957322868,40.5166516652",
    "35$116.098278382,40.2376237624",
    "5$116.403681996,39.7785778578",
    "256$116.415428289,40.1836183618",
    "69$116.521144924,40.1116111611",
    "435$116.62686156,40.1296129613",
    "1$116.87353371,40.1206120612",
    "420$116.485906046,39.8235823582",
    "4$116.603368974,39.7065706571",
    "1$116.779563367,39.8685868587",
    "2$116.803055953,40.2826282628",
    "1$115.72239701,40.102610261",
    "4$115.745889596,39.5535553555",
    "3$116.004308039,39.6885688569",
    "1$116.004308039,40.0126012601",
    "2501$116.262726482,39.8595859586",
    "1099$116.344950532,39.8145814581",
    "4772$116.415428289,39.9315931593",
    "2666$116.415428289,40.1206120612",
    "984$116.685593024,39.8685868587",
    "11$116.697339317,40.4536453645",
    "19$116.803055953,39.8595859586",
    "23$117.182067539,40.1206120612",
    "202$116.063039503,39.6705670567",
    "601$116.427174582,40.1206120612",
    "14$116.685593024,40.0486048605",
    "3$116.79130966,40.0846084608",
    "2$116.814802246,40.6516651665",
    "2$117.088097196,40.300630063",
    "4$117.170321246,40.2466246625",
    "1$115.910337696,40.4266426643",
    "33$116.274472775,40.2286228623",
    "7284$116.368443117,39.895589559",
    "1$116.521144924,40.201620162",
    "227$116.54463751,40.1206120612",
    "5$116.62686156,39.6165616562",
    "5$116.744324489,40.0576057606",
    "1$116.767817074,40.6246624662",
    "6$115.72239701,39.5805580558",
    "18$115.80462106,39.5895589559",
    "1$115.957322868,40.00360036",
    "8$116.098278382,40.4626462646",
    "1024$116.262726482,40.0216021602",
    "2$116.391935703,40.696669667",
    "2$116.650354146,40.7416741674",
    "3$116.767817074,40.4626462646",
    "1$116.79130966,40.2916291629",
    "44$116.192248725,40.201620162",
    "1558$116.239233896,39.9585958596",
    "78$116.485906046,39.7695769577",
    "4$116.532891217,40.3276327633",
    "23$116.79130966,39.6165616562",
    "7$116.814802246,40.4446444644",
    "3$116.826548539,40.1836183618",
    "10$116.897026296,40.0576057606",
    "748$116.474159753,39.796579658",
    "4$116.779563367,40.2106210621",
    "17$116.79130966,40.0306030603",
    "49$116.861787417,40.3636363636",
    "797$116.274472775,39.8325832583",
    "72$116.62686156,39.6615661566",
    "216$116.673846732,39.8685868587",
    "5$116.932265174,40.3816381638",
    "8054$116.333204239,39.895589559",
    "25$116.391935703,39.6165616562",
    "4839$116.438920874,39.8505850585",
    "221$116.474159753,40.0936093609",
    "1760$116.650354146,39.895589559",
    "3$116.673846732,40.597659766",
    "11$116.732578196,39.8685868587",
    "9$116.861787417,40.1656165617",
    "1$117.334769346,40.6426642664",
    "10$116.157009846,40.1566156616",
    "34$116.239233896,39.6525652565",
    "15$116.46241346,39.6165616562",
    "2$116.70908561,39.7605760576",
    "6$117.005873146,40.1926192619",
    "2$116.086532089,40.5616561656",
    "8$116.110024675,40.4356435644",
    "7$116.227487603,39.8055805581",
    "8$116.344950532,40.1476147615",
    "45$116.485906046,39.697569757",
    "671$116.591622682,39.895589559",
    "351$116.591622682,40.0666066607",
    "53$116.662100439,39.8415841584",
    "62$116.673846732,40.1746174617",
    "392$116.415428289,39.8235823582",
    "9$116.673846732,39.8145814581",
    "21$116.673846732,40.201620162",
    "1$116.756070781,39.6525652565",
    "3$117.323023053,40.1926192619",
    "13$117.323023053,40.2646264626",
    "3$116.039546917,40.5256525653",
    "4$116.05129321,40.1836183618",
    "134$116.180502432,39.8235823582",
    "134$116.250980189,40.300630063",
    "11561$116.415428289,40.0576057606",
    "3$116.474159753,40.1476147615",
    "60$116.556383803,40.2826282628",
    "24$116.70908561,40.0936093609",
    "3$116.779563367,40.2826282628",
    "8$115.96906916,40.4356435644",
    "2431$116.321457946,39.9135913591",
    "1$115.96906916,40.5076507651",
    "32$116.227487603,39.697569757",
    "88$116.239233896,40.2556255626",
    "9135$116.356696825,39.9945994599",
    "9$116.568130096,40.2196219622",
    "310$116.591622682,39.8505850585",
    "32$116.638607853,39.697569757",
    "8$116.756070781,40.6336633663",
    "16$116.814802246,40.0486048605",
    "5$116.027800625,40.1566156616",
    "14$116.027800625,40.4806480648",
    "3$116.227487603,40.1566156616",
    "1$116.262726482,39.598559856",
    "9532$116.309711653,39.9315931593",
    "9594$116.38018941,39.9675967597",
    "239$116.415428289,40.1476147615",
    "43$116.70908561,39.8145814581",
    "5$116.767817074,40.1566156616",
    "4$116.767817074,40.2286228623",
    "2$117.182067539,40.4896489649",
    "7$115.957322868,39.6435643564",
    "14$116.110024675,40.3636363636",
    "14$116.239233896,40.0216021602",
    "7$116.615115267,39.6345634563",
    "55$116.697339317,39.7335733573",
    "20$116.70908561,39.9765976598",
    "20$116.756070781,40.0396039604",
    "24$116.767817074,40.1926192619",
    "5$116.838294831,40.2556255626",
    "3$117.002742931,40.0666066607",
    "6$115.88684511,39.6525652565",
    "5$115.945576575,39.8145814581",
    "8$116.063039503,39.5805580558",
    "227$116.474159753,39.7785778578",
    "3729$116.497652339,39.904590459",
    "47$116.521144924,40.1386138614",
    "328$116.568130096,40.0576057606",
    "65$116.638607853,40.1746174617",
    "1$116.756070781,39.7875787579",
    "1$117.099843489,40.1836183618",
    "1259$116.227487603,40.2106210621",
    "110$116.779563367,39.8145814581",
    "385$116.250980189,40.0936093609",
    "81$116.321457946,39.4905490549",
    "4$116.532891217,40.2916291629",
    "26$116.568130096,40.1476147615",
    "9$116.615115267,39.6435643564",
    "35$116.756070781,39.7155715572",
    "10$116.779563367,40.0396039604",
    "18$116.779563367,40.1566156616",
    "7$116.803055953,40.2466246625",
    "16$116.838294831,40.201620162",
    "46$115.980815453,39.7245724572",
    "14$116.016054332,39.7785778578",
    "8$116.157009846,39.6255625563",
    "253$116.532891217,39.796579658",
    "6$116.615115267,39.6705670567",
    "43$116.638607853,39.7425742574",
    "3$116.885280003,40.1116111611",
    "3$117.146828661,40.1746174617",
    "25$116.027800625,39.9585958596",
    "7$116.697339317,39.7065706571",
    "1$116.767817074,39.7875787579",
    "5$117.205560125,40.1206120612",
    "38$115.922083989,39.6255625563",
    "71$116.098278382,39.904590459",
    "264$116.21574131,40.1296129613",
    "11$116.239233896,39.5895589559",
    "4$116.46241346,39.598559856",
    "429$116.29796536,39.7875787579",
    "25$116.579876389,39.6525652565",
    "27$116.063039503,39.9765976598",
    "4$116.262726482,40.399639964",
    "5506$116.274472775,40.0306030603",
    "5746$116.38018941,39.9945994599",
    "15$115.992561746,40.4176417642",
    "8$116.074785796,39.9135913591",
    "2790$116.286219067,39.8775877588",
    "3$116.591622682,40.3456345635",
    "5$117.099843489,40.5256525653",
    "1$115.96906916,39.9495949595",
    "41$116.063039503,40.1746174617",
    "4$116.556383803,40.7236723672",
    "74$116.662100439,40.4086408641",
    "14$116.70908561,40.3186318632",
    "10$116.732578196,39.7335733573",
    "5$116.87353371,39.7425742574",
    "8$117.088097196,40.1296129613",
    "1$116.039546917,39.8595859586",
    "14$116.098278382,39.796579658",
    "6$116.250980189,39.7155715572",
    "8$116.697339317,40.3366336634",
    "121$116.110024675,40.0576057606",
    "21$116.509398632,40.2646264626",
    "29$116.697339317,39.8325832583",
    "31$116.79130966,39.7515751575",
    "2$117.005873146,40.5796579658",
    "9$117.276037882,40.1836183618",
    "97$116.086532089,40.0666066607",
    "30$116.121770967,39.8055805581",
    "9$116.250980189,39.6615661566",
    "99$116.391935703,39.7065706571",
    "901$116.509398632,40.0216021602",
    "1$116.638607853,39.7155715572",
    "268$116.662100439,40.0936093609",
    "29$116.885280003,39.7785778578",
    "4$115.922083989,40.5166516652",
    "54$116.074785796,39.6795679568",
    "379$116.168756139,40.0666066607",
    "2$116.192248725,39.6255625563",
    "1$116.203995017,40.3276327633",
    "2030$116.403681996,40.0216021602",
    "9$117.299530468,40.1746174617",
    "51$116.086532089,39.598559856",
    "331$116.145263553,39.7155715572",
    "241$116.21574131,39.8055805581",
    "1070$116.274472775,39.8505850585",
    "39$116.38018941,40.3636363636",
    "6$117.005873146,40.2376237624",
    "15$117.158574954,40.2376237624",
    "102$115.945576575,39.6615661566",
    "366$116.192248725,39.8415841584",
    "281$116.274472775,39.8595859586",
    "5680$116.333204239,39.9585958596",
    "54$116.650354146,39.8595859586",
    "4$116.920518881,40.4536453645",
    "13$116.227487603,40.1746174617",
    "14$116.415428289,40.2376237624",
    "33$116.685593024,40.3636363636",
    "6$116.826548539,40.2826282628",
    "3$116.838294831,40.6336633663",
    "396$116.145263553,40.1116111611",
    "6$116.62686156,40.1836183618",
    "1307$116.638607853,39.9135913591",
    "130$116.016054332,40.3636363636",
    "1$116.157009846,40.5526552655",
    "43$116.286219067,39.7155715572",
    "566$116.321457946,40.102610261",
    "346$116.450667167,40.1206120612",
    "32$116.46241346,39.7425742574",
    "180$116.591622682,40.1206120612",
    "22$116.720831903,40.2736273627",
    "19$116.744324489,39.9585958596",
    "11$116.039546917,39.8685868587",
    "4641$116.391935703,39.8685868587",
    "60$116.403681996,40.2286228623",
    "41$116.685593024,39.7515751575",
    "20$116.779563367,39.7785778578",
    "110$116.615115267,39.8505850585",
    "4$116.850041124,40.2466246625",
    "10$116.944011467,40.0846084608",
    "115$116.38018941,39.7875787579",
    "3$116.861787417,39.7245724572",
    "16$117.146828661,40.1656165617",
    "1$115.945576575,40.3366336634",
    "1$116.063039503,40.4626462646",
    "110$116.321457946,39.6435643564",
    "27$117.064604611,40.0846084608",
    "1$117.311276761,40.1836183618",
    "48$115.72239701,39.5535553555",
    "1$116.13351726,39.8685868587",
    "12$116.168756139,40.5166516652",
    "1$116.344950532,39.598559856",
    "21$116.485906046,39.7425742574",
    "95$116.521144924,40.2106210621",
    "7$116.650354146,40.3636363636",
    "7$115.96906916,40.4896489649",
    "420$116.098278382,39.9495949595",
    "14$116.192248725,40.0846084608",
    "15$116.62686156,40.7326732673",
    "16$116.861787417,40.0576057606",
    "2$117.135082368,40.6876687669",
    "9$116.016054332,39.7515751575",
    "1425$116.333204239,39.7695769577",
    "29$116.46241346,39.6615661566",
    "7$116.521144924,40.1656165617",
    "40$116.521144924,40.2286228623",
    "1$116.673846732,40.9216921692",
    "7$116.87353371,39.7785778578",
    "1$115.922083989,40.3906390639",
    "3$116.145263553,39.6165616562",
    "57$116.227487603,40.1296129613",
    "4$116.391935703,39.7335733573",
    "15$116.532891217,39.598559856",
    "40$116.591622682,39.9675967597",
    "1249$116.685593024,39.8775877588",
    "71$116.697339317,40.2916291629",
    "2$117.064604611,40.3456345635",
    "2$115.581441496,39.697569757",
    "1$115.88684511,40.5436543654",
    "9$115.933830282,39.9405940594",
    "5$116.074785796,39.8685868587",
    "6$116.21574131,40.5256525653",
    "4$116.274472775,39.7335733573",
    "4354$116.591622682,39.9135913591",
    "17$116.62686156,40.00360036",
    "2$116.732578196,40.2376237624",
    "10$116.850041124,40.4626462646",
    "5$117.146828661,40.1476147615",
    "3$115.616680375,39.6435643564",
    "258$116.074785796,40.0666066607",
    "2$116.286219067,40.2916291629",
    "1535$116.509398632,40.0126012601",
    "23$116.615115267,40.3456345635",
    "130$116.403681996,39.7515751575",
    "57$116.591622682,39.7605760576",
    "38$116.697339317,40.00360036",
    "1$117.002742931,40.1386138614",
    "4$116.063039503,39.6165616562",
    "143$116.110024675,40.00360036",
    "3995$116.321457946,40.0396039604",
    "5318$116.509398632,39.9315931593",
    "3$116.732578196,40.0216021602",
    "2$116.87353371,40.5076507651",
    "1$115.910337696,39.7605760576",
    "1514$116.262726482,40.0306030603",
    "161$116.685593024,40.1206120612",
    "619$116.180502432,40.0486048605",
    "203$116.250980189,40.1566156616",
    "21$116.861787417,40.1566156616",
    "17$116.016054332,40.5346534653",
    "1$116.110024675,40.2826282628",
    "1592$116.29796536,40.0216021602",
    "3$116.556383803,39.6615661566",
    "707$116.685593024,39.9405940594",
    "2$116.990996639,40.0486048605",
    "3409$116.309711653,39.8775877588",
    "88$116.603368974,39.8595859586",
    "8$116.826548539,39.8235823582",
    "4$116.979250346,40.4086408641",
    "16$116.227487603,39.796579658",
    "12$116.29796536,40.1926192619",
    "15$116.309711653,39.5805580558",
    "88$116.368443117,39.7155715572",
    "1$115.663665546,39.9675967597",
    "10$116.039546917,40.1836183618",
    "28$117.170321246,40.1656165617",
    "3$115.499217446,40.0396039604",
    "7$115.945576575,40.4626462646",
    "7$116.05129321,39.6885688569",
    "1$116.250980189,39.5085508551",
    "2080$116.650354146,39.904590459",
    "1$116.803055953,40.4266426643",
    "10$116.979250346,40.2646264626",
    "2$116.990996639,40.0576057606",
    "1$116.086532089,40.0486048605",
    "16$116.110024675,40.1746174617",
    "72$116.532891217,40.2376237624",
    "10$116.79130966,39.8415841584",
    "23$117.017619439,40.1296129613",
    "7$115.769382182,40.0306030603",
    "3$116.039546917,39.895589559",
    "6$116.121770967,39.5895589559",
    "16$116.250980189,39.7065706571",
    "4155$116.286219067,39.8685868587",
    "2576$116.356696825,39.8325832583",
    "1$116.415428289,40.5346534653",
    "6$116.46241346,39.7515751575",
    "8$116.662100439,40.3816381638",
    "11$116.767817074,40.0936093609",
    "9$116.850041124,40.0756075608",
    "1$116.016054332,39.8865886589",
    "978$116.286219067,40.1746174617",
    "3846$116.309711653,39.8505850585",
    "819$116.344950532,39.7515751575",
    "2$116.391935703,39.6885688569",
    "3904$116.391935703,39.9585958596",
    "101$116.697339317,40.102610261",
    "2$117.370008225,40.1926192619",
    "8$116.063039503,40.201620162",
    "20$116.391935703,39.5175517552",
    "17$116.509398632,39.6075607561",
    "2$115.957322868,39.6615661566",
    "14$116.027800625,39.6525652565",
    "34$116.274472775,40.2196219622",
    "2$116.861787417,40.4536453645",
    "6$116.944011467,40.4086408641",
    "3$117.123336075,40.4086408641",
    "2$116.004308039,39.8235823582",
    "137$116.192248725,39.7515751575",
    "1527$116.474159753,40.0216021602",
    "22$116.615115267,40.3636363636",
    "2$116.744324489,39.6885688569",
    "156$115.992561746,39.7065706571",
    "10$116.039546917,40.1566156616",
    "351$116.309711653,39.7695769577",
    "69$116.579876389,40.1116111611",
    "1$116.79130966,40.4176417642",
    "14$117.017619439,40.201620162",
    "3$117.017619439,40.2286228623",
    "41$116.027800625,40.3546354635",
    "3904$116.356696825,40.0216021602",
    "1$116.532891217,39.6525652565",
    "164$116.650354146,39.7515751575",
    "3$116.720831903,39.8145814581",
    "30$116.05129321,40.3096309631",
    "1$116.086532089,40.0756075608",
    "19$116.391935703,40.2376237624",
    "84$116.650354146,39.7605760576",
    "8$116.720831903,39.8055805581",
    "2$116.262726482,40.3816381638",
    "2704$116.286219067,40.0306030603",
    "7046$116.38018941,39.9585958596",
    "27$116.46241346,39.5625562556",
    "608$116.532891217,40.0216021602",
    "17$116.944011467,40.4176417642",
    "30$116.027800625,40.00360036",
    "265$116.074785796,39.6525652565",
    "87$116.121770967,39.8415841584",
    "685$116.168756139,39.895589559",
    "279$116.192248725,39.796579658",
    "9$116.192248725,40.2556255626",
    "6$116.54463751,40.4266426643",
    "4$116.638607853,40.7236723672",
    "6$116.662100439,40.6786678668",
    "4$116.979250346,40.1386138614",
    "1820$116.556383803,39.9495949595",
    "129$116.603368974,39.8415841584",
    "6$115.757635889,39.6615661566",
    "102$116.497652339,40.2106210621",
    "8$116.79130966,39.8595859586",
    "8$115.898591403,40.399639964",
    "2$116.21574131,39.5805580558",
    "122$116.38018941,39.7515751575",
    "91$116.650354146,39.8235823582",
    "48$116.650354146,40.1476147615",
    "43$116.767817074,39.8775877588",
    "1$116.908772589,40.597659766",
    "13$117.170321246,40.4536453645",
    "5$115.96906916,40.5256525653",
    "36$116.203995017,40.300630063",
    "1378$116.239233896,39.8595859586",
    "1$116.274472775,39.5175517552",
    "122$116.274472775,39.9765976598",
    "107$116.333204239,39.6075607561",
    "93$116.532891217,40.1206120612",
    "24$116.568130096,40.2646264626",
    "47$116.591622682,39.8055805581",
    "3$115.745889596,39.5175517552",
    "112$116.227487603,40.1116111611",
    "1$116.250980189,39.5535553555",
    "56$116.274472775,39.796579658",
    "16$116.29796536,40.2376237624",
    "3$116.391935703,39.7785778578",
    "178$116.650354146,39.8325832583",
    "8$116.838294831,40.1656165617",
    "3$115.72239701,39.8325832583",
    "14$115.933830282,40.0936093609",
    "41$115.96906916,39.6165616562",
    "5$116.157009846,39.9495949595",
    "471$116.180502432,39.7335733573",
    "4$116.521144924,39.7155715572",
    "1$116.885280003,40.3096309631",
    "10$117.029365732,40.0576057606",
    "4$117.029365732,40.2556255626",
    "6$117.182067539,40.1566156616",
    "1$115.88684511,39.598559856",
    "30$116.121770967,40.1926192619",
    "49$116.720831903,39.8325832583",
    "4$116.967504053,40.1116111611",
    "59$117.017619439,40.1386138614",
    "29$117.146828661,40.3366336634",
    "1$117.182067539,40.1926192619",
    "42$116.203995017,39.6525652565",
    "105$116.403681996,39.7695769577",
    "353$116.673846732,40.1116111611",
    "8$116.756070781,39.9855985599",
    "1$116.908772589,40.0666066607",
    "10$116.944011467,40.0666066607",
    "2076$116.274472775,40.0126012601",
    "688$116.309711653,40.1116111611",
    "1003$116.450667167,40.0126012601",
    "164$116.556383803,40.1296129613",
    "700$116.650354146,39.9315931593",
    "2$116.95575776,40.0756075608",
    "9$117.217306418,40.201620162",
    "2$116.321457946,40.696669667",
    "4877$116.333204239,40.00360036",
    "1404$116.62686156,39.9135913591",
    "11$116.838294831,40.0756075608",
    "26$116.027800625,39.6795679568",
    "3$116.063039503,39.8235823582",
    "1$116.192248725,40.3366336634",
    "44$116.333204239,40.2196219622",
    "24$116.427174582,39.5265526553",
    "13205$116.46241346,39.8865886589",
    "470$116.532891217,39.8145814581",
    "185$116.556383803,40.1476147615",
    "126$116.673846732,39.6615661566",
    "19$116.79130966,40.2826282628",
    "9$116.803055953,40.3456345635",
    "4$117.158574954,40.696669667",
    "3$116.368443117,39.6075607561",
    "2$116.46241346,40.5796579658",
    "3$116.485906046,39.6435643564",
    "15$117.146828661,40.5076507651",
    "7875$116.415428289,39.8595859586",
    "1$116.450667167,39.6255625563",
    "66$116.662100439,40.0306030603",
    "1$116.697339317,40.8586858686",
    "2$116.227487603,39.6435643564",
    "1$116.250980189,39.5265526553",
    "27$116.767817074,39.8145814581",
    "16$116.897026296,40.1206120612",
    "1$115.698904425,39.5895589559",
    "11$115.828113646,39.5895589559",
    "3$115.957322868,39.9945994599",
    "1$116.262726482,39.5535553555",
    "224$116.38018941,39.7245724572",
    "9034$116.415428289,39.9945994599",
    "2360$116.509398632,39.8235823582",
    "1$117.170321246,40.597659766",
    "7$115.839859939,39.5625562556",
    "2$115.933830282,40.3186318632",
    "1$116.157009846,40.0306030603",
    "8$116.29796536,39.6075607561",
    "3439$116.344950532,40.0126012601",
    "29$116.474159753,40.1566156616",
    "54$116.579876389,40.0306030603",
    "1$116.579876389,40.3816381638",
    "124$116.62686156,40.0486048605",
    "1$116.039546917,39.9315931593",
    "3$116.039546917,40.4626462646",
    "11$116.121770967,39.6615661566",
    "4$116.427174582,39.6525652565",
    "3$116.568130096,40.300630063",
    "2$116.826548539,39.8775877588",
    "1$115.933830282,39.796579658",
    "1$116.074785796,39.8865886589",
    "4$116.333204239,39.6435643564",
    "2$117.170321246,40.2376237624",
    "2$115.863352525,39.8235823582",
    "1$115.922083989,40.5076507651",
    "148$116.391935703,40.1836183618",
    "1$116.650354146,39.6435643564",
    "10$116.673846732,40.3276327633",
    "4$116.004308039,39.7875787579",
    "16$116.063039503,39.796579658",
    "87$116.579876389,39.8325832583",
    "49$115.957322868,39.598559856",
    "3$116.039546917,40.0306030603",
    "491$116.21574131,39.9765976598",
    "54$116.532891217,40.2466246625",
    "5$116.732578196,39.9675967597",
    "9$116.908772589,39.8415841584",
    "1$116.967504053,40.3366336634",
    "64$115.72239701,39.5715571557",
    "3$116.098278382,40.3726372637",
    "272$116.168756139,39.8775877588",
    "98$116.168756139,40.0306030603",
    "8$116.38018941,40.1926192619",
    "2969$116.415428289,40.0936093609",
    "12$116.568130096,39.697569757",
    "161$116.673846732,40.3906390639",
    "3$117.076350904,40.1386138614",
    "8$116.016054332,40.2916291629",
    "46$116.168756139,40.0756075608",
    "45$116.521144924,40.102610261",
    "267$116.579876389,40.0126012601",
    "35$116.756070781,40.1656165617",
    "5$116.920518881,39.8145814581",
    "23$117.182067539,40.5796579658",
    "1$115.88684511,40.5076507651",
    "2$115.898591403,40.1836183618",
    "1$115.96906916,39.8595859586",
    "8$116.086532089,39.7605760576",
    "5$116.098278382,39.895589559",
    "20$116.180502432,40.3096309631",
    "1$116.192248725,40.6516651665",
    "1$116.767817074,39.7245724572",
    "70$116.932265174,40.1476147615",
    "2$117.002742931,40.1296129613",
    "14$117.135082368,40.5076507651",
    "5$115.792874768,39.5895589559",
    "57$116.21574131,40.1836183618",
    "125$116.250980189,39.9945994599",
    "9$116.309711653,39.5895589559",
    "5$116.579876389,40.4446444644",
    "1870$116.673846732,39.8865886589",
    "5$116.779563367,40.4446444644",
    "2$116.908772589,39.8145814581",
    "1$115.651919253,39.6255625563",
    "38$116.192248725,39.8235823582",
    "4921$116.286219067,39.9225922592",
    "384$116.309711653,39.6885688569",
    "1601$116.333204239,39.8235823582",
    "685$116.662100439,39.9315931593",
    "7$116.720831903,39.6435643564",
    "12$117.111589782,40.1836183618",
    "23$117.264291589,40.6516651665",
    "1$116.063039503,40.4806480648",
    "4$116.250980189,39.5625562556",
    "1350$116.356696825,40.0486048605",
    "5654$116.403681996,39.9765976598",
    "153$116.427174582,40.1656165617",
    "159$116.438920874,40.1386138614",
    "2167$116.579876389,39.895589559",
    "1$116.603368974,39.7785778578",
    "358$116.615115267,39.8685868587",
    "7$116.697339317,39.6795679568",
    "1$116.756070781,40.4356435644",
    "31$116.767817074,39.8235823582",
    "27$116.932265174,40.4446444644",
    "28$116.990996639,40.1566156616",
    "1891$116.309711653,40.102610261",
    "3955$116.474159753,39.9495949595",
    "329$116.62686156,40.3726372637",
    "321$116.767817074,39.9315931593",
    "3$116.779563367,40.3276327633",
    "46$116.850041124,39.7515751575",
    "28$117.064604611,40.102610261",
    "1$115.616680375,39.9495949595",
    "12$115.734143303,39.5805580558",
    "39$116.21574131,39.6885688569",
    "217$116.227487603,40.0666066607",
    "2343$116.286219067,40.1476147615",
    "56$116.29796536,40.2196219622",
    "3$116.309711653,40.3546354635",
    "3545$116.497652339,39.9675967597",
    "1363$116.509398632,39.8775877588",
    "7$116.579876389,40.0216021602",
    "14$116.685593024,40.0216021602",
    "16$116.87353371,40.2196219622",
    "5$116.004308039,39.5805580558",
    "5$116.063039503,40.4896489649",
    "279$116.13351726,40.0666066607",
    "26$116.13351726,40.1656165617",
    "23$116.21574131,39.7245724572",
    "743$116.262726482,39.9765976598",
    "6383$116.450667167,39.9675967597",
    "4448$116.532891217,39.9135913591",
    "93$116.568130096,39.8325832583",
    "8$116.662100439,40.6156615662",
    "1$116.850041124,40.1296129613",
    "6$116.87353371,39.6885688569",
    "6$116.95575776,40.4086408641",
    "6$115.781128475,39.5535553555",
    "6$116.074785796,40.4716471647",
    "11980$116.46241346,39.904590459",
    "944$116.532891217,39.9675967597",
    "106$116.591622682,39.8145814581",
    "34$116.779563367,40.2466246625",
    "11$116.87353371,39.6795679568",
    "1$117.041112025,40.201620162",
    "22$117.346515639,40.2196219622",
    "3507$116.29796536,39.8415841584",
    "60$116.356696825,40.201620162",
    "301$116.62686156,40.1386138614",
    "45$116.673846732,40.2736273627",
    "12$116.850041124,40.3456345635",
    "55$115.910337696,40.3636363636",
    "1$116.286219067,40.2736273627",
    "29$116.415428289,39.6885688569",
    "13$116.568130096,40.399639964",
    "21$116.697339317,39.6615661566",
    "6$117.111589782,40.5256525653",
    "6$117.158574954,40.1206120612",
    "2$117.193813832,40.6516651665",
    "165$115.522710032,39.6075607561",
    "2$115.745889596,39.6075607561",
    "65$116.46241346,39.7785778578",
    "173$116.497652339,39.7785778578",
    "17$116.838294831,39.8055805581",
    "1$115.769382182,39.8145814581",
    "6$115.945576575,40.4536453645",
    "36$115.96906916,39.697569757",
    "374$116.180502432,39.8595859586",
    "39$116.497652339,40.2826282628",
    "240$116.638607853,40.1116111611",
    "52$116.638607853,40.2916291629",
    "1567$116.650354146,39.9225922592",
    "8$116.650354146,39.9585958596",
    "4$116.967504053,40.0936093609",
    "1$117.099843489,40.2466246625",
    "26$117.111589782,40.1206120612",
    "14$117.146828661,40.3546354635",
    "5$116.192248725,39.6075607561",
    "468$116.203995017,40.0486048605",
    "2445$116.286219067,39.9405940594",
    "1651$116.286219067,40.0486048605",
    "6583$116.286219067,40.102610261",
    "2269$116.46241346,39.8325832583",
    "43$116.62686156,40.1746174617",
    "15$116.650354146,39.6525652565",
    "5$116.744324489,40.6336633663",
    "6$116.767817074,40.6336633663",
    "1$117.170321246,40.6786678668",
    "18$115.816367353,40.0126012601",
    "26$115.88684511,40.4896489649",
    "11$116.004308039,40.4176417642",
    "5$116.016054332,39.9855985599",
    "988$116.121770967,39.9405940594",
    "2$116.356696825,40.2466246625",
    "21$116.415428289,39.6345634563",
    "28$116.509398632,39.6435643564",
    "34$116.54463751,40.2196219622",
    "203$116.579876389,40.0486048605",
    "24$116.579876389,40.3636363636",
    "1$116.673846732,39.6795679568",
    "1$116.814802246,39.7245724572",
    "22$117.088097196,40.1656165617",
    "1$115.781128475,40.5166516652",
    "5$115.80462106,39.5265526553",
    "132$116.227487603,39.9855985599",
    "154$116.286219067,40.2646264626",
    "2$116.356696825,40.3636363636",
    "8946$116.403681996,39.9675967597",
    "6$116.485906046,40.2916291629",
    "40$117.287784175,40.6606660666",
    "3$115.616680375,39.9405940594",
    "4$116.027800625,40.1116111611",
    "5$116.203995017,40.0756075608",
    "519$116.239233896,39.8775877588",
    "36$116.356696825,40.2376237624",
    "489$116.391935703,40.1746174617",
    "11$116.638607853,39.9585958596",
    "9$116.016054332,40.1296129613",
    "3$116.063039503,39.8505850585",
    "13$116.145263553,40.1926192619",
    "98$116.168756139,39.9135913591",
    "225$116.262726482,39.7695769577",
    "2358$116.403681996,40.0846084608",
    "2351$116.54463751,39.895589559",
    "9$116.579876389,40.0936093609",
    "1$117.182067539,40.4176417642",
    "1$115.933830282,40.3456345635",
    "8$115.933830282,40.5076507651",
    "2$116.180502432,40.5076507651",
    "167$116.192248725,40.0666066607",
    "926$116.227487603,39.9945994599",
    "2$116.368443117,40.1386138614",
    "1$116.450667167,40.6696669667",
    "53$116.556383803,40.2556255626",
    "31$116.850041124,40.1566156616",
    "1$117.029365732,40.1206120612",
    "8$115.828113646,39.7605760576",
    "10$116.098278382,40.4536453645",
    "837$116.321457946,39.7605760576",
    "682$116.556383803,39.9405940594",
    "3$116.697339317,40.4086408641",
    "11$116.944011467,40.1386138614",
    "60$117.017619439,40.0666066607",
    "4$115.933830282,39.9675967597",
    "65$116.027800625,40.5436543654",
    "13$116.145263553,40.2196219622",
    "10$116.861787417,40.2196219622",
    "6$117.252545296,40.6516651665",
    "3$116.05129321,40.4266426643",
    "44$116.192248725,40.2736273627",
    "22$116.21574131,40.2556255626",
    "7949$116.333204239,39.904590459",
    "525$116.438920874,39.7785778578",
    "8$116.685593024,39.6345634563",
    "17$116.685593024,39.7875787579",
    "226$116.70908561,39.904590459",
    "4$117.064604611,40.2736273627",
    "15$117.111589782,40.6066606661",
    "2$117.146828661,40.3726372637",
    "2$116.110024675,40.4536453645",
    "54$116.157009846,39.7065706571",
    "9831$116.321457946,39.9495949595",
    "4792$116.321457946,40.00360036",
    "2$116.62686156,40.8946894689",
    "43$116.779563367,39.7695769577",
    "192$115.945576575,39.6705670567",
    "14$116.110024675,40.2196219622",
    "1$116.168756139,40.6426642664",
    "107$116.344950532,40.2106210621",
    "10849$116.403681996,39.8595859586",
    "3$116.732578196,40.8226822682",
    "87$116.05129321,39.7425742574",
    "3777$116.29796536,40.0936093609",
    "5$116.344950532,40.399639964",
    "474$116.450667167,39.7695769577",
    "37$116.62686156,39.6435643564",
    "136$116.650354146,39.7335733573",
    "90$116.662100439,40.201620162",
    "11$116.720831903,39.7785778578",
    "2$116.944011467,40.3726372637",
    "10$117.170321246,40.2556255626",
    "34$116.004308039,40.3456345635",
    "1$116.121770967,39.598559856",
    "137$116.157009846,40.0216021602",
    "4$116.239233896,39.7875787579",
    "155$116.532891217,40.4536453645",
    "161$116.579876389,40.0666066607",
    "15$116.744324489,40.3456345635",
    "178$115.945576575,39.598559856",
    "2$116.016054332,39.895589559",
    "4$116.098278382,40.5346534653",
    "32$116.286219067,39.6885688569",
    "459$116.403681996,40.102610261",
    "88$116.70908561,40.1386138614",
    "524$116.838294831,40.3726372637",
    "1$116.908772589,39.7875787579",
    "7$116.227487603,39.8145814581",
    "206$116.250980189,40.2286228623",
    "1$116.579876389,40.3546354635",
    "91$116.62686156,39.9765976598",
    "115$116.638607853,40.3456345635",
    "46$116.720831903,39.9135913591",
    "2$115.710650718,40.0126012601",
    "387$116.286219067,40.201620162",
    "174$116.333204239,40.1296129613",
    "7$116.356696825,40.1386138614",
    "14$116.368443117,40.1926192619",
    "84$116.662100439,40.0576057606",
    "80$116.732578196,40.1296129613",
    "13$116.779563367,39.6165616562",
    "3$115.933830282,40.4536453645",
    "639$115.980815453,40.4626462646",
    "767$116.227487603,39.9135913591",
    "112$116.579876389,39.9945994599",
    "271$116.603368974,39.8775877588",
    "5$116.814802246,39.6165616562",
    "6$117.240799003,40.201620162",
    "3$115.72239701,39.5895589559",
    "10$115.792874768,39.6165616562",
    "23$116.05129321,39.8145814581",
    "12$116.110024675,40.5076507651",
    "34$116.38018941,39.7335733573",
    "7$116.591622682,40.1926192619",
    "6$116.62686156,39.8145814581",
    "45$116.673846732,39.6525652565",
    "154$116.720831903,39.9675967597",
    "22$116.861787417,40.0756075608",
    "13$117.017619439,40.2466246625",
    "13$117.099843489,40.1116111611",
    "1$117.299530468,40.1926192619",
    "151$115.64017296,39.9945994599",
    "273$116.168756139,39.8415841584",
    "251$116.180502432,39.8415841584",
    "571$116.21574131,40.102610261",
    "33$116.274472775,40.597659766",
    "1093$116.286219067,39.7785778578",
    "30$116.70908561,40.102610261",
    "11$116.744324489,40.201620162",
    "4$117.029365732,40.4896489649",
    "686$116.356696825,40.0576057606",
    "5667$116.368443117,39.8595859586",
    "36$116.450667167,39.7065706571",
    "114$116.46241346,40.4536453645",
    "6$116.779563367,39.6795679568",
    "2$117.017619439,40.1566156616",
    "8$115.828113646,39.6885688569",
    "1$116.039546917,40.5076507651",
    "15$116.074785796,40.1746174617",
    "107$116.262726482,40.0666066607",
    "4846$116.29796536,39.8595859586",
    "81$116.309711653,40.1386138614",
    "777$116.46241346,40.1206120612",
    "216$116.54463751,40.0666066607",
    "24$116.54463751,40.1566156616",
    "127$116.826548539,40.1566156616",
    "107$116.027800625,39.8775877588",
    "1$116.344950532,40.5256525653",
    "171$116.568130096,39.7245724572",
    "10$116.803055953,40.0576057606",
    "2$117.052858318,40.1746174617",
    "2485$116.203995017,39.9315931593",
    "8$116.344950532,40.2286228623",
    "4982$116.356696825,40.0666066607",
    "393$116.485906046,40.0306030603",
    "15$116.673846732,39.9765976598",
    "1$116.685593024,40.0576057606",
    "3$116.744324489,40.2646264626",
    "12$116.826548539,39.7875787579",
    "1$117.135082368,40.5796579658",
    "19$115.757635889,39.9495949595",
    "14$115.875098818,39.6165616562",
    "1$116.333204239,39.6345634563",
    "2$116.638607853,40.7146714671",
    "15$116.697339317,39.7515751575",
    "4$117.041112025,40.2826282628",
    "19$115.933830282,39.6075607561",
    "149$115.992561746,40.4716471647",
    "24$116.157009846,39.9135913591",
    "2$116.203995017,40.4446444644",
    "39$116.227487603,40.0576057606",
    "3$116.438920874,39.7155715572",
    "8$117.005873146,40.0846084608",
    "10$115.96906916,39.6435643564",
    "2$115.96906916,39.9945994599",
    "12$116.086532089,39.8145814581",
    "8$116.110024675,40.2736273627",
    "183$116.13351726,39.9315931593",
    "11752$116.321457946,39.9675967597",
    "1176$116.344950532,39.8055805581",
    "20$116.650354146,40.6336633663",
    "46$116.756070781,39.8325832583",
    "13$117.123336075,40.1746174617",
    "1$115.557948911,39.8415841584",
    "8$115.957322868,40.4266426643",
    "40$116.509398632,40.0666066607",
    "212$116.532891217,40.0486048605",
    "1$117.311276761,40.6336633663",
    "9$117.334769346,40.1836183618",
    "300$116.568130096,39.7335733573",
    "161$116.650354146,40.3186318632",
    "1$116.673846732,39.6345634563",
    "442$116.70908561,39.9225922592",
    "38$116.908772589,39.796579658",
    "1$117.205560125,40.1566156616",
    "15$115.710650718,39.5805580558",
    "53$116.086532089,39.8865886589",
    "6$116.403681996,39.6525652565",
    "155$116.615115267,39.8325832583",
    "31$115.96906916,39.6795679568",
    "5$116.05129321,40.4806480648",
    "1712$116.203995017,39.9405940594",
    "1$116.803055953,40.6156615662",
    "4$117.158574954,40.4266426643",
    "1$115.734143303,39.7245724572",
    "5$116.063039503,40.5436543654",
    "7$116.21574131,40.5706570657",
    "4367$116.356696825,39.8505850585",
    "4$116.54463751,40.2646264626",
    "471$116.556383803,40.1116111611",
    "13$116.650354146,40.2646264626",
    "1$116.79130966,40.6156615662",
    "1$116.803055953,40.4806480648",
    "2$117.146828661,40.5166516652",
    "71$116.13351726,40.1296129613",
    "3541$116.168756139,39.7155715572",
    "1$116.180502432,39.6525652565",
    "190$116.227487603,40.0846084608",
    "2$116.438920874,40.4086408641",
    "16$116.673846732,40.4356435644",
    "1$116.70908561,40.4086408641",
    "2$116.474159753,40.5796579658",
    "428$116.556383803,39.8595859586",
    "132$116.579876389,40.0846084608",
    "1$116.944011467,40.3636363636",
    "1$117.076350904,40.1746174617",
    "16$115.898591403,39.6075607561",
    "16$115.910337696,39.7425742574",
    "131$116.121770967,40.2286228623",
    "9$116.192248725,39.6795679568",
    "14$116.309711653,39.6525652565",
    "4499$116.321457946,40.0666066607",
    "146$116.450667167,40.102610261",
    "971$116.556383803,39.9585958596",
    "4$116.79130966,40.4356435644",
    "1$117.088097196,40.0756075608",
    "3$117.346515639,40.2286228623",
    "75$116.074785796,40.2736273627",
    "2$116.239233896,39.5715571557",
    "13$116.356696825,39.6165616562",
    "5$116.485906046,39.5895589559",
    "143$116.485906046,40.0666066607",
    "5$116.603368974,40.4356435644",
    "1$116.814802246,40.2286228623",
    "7$116.074785796,40.1656165617",
    "2$116.38018941,39.5895589559",
    "17$116.38018941,39.6795679568",
    "4406$116.415428289,39.8505850585",
    "41$116.521144924,39.6705670567",
    "10$116.579876389,40.3456345635",
    "1412$116.591622682,39.9315931593",
    "14$116.591622682,40.2196219622",
    "15$116.720831903,39.9315931593",
    "2$116.87353371,40.1296129613",
    "15$115.992561746,39.6525652565",
    "71$116.192248725,39.7155715572",
    "155$116.227487603,40.0216021602",
    "501$116.29796536,40.0126012601",
    "21$116.497652339,40.2286228623",
    "1$116.803055953,40.5346534653",
    "15$115.957322868,39.7695769577",
    "73$116.274472775,39.5895589559",
    "9$116.333204239,40.1836183618",
    "30$116.697339317,40.2736273627",
    "58$116.098278382,40.2196219622",
    "236$116.356696825,39.7245724572",
    "16$116.356696825,40.399639964",
    "1910$116.38018941,40.0756075608",
    "19$116.697339317,39.7785778578",
    "4$117.311276761,40.1746174617",
    "3$115.898591403,40.3906390639",
    "169$116.145263553,39.904590459",
    "50$116.29796536,39.7245724572",
    "1999$116.603368974,39.904590459",
    "3$116.756070781,39.6165616562",
    "6$117.323023053,40.1836183618",
    "41$116.039546917,39.6795679568",
    "1$116.086532089,40.5346534653",
    "3213$116.321457946,39.8505850585",
    "70$116.450667167,39.7245724572",
    "10495$116.450667167,39.9225922592",
    "15$116.850041124,40.4176417642",
    "3$117.334769346,40.201620162",
    "4024$116.450667167,39.9945994599",
    "284$116.485906046,39.7785778578",
    "1994$116.497652339,39.9765976598",
    "33$116.579876389,40.102610261",
    "364$116.603368974,39.9495949595",
    "117$116.732578196,40.0126012601",
    "5$117.264291589,40.1836183618",
    "1$115.898591403,39.598559856",
    "47$116.05129321,40.00360036",
    "68$116.063039503,39.7875787579",
    "1$116.427174582,40.5616561656",
    "27$116.46241346,39.6435643564",
    "711$116.54463751,39.8145814581",
    "17$116.685593024,39.7695769577",
    "49$116.697339317,39.6165616562",
    "1$116.814802246,39.6615661566",
    "1$116.838294831,40.6066606661",
    "7$117.005873146,40.3636363636",
    "1$117.135082368,40.597659766",
    "21$115.816367353,39.5895589559",
    "175$115.96906916,39.7155715572",
    "4$116.074785796,39.8595859586",
    "40$116.121770967,40.1836183618",
    "1$116.344950532,40.7146714671",
    "34$116.46241346,40.2286228623",
    "3$116.54463751,40.3366336634",
    "2515$116.568130096,39.9135913591",
    "360$116.650354146,40.1836183618",
    "11$116.70908561,40.3726372637",
    "1$116.70908561,40.4266426643",
    "1$116.861787417,40.4626462646",
    "12$115.910337696,40.3546354635",
    "10$115.980815453,39.9585958596",
    "1155$116.168756139,39.7695769577",
    "1165$116.344950532,39.8595859586",
    "14$116.356696825,39.598559856",
    "2078$116.415428289,40.0216021602",
    "12$116.568130096,40.3456345635",
    "94$116.579876389,39.9855985599",
    "6$116.673846732,40.1566156616",
    "1$116.685593024,40.7596759676",
    "52$116.732578196,39.6345634563",
    "6$116.756070781,39.7245724572",
    "47$117.064604611,40.1476147615",
    "4$115.922083989,40.0126012601",
    "28$116.098278382,39.8415841584",
    "25$116.344950532,39.6075607561",
    "5993$116.403681996,39.9585958596",
    "1096$116.591622682,40.0486048605",
    "1$116.767817074,40.2826282628",
    "22$116.074785796,39.598559856",
    "4544$116.274472775,39.9315931593",
    "5576$116.38018941,39.904590459",
    "6194$116.427174582,39.9495949595",
    "1$116.521144924,40.7686768677",
    "47$116.662100439,39.7155715572",
    "44$116.004308039,40.4536453645",
    "642$116.180502432,40.0576057606",
    "614$116.321457946,39.6345634563",
    "3143$116.662100439,39.8865886589",
    "3$116.779563367,39.6255625563",
    "2$117.182067539,40.4086408641",
    "6$116.074785796,39.9855985599",
    "7$116.086532089,39.6345634563",
    "1$116.979250346,40.0936093609",
    "1$117.123336075,40.3276327633",
    "4$115.992561746,40.4266426643",
    "2008$116.110024675,39.9315931593",
    "102$116.157009846,39.8415841584",
    "20$116.286219067,39.5895589559",
    "14$116.427174582,39.6795679568",
    "103$116.497652339,39.6165616562",
    "377$116.54463751,40.0576057606",
    "149$116.603368974,39.8505850585",
    "7$116.016054332,39.8775877588",
    "180$116.086532089,40.102610261",
    "5$116.098278382,40.2286228623",
    "416$116.239233896,39.8685868587",
    "2$116.274472775,39.5805580558",
    "27$117.252545296,40.2556255626",
    "30$115.851606232,39.5625562556",
    "2$116.203995017,40.5076507651",
    "7$116.662100439,40.6516651665",
    "275$116.732578196,39.9315931593",
    "2$116.95575776,40.1926192619",
    "24$117.170321246,40.5706570657",
    "1$115.581441496,39.9765976598",
    "539$116.250980189,39.9405940594",
    "125$116.274472775,40.1836183618",
    "141$116.62686156,39.9315931593",
    "2$116.767817074,39.6255625563",
    "1$116.979250346,40.300630063",
    "11$117.217306418,40.1656165617",
    "55$116.039546917,40.3276327633",
    "49$116.180502432,40.0306030603",
    "12$116.321457946,40.3636363636",
    "4959$116.356696825,40.0756075608",
    "19$116.568130096,39.7155715572",
    "3918$116.603368974,39.9225922592",
    "249$116.685593024,39.9855985599",
    "5$116.697339317,40.3636363636",
    "28$116.70908561,40.3456345635",
    "345$116.732578196,39.9135913591",
    "59$116.803055953,40.0396039604",
    "1$116.027800625,39.796579658",
    "77$116.039546917,39.7065706571",
    "47$116.13351726,40.2286228623",
    "215$116.192248725,40.00360036",
    "3780$116.274472775,39.8685868587",
    "2615$116.309711653,40.00360036",
    "53$116.650354146,39.7875787579",
    "1$116.814802246,40.6246624662",
    "4$116.908772589,40.4536453645",
    "1$116.098278382,40.5616561656",
    "23$116.110024675,40.0216021602",
    "5$116.239233896,40.1386138614",
    "88$116.29796536,39.6615661566",
    "7$116.403681996,39.6075607561",
    "528$116.54463751,39.7425742574",
    "69$116.54463751,40.0486048605",
    "92$116.568130096,39.9945994599",
    "8$116.591622682,40.4266426643",
    "48$116.638607853,39.8325832583",
    "3$116.779563367,40.4266426643",
    "18$116.967504053,40.0666066607",
    "11$116.168756139,40.2196219622",
    "5946$116.309711653,39.904590459",
    "9$116.368443117,39.6885688569",
    "7$116.474159753,39.598559856",
    "4$116.497652339,39.598559856",
    "60$116.62686156,40.300630063",
    "937$116.673846732,39.9405940594",
    "1$117.041112025,40.2646264626",
    "3$116.027800625,40.4446444644",
    "253$116.46241346,39.7695769577",
    "6$116.615115267,40.2376237624",
    "2$116.662100439,40.7596759676",
    "4$116.920518881,40.2466246625",
    "3$117.076350904,40.3636363636",
    "23$117.099843489,40.0936093609",
    "1$117.381754518,40.6426642664",
    "4$115.745889596,39.7245724572",
    "1$115.781128475,39.5805580558",
    "13$115.980815453,40.4896489649",
    "1372$116.227487603,39.8775877588",
    "5494$116.391935703,39.9405940594",
    "8095$116.474159753,39.9315931593",
    "194$116.662100439,39.9675967597",
    "461$116.697339317,39.8865886589",
    "2$116.767817074,40.1476147615",
    "42$116.767817074,40.3096309631",
    "58$116.79130966,40.3456345635",
    "3$116.990996639,40.4176417642",
    "2$117.005873146,40.3546354635",
    "19$117.146828661,40.4086408641",
    "1$115.581441496,39.6435643564",
    "25$115.980815453,40.2376237624",
    "1$116.027800625,40.201620162",
    "139$116.063039503,39.9315931593",
    "31$116.157009846,40.5256525653",
    "3$116.192248725,40.399639964",
    "260$116.203995017,40.1206120612",
    "20$116.344950532,39.5445544554",
    "719$116.356696825,40.102610261",
    "13$116.368443117,39.5895589559",
    "727$116.579876389,39.8055805581",
    "6$116.650354146,39.6345634563",
    "570$116.779563367,39.9405940594",
    "5$117.041112025,40.3636363636",
    "73$116.180502432,40.0846084608",
    "37$116.21574131,40.2646264626",
    "31$116.54463751,40.1656165617",
    "4$117.088097196,40.1116111611",
    "48$116.098278382,39.8145814581",
    "32$116.098278382,39.8235823582",
    "129$116.286219067,40.2286228623",
    "93$116.46241346,40.0756075608",
    "1$116.568130096,39.6705670567",
    "11$116.685593024,39.7155715572",
    "85$116.70908561,39.8595859586",
    "4$116.838294831,39.8685868587",
    "10$115.745889596,39.5805580558",
    "211$116.192248725,39.9675967597",
    "617$116.532891217,39.8415841584",
    "891$116.615115267,39.895589559",
    "36$116.779563367,39.8595859586",
    "1$116.779563367,40.3906390639",
    "2$117.193813832,40.1116111611",
    "4$115.88684511,39.7695769577",
    "802$116.121770967,40.0936093609",
    "95$116.638607853,40.0576057606",
    "1$116.697339317,40.300630063",
    "2$116.744324489,40.2736273627",
    "1$116.920518881,39.8055805581",
    "37$115.581441496,39.7785778578",
    "1$115.875098818,40.4806480648",
    "4$115.980815453,40.3726372637",
    "54$116.05129321,39.7605760576",
    "1$116.521144924,40.7776777678",
    "8$116.615115267,40.102610261",
    "1380$116.638607853,39.9315931593",
    "2$116.779563367,40.6156615662",
    "1$116.803055953,39.7515751575",
    "1$115.933830282,39.697569757",
    "14$116.074785796,39.8055805581",
    "1697$116.427174582,40.0216021602",
    "1$116.54463751,39.7065706571",
    "103$116.591622682,39.8865886589",
    "115$116.603368974,40.0306030603",
    "2$116.861787417,39.8325832583",
    "23$117.041112025,40.1476147615",
    "15$117.240799003,40.2466246625",
    "6$116.168756139,39.6075607561",
    "402$116.321457946,40.1476147615",
    "41$116.403681996,39.6165616562",
    "404$116.403681996,39.7155715572",
    "3209$116.450667167,40.0216021602",
    "5$116.673846732,40.4266426643",
    "2$116.70908561,39.6255625563",
    "31$116.814802246,40.0666066607",
    "3$116.908772589,39.8505850585",
    "13$117.111589782,40.5346534653",
    "44$115.88684511,40.3726372637",
    "9$115.992561746,40.4806480648",
    "9$116.086532089,39.904590459",
    "7$116.38018941,40.2376237624",
    "18$116.46241346,40.1476147615",
    "1288$116.638607853,40.1296129613",
    "36$116.662100439,40.0126012601",
    "144$116.697339317,39.7875787579",
    "13$116.838294831,40.4266426643",
    "4$116.944011467,40.2826282628",
    "4$115.593187789,39.7785778578",
    "55$116.203995017,40.1656165617",
    "46$116.203995017,40.3096309631",
    "35$116.403681996,40.1476147615",
    "3$117.240799003,40.5346534653",
    "8$117.323023053,40.201620162",
    "42$115.992561746,39.7155715572",
    "576$116.38018941,40.0576057606",
    "6851$116.427174582,39.8415841584",
    "494$116.509398632,39.7875787579",
    "1801$116.54463751,39.8685868587",
    "22$116.615115267,40.2826282628",
    "16$116.814802246,39.8055805581",
    "7$116.016054332,39.6885688569",
    "342$116.086532089,39.9405940594",
    "295$116.098278382,39.9135913591",
    "5100$116.321457946,39.8415841584",
    "1$116.368443117,39.5085508551",
    "13$116.720831903,40.1566156616",
    "11$116.732578196,39.7605760576",
    "1$116.967504053,40.0846084608",
    "7$117.052858318,40.2556255626",
    "32$117.240799003,40.6156615662",
    "7$115.898591403,40.2286228623",
    "27$115.96906916,39.7515751575",
    "179$116.086532089,39.7155715572",
    "200$116.157009846,39.7875787579",
    "1620$116.274472775,40.1656165617",
    "6$115.945576575,39.7065706571",
    "57$116.13351726,39.7875787579",
    "718$116.145263553,39.895589559",
    "2$116.168756139,40.2106210621",
    "2$116.591622682,39.7245724572",
    "1$116.591622682,40.3366336634",
    "109$116.756070781,39.8865886589",
    "6$116.79130966,40.3636363636",
    "2$116.967504053,40.3636363636",
    "8$117.017619439,40.1656165617",
    "36$115.980815453,39.8145814581",
    "38$116.227487603,40.1656165617",
    "10622$116.356696825,39.9585958596",
    "6$116.403681996,39.499549955",
    "2643$116.450667167,39.9855985599",
    "4$116.474159753,40.4086408641",
    "1$116.474159753,40.4626462646",
    "67$116.54463751,39.9765976598",
    "2$116.744324489,40.300630063",
    "10$116.95575776,40.0576057606",
    "16$115.745889596,39.5265526553",
    "15$116.063039503,39.8055805581",
    "9$116.145263553,40.201620162",
    "10$116.579876389,40.1746174617",
    "2$116.756070781,40.795679568",
    "1$116.79130966,40.0576057606",
    "2$116.944011467,40.0936093609",
    "2$117.287784175,40.2106210621",
    "5$115.80462106,39.6705670567",
    "1$115.945576575,39.5715571557",
    "191$116.145263553,39.9675967597",
    "183$116.662100439,40.1836183618",
    "30$116.79130966,39.8775877588",
    "23$115.875098818,39.5625562556",
    "1$115.875098818,39.5805580558",
    "6$115.945576575,40.00360036",
    "49$116.027800625,39.7065706571",
    "4$116.145263553,40.1836183618",
    "199$116.274472775,39.8145814581",
    "2192$116.333204239,39.7515751575",
    "2826$116.333204239,39.8505850585",
    "2$116.450667167,40.2466246625",
    "31$116.497652339,40.1206120612",
    "61$116.532891217,39.9855985599",
    "1$116.685593024,40.201620162",
    "407$116.697339317,39.9225922592",
    "41$116.779563367,39.8325832583",
    "1$117.064604611,40.2916291629",
    "9$116.004308039,39.6435643564",
    "2$116.004308039,40.1386138614",
    "11$116.063039503,40.498649865",
    "17$116.110024675,40.2466246625",
    "226$116.356696825,39.7155715572",
    "28$116.415428289,40.3546354635",
    "1$116.744324489,40.4626462646",
    "25$116.756070781,39.9675967597",
    "3$116.861787417,39.8235823582",
    "1$117.029365732,40.0486048605",
    "8$115.792874768,39.5535553555",
    "4$115.922083989,39.7245724572",
    "56$116.039546917,40.4806480648",
    "2$116.098278382,40.0216021602",
    "42$116.168756139,40.1386138614",
    "1$116.180502432,40.5706570657",
    "549$116.274472775,39.9855985599",
    "6$115.945576575,40.5076507651",
    "4$116.05129321,39.6075607561",
    "45$116.591622682,39.9585958596",
    "7$116.62686156,39.6885688569",
    "32$116.685593024,39.8055805581",
    "7$116.967504053,40.1926192619",
    "9$117.099843489,40.3906390639",
    "3$117.240799003,40.4176417642",
    "224$116.29796536,40.2106210621",
    "2$116.368443117,39.4635463546",
    "29$116.532891217,40.1476147615",
    "204$116.615115267,39.9945994599",
    "4$116.62686156,39.7695769577",
    "157$116.685593024,39.9495949595",
    "72$116.744324489,40.1386138614",
    "5$116.756070781,40.0756075608",
    "17$116.87353371,40.3636363636",
    "4$116.145263553,39.6435643564",
    "179$116.21574131,39.8595859586",
    "26$116.274472775,39.6885688569",
    "7255$116.497652339,39.9225922592",
    "108$116.579876389,39.9675967597",
    "361$116.638607853,40.3186318632",
    "178$116.70908561,39.8505850585",
    "2$115.851606232,39.5895589559",
    "64$116.039546917,39.6165616562",
    "10$116.039546917,40.00360036",
    "4$116.262726482,39.5175517552",
    "238$116.286219067,40.2466246625",
    "2$116.356696825,39.5085508551",
    "3381$116.474159753,39.9675967597",
    "131$116.662100439,40.0486048605",
    "15$117.252545296,40.2646264626",
    "1$116.027800625,39.6345634563",
    "20$116.05129321,39.8505850585",
    "4912$116.21574131,39.904590459",
    "118$116.344950532,39.6885688569",
    "1$115.839859939,39.5805580558",
    "4$116.016054332,39.7875787579",
    "104$116.086532089,39.5805580558",
    "28$116.110024675,39.7425742574",
    "31$116.168756139,40.1296129613",
    "4299$116.309711653,39.8595859586",
    "1670$116.333204239,39.8415841584",
    "3233$116.579876389,39.904590459",
    "24$116.826548539,39.8145814581",
    "110$116.850041124,40.3636363636",
    "18$117.076350904,40.498649865",
    "1$115.792874768,39.8145814581",
    "253$116.227487603,39.7695769577",
    "622$116.227487603,39.9765976598",
    "249$116.250980189,40.1656165617",
    "606$116.274472775,40.0936093609",
    "85$116.344950532,40.201620162",
    "1$116.450667167,39.5805580558",
    "31$117.029365732,40.1386138614",
    "121$117.182067539,40.1116111611",
    "10$117.252545296,40.6696669667",
    "8$115.96906916,39.6615661566",
    "1$116.016054332,39.6165616562",
    "32$116.157009846,40.1206120612",
    "93$116.274472775,40.2376237624",
    "3$116.333204239,40.3726372637",
    "59$116.579876389,39.7425742574",
    "522$116.62686156,40.0306030603",
    "4$116.920518881,40.1566156616",
    "23$115.933830282,39.7335733573",
    "6977$116.356696825,39.9765976598",
    "8$116.450667167,40.2376237624",
    "66$116.497652339,39.7335733573",
    "15$116.509398632,39.7155715572",
    "118$116.509398632,40.0486048605",
    "801$116.532891217,39.8775877588",
    "28$116.568130096,40.3546354635",
    "1$116.615115267,40.9846984698",
    "51$116.62686156,39.9675967597",
    "41$116.62686156,40.0756075608",
    "11$116.638607853,39.6885688569",
    "2$116.756070781,40.8136813681",
    "4$116.027800625,40.1476147615",
    "161$116.13351726,39.7515751575",
    "213$116.13351726,39.9585958596",
    "534$116.262726482,40.1116111611",
    "403$116.532891217,40.0306030603",
    "963$116.850041124,40.3726372637",
    "10$117.323023053,40.2106210621",
    "8$116.13351726,39.5805580558",
    "91$116.227487603,39.7605760576",
    "2185$116.286219067,40.00360036",
    "4152$116.29796536,39.8325832583",
    "89$116.391935703,40.1296129613",
    "848$116.509398632,39.9855985599",
    "1105$116.521144924,39.7785778578",
    "19$116.826548539,40.102610261",
    "12$116.932265174,39.796579658",
    "11$116.203995017,40.0576057606",
    "2$116.438920874,39.5805580558",
    "13$116.497652339,39.7155715572",
    "214$116.591622682,39.6885688569",
    "15$116.615115267,40.3366336634",
    "7$116.744324489,40.3186318632",
    "1$116.979250346,40.3726372637",
    "159$116.074785796,39.9405940594",
    "1$116.180502432,39.6615661566",
    "3142$116.532891217,39.8685868587",
    "1$116.79130966,40.0756075608",
    "40$116.850041124,40.4716471647",
    "45$116.95575776,40.1476147615",
    "3$115.957322868,39.9765976598",
    "7629$116.356696825,39.9675967597",
    "9897$116.368443117,39.9585958596",
    "24$116.54463751,40.2106210621",
    "132$116.662100439,40.102610261",
    "8$116.074785796,39.7785778578",
    "1$116.427174582,40.2826282628",
    "27$116.450667167,40.4626462646",
    "7$116.54463751,39.6795679568",
    "14$116.110024675,40.1296129613",
    "5$116.145263553,40.3276327633",
    "19$116.157009846,39.8775877588",
    "98$116.29796536,39.6255625563",
    "139$116.344950532,39.697569757",
    "1$116.415428289,40.2466246625",
    "94$116.427174582,39.7425742574",
    "2$116.532891217,40.4356435644",
    "4$116.767817074,40.3456345635",
    "15$117.052858318,40.2736273627",
    "203$117.123336075,40.1566156616",
    "10$117.229052711,40.6066606661",
    "199$116.485906046,40.1296129613",
    "6$117.088097196,40.3096309631",
    "2$115.96906916,40.3726372637",
    "20$115.980815453,39.8055805581",
    "164$116.121770967,40.2376237624",
    "83$116.168756139,40.2466246625",
    "4566$116.262726482,39.9135913591",
    "98$116.46241346,40.1566156616",
    "2$116.650354146,40.7056705671",
    "1$116.803055953,40.3816381638",
    "6$116.838294831,39.7425742574",
    "3$116.944011467,40.3816381638",
    "5$117.217306418,40.102610261",
    "3$115.80462106,39.5355535554",
    "2110$116.46241346,39.8415841584",
    "737$116.521144924,39.9675967597",
    "24$116.54463751,40.2826282628",
    "82$116.556383803,40.2646264626",
    "45$116.568130096,40.2106210621",
    "6$117.123336075,40.1116111611",
    "18$115.992561746,39.6795679568",
    "2$116.004308039,40.1656165617",
    "6$116.356696825,39.5535553555",
    "55$116.662100439,40.2196219622",
    "35$116.720831903,39.8685868587",
    "3$116.850041124,40.1836183618",
    "2$116.990996639,40.1386138614",
    "2$115.863352525,39.8145814581",
    "5$116.192248725,39.6885688569",
    "184$116.239233896,40.1206120612",
    "64$116.368443117,40.2376237624",
    "2$116.427174582,39.4815481548",
    "3$117.205560125,40.1656165617",
    "22$116.203995017,39.6255625563",
    "1225$116.250980189,40.2196219622",
    "4$116.415428289,40.4176417642",
    "2400$116.438920874,40.0396039604",
    "29$116.732578196,39.6795679568",
    "7$116.79130966,39.8235823582",
    "1$116.897026296,40.4446444644",
    "441$116.21574131,40.0756075608",
    "11$116.274472775,39.6705670567",
    "878$116.344950532,39.7785778578",
    "421$116.403681996,40.1206120612",
    "1116$116.485906046,39.796579658",
    "36$116.767817074,39.8595859586",
    "9$116.262726482,39.6615661566",
    "4105$116.485906046,39.9315931593",
    "16$116.509398632,39.6165616562",
    "77$116.744324489,39.9135913591",
    "13$116.814802246,40.3816381638",
    "7$116.908772589,39.6885688569",
    "7$116.990996639,40.3546354635",
    "1$116.027800625,40.0486048605",
    "11$116.192248725,40.0306030603",
    "1$116.568130096,39.6255625563",
    "358$116.568130096,39.8055805581",
    "35$116.697339317,39.9945994599",
    "8$116.803055953,40.4176417642",
    "11$115.863352525,39.598559856",
    "1$116.333204239,39.5805580558",
    "1062$116.767817074,39.9405940594",
    "1$116.79130966,40.4086408641",
    "1$117.099843489,40.3186318632",
    "19$115.851606232,39.598559856",
    "1$115.922083989,39.6525652565",
    "3$116.027800625,39.9315931593",
    "2$116.168756139,40.4896489649",
    "2$116.180502432,40.2376237624",
    "5$116.286219067,40.3276327633",
    "2$116.615115267,39.796579658",
    "260$116.803055953,40.0486048605",
    "2$116.826548539,39.6705670567",
    "9$115.992561746,39.6615661566",
    "12$116.157009846,40.5166516652",
    "8065$116.415428289,40.0306030603",
    "3$116.485906046,39.6615661566",
    "151$116.591622682,39.6525652565",
    "8$117.111589782,40.3906390639",
    "1$115.72239701,39.9675967597",
    "13$116.074785796,40.2106210621",
    "26$116.110024675,40.0126012601",
    "19$116.227487603,40.2736273627",
    "98$116.274472775,39.7515751575",
    "5$116.638607853,40.2376237624",
    "13$116.650354146,39.7245724572",
    "4$116.803055953,40.2646264626",
    "18$116.850041124,39.796579658",
    "553$116.46241346,39.8145814581",
    "4$116.509398632,39.5715571557",
    "1$116.568130096,40.1926192619",
    "183$116.838294831,40.3816381638",
    "1$117.088097196,40.5256525653",
    "1$115.64017296,39.8325832583",
    "2$115.980815453,40.3816381638",
    "7$116.027800625,40.1836183618",
    "86$116.180502432,39.8865886589",
    "1$116.227487603,39.6345634563",
    "614$116.474159753,39.8235823582",
    "1$116.509398632,40.3186318632",
    "612$116.521144924,39.8325832583",
    "1$116.814802246,40.4266426643",
    "17$116.861787417,40.6066606661",
    "132$115.522710032,39.6165616562",
    "13$116.027800625,39.7875787579",
    "1895$116.321457946,40.0936093609",
    "137$116.591622682,39.9945994599",
    "4$117.182067539,40.6606660666",
    "6$115.957322868,39.6705670567",
    "3052$116.286219067,40.0936093609",
    "6486$116.333204239,40.0846084608",
    "534$116.62686156,40.3186318632",
    "12$116.861787417,39.8055805581",
    "98$116.05129321,40.0756075608",
    "9$116.086532089,39.8415841584",
    "2$116.098278382,40.2826282628",
    "111$116.309711653,39.6795679568",
    "1$116.685593024,40.8586858686",
    "6$116.756070781,39.7785778578",
    "53$117.111589782,40.1656165617",
    "40$116.027800625,39.7785778578",
    "1$116.063039503,40.0396039604",
    "316$116.121770967,39.9495949595",
    "115$116.168756139,40.5256525653",
    "176$116.333204239,39.7065706571",
    "4$116.521144924,40.3366336634",
    "186$116.579876389,40.0396039604",
    "9$116.779563367,40.399639964",
    "1$116.908772589,40.5526552655",
    "395$116.157009846,39.7335733573",
    "73$116.157009846,39.8595859586",
    "22$116.485906046,39.6795679568",
    "93$116.673846732,40.102610261",
    "18$117.358261932,40.2196219622",
    "1$115.604934082,39.6705670567",
    "309$116.063039503,39.7335733573",
    "3$116.098278382,40.0306030603",
    "16$116.13351726,40.1206120612",
    "1$116.203995017,39.598559856",
    "78$116.356696825,40.1836183618",
    "23$116.391935703,40.2286228623",
    "10$116.603368974,39.6885688569",
    "6$116.87353371,40.1386138614",
    "5$115.546202618,39.6615661566",
    "86$116.203995017,40.201620162",
    "1725$116.427174582,39.8325832583",
    "6043$116.438920874,39.8865886589",
    "127$116.474159753,39.7065706571",
    "22$116.556383803,40.3816381638",
    "186$116.697339317,39.7425742574",
    "47$116.838294831,40.3456345635",
    "8$116.932265174,40.5616561656",
    "12$115.687158132,39.598559856",
    "30$116.168756139,39.9495949595",
    "2$116.720831903,39.9945994599",
    "14$116.016054332,39.9765976598",
    "20$116.121770967,39.5715571557",
    "427$116.21574131,40.0306030603",
    "7$116.662100439,39.9945994599",
    "6$116.732578196,39.6615661566",
    "1$116.732578196,40.00360036",
    "122$116.744324489,39.8775877588",
    "4$116.861787417,39.7155715572",
    "7$116.979250346,40.1746174617",
    "1$115.898591403,40.1926192619",
    "2027$116.650354146,39.8865886589",
    "10$116.732578196,40.3276327633",
    "14$116.850041124,40.1746174617",
    "4$117.193813832,40.1206120612",
    "1$115.593187789,39.6615661566",
    "2$115.80462106,40.0216021602",
    "43$115.992561746,40.4536453645",
    "3$116.004308039,39.6795679568",
    "1086$116.192248725,39.9405940594",
    "218$116.250980189,40.0576057606",
    "1985$116.497652339,39.8685868587",
    "44$116.697339317,39.8415841584",
    "2$116.70908561,40.3906390639",
    "2$116.779563367,40.6246624662",
    "1$116.79130966,40.1386138614",
    "1$116.838294831,39.6795679568",
    "9$115.945576575,39.6435643564",
    "14$115.96906916,39.8145814581",
    "1$116.227487603,40.4716471647",
    "558$116.321457946,39.7335733573",
    "208$116.568130096,39.7425742574",
    "4$116.920518881,40.4356435644",
    "25$117.017619439,40.0576057606",
    "241$115.980815453,39.697569757",
    "2$115.980815453,40.1206120612",
    "17$116.027800625,39.8145814581",
    "190$116.180502432,39.7155715572",
    "15$116.344950532,40.1926192619",
    "132$116.391935703,40.0756075608",
    "16$116.803055953,39.7695769577",
    "1$115.910337696,40.4176417642",
    "17$116.074785796,39.9675967597",
    "2$116.967504053,40.1746174617",
    "3$117.146828661,40.5706570657",
    "4$115.851606232,40.4626462646",
    "901$116.250980189,40.1206120612",
    "6561$116.368443117,39.8775877588",
    "5$116.427174582,39.5175517552",
    "163$116.579876389,39.8595859586",
    "21$116.591622682,39.6435643564",
    "136$116.615115267,39.8775877588",
    "1$116.814802246,39.7155715572",
    "1$117.193813832,40.2286228623",
    "2$117.205560125,40.3456345635",
    "15$117.264291589,40.2826282628",
    "177$116.039546917,40.0846084608",
    "93$116.063039503,39.6435643564",
    "78$116.121770967,39.9675967597",
    "22$116.13351726,39.9765976598",
    "5$116.203995017,39.7155715572",
    "177$116.485906046,40.0486048605",
    "10$116.79130966,39.7335733573",
    "61$116.885280003,40.4716471647",
    "2$115.710650718,39.6255625563",
    "3$115.851606232,40.4086408641",
    "5$116.039546917,40.1926192619",
    "62$116.262726482,39.7785778578",
    "5474$116.368443117,39.8325832583",
    "667$116.54463751,39.8865886589",
    "1853$116.168756139,39.7245724572",
    "662$116.250980189,39.8415841584",
    "22$116.720831903,39.8775877588",
    "2$117.029365732,40.1836183618",
    "8$117.370008225,40.1746174617",
    "1$115.922083989,39.9495949595",
    "4$115.957322868,40.4716471647",
    "351$116.063039503,39.7155715572",
    "174$116.157009846,39.8865886589",
    "7314$116.415428289,40.0666066607",
    "30$116.438920874,39.5625562556",
    "6$116.697339317,40.3816381638",
    "18$116.885280003,40.399639964",
    "88$115.710650718,39.6525652565",
    "5$115.875098818,39.6795679568",
    "1$116.05129321,39.8235823582",
    "472$116.615115267,40.1206120612",
    "597$116.62686156,39.9855985599",
    "220$116.638607853,40.2106210621",
    "975$116.697339317,39.8685868587",
    "8$117.252545296,40.6426642664",
    "2$115.828113646,39.5715571557",
    "292$116.239233896,40.0306030603",
    "95$116.509398632,39.6795679568",
    "7$116.826548539,39.8415841584",
    "1$116.850041124,40.6336633663",
    "1$116.932265174,40.1926192619",
    "1$117.381754518,40.6606660666",
    "31$115.663665546,39.6615661566",
    "1$115.80462106,39.5175517552",
    "191$116.157009846,40.1296129613",
    "92$116.262726482,39.8055805581",
    "14$116.368443117,39.6705670567",
    "1895$116.38018941,40.102610261",
    "1640$116.450667167,40.0306030603",
    "1$116.62686156,40.2556255626",
    "59$116.662100439,39.9855985599",
    "105$116.744324489,39.8685868587",
    "30$116.767817074,39.8415841584",
    "30$116.098278382,39.7335733573",
    "80$116.13351726,40.1566156616",
    "183$116.227487603,39.8595859586",
    "97$116.474159753,39.6165616562",
    "425$116.203995017,39.9855985599",
    "386$116.403681996,40.1656165617",
    "1060$116.415428289,39.7875787579",
    "6762$116.415428289,39.9405940594",
    "2210$116.46241346,40.0216021602",
    "13$116.521144924,40.1836183618",
    "1$116.54463751,40.3276327633",
    "235$116.615115267,39.9585958596",
    "7$116.779563367,39.7605760576",
    "1$116.826548539,40.3186318632",
    "2$117.041112025,40.1116111611",
    "32$117.088097196,40.0846084608",
    "49$117.099843489,40.1566156616",
    "15$116.004308039,39.9405940594",
    "18$116.13351726,39.6795679568",
    "1$116.262726482,40.4266426643",
    "1097$116.333204239,39.8595859586",
    "10$116.509398632,40.1296129613",
    "7$116.62686156,39.7425742574",
    "5$116.932265174,40.0756075608",
    "2$115.710650718,39.9855985599",
    "12$116.145263553,40.5076507651",
    "65$116.391935703,40.201620162",
    "6$116.885280003,40.0756075608",
    "3$116.180502432,39.6075607561",
    "24$116.227487603,40.2826282628",
    "486$116.321457946,39.796579658",
    "115$116.391935703,40.0576057606",
    "15$116.415428289,39.6525652565",
    "123$116.615115267,40.1476147615",
    "7$116.673846732,40.3096309631",
    "2$115.898591403,39.7605760576",
    "24$116.086532089,39.8775877588",
    "30$116.086532089,40.2106210621",
    "43$116.615115267,40.1836183618",
    "2$116.673846732,40.2556255626",
    "5$116.979250346,40.2916291629",
    "4$115.957322868,39.9855985599",
    "3$115.96906916,39.8505850585",
    "1$116.180502432,40.1476147615",
    "1250$116.286219067,39.9765976598",
    "1$116.62686156,40.9486948695",
    "2$116.861787417,39.6885688569",
    "2$115.487471153,39.9495949595",
    "1$116.121770967,40.498649865",
    "631$116.203995017,39.7605760576",
    "2887$116.29796536,39.9495949595",
    "16$116.673846732,40.2646264626",
    "9$116.767817074,40.3276327633",
    "7$117.158574954,40.3816381638",
    "18$117.217306418,40.6066606661",
    "6$116.027800625,40.4266426643",
    "101$116.05129321,39.7335733573",
    "3613$116.29796536,39.9855985599",
    "7718$116.321457946,39.8775877588",
    "5761$116.403681996,39.895589559",
    "17$116.568130096,40.3186318632",
    "6$116.850041124,40.2916291629",
    "10$116.885280003,39.8325832583",
    "1852$116.180502432,39.9315931593",
    "644$116.21574131,39.7515751575",
    "6208$116.450667167,39.9495949595",
    "28$116.474159753,39.6345634563",
    "358$116.638607853,40.3096309631",
    "5$115.745889596,39.7335733573",
    "2$116.110024675,40.498649865",
    "9$116.250980189,39.6795679568",
    "1339$116.474159753,39.8505850585",
    "815$116.485906046,39.7875787579",
    "3$116.79130966,39.6255625563",
    "6$117.064604611,40.0666066607",
    "6$116.286219067,39.5535553555",
    "14$116.415428289,39.598559856",
    "8759$116.485906046,39.9135913591",
    "15$116.814802246,39.8415841584",
    "70$115.710650718,39.5715571557",
    "532$116.121770967,39.7335733573",
    "7$116.309711653,40.3636363636",
    "1968$116.368443117,40.0936093609",
    "9$116.615115267,40.201620162",
    "157$116.720831903,39.8595859586",
    "6$116.779563367,39.6885688569",
    "1$116.850041124,40.0666066607",
    "6$116.05129321,40.4716471647",
    "1$116.239233896,39.5805580558",
    "3$116.474159753,39.7605760576",
    "5$116.579876389,40.1656165617",
    "7$116.650354146,39.9765976598",
    "1$116.803055953,39.796579658",
    "9$116.121770967,39.6705670567",
    "726$116.474159753,39.8145814581",
    "163$116.568130096,40.1206120612",
    "4$117.146828661,40.6696669667",
    "19$116.110024675,39.6705670567",
    "15$116.110024675,39.7875787579",
    "6$116.239233896,40.3366336634",
    "1$116.356696825,40.4716471647",
    "2$117.064604611,40.201620162",
    "31$115.898591403,39.6165616562",
    "262$116.121770967,39.9135913591",
    "9281$116.344950532,39.9585958596",
    "1945$116.603368974,39.9315931593",
    "1$116.932265174,40.300630063",
    "15$115.992561746,40.2286228623",
    "1252$116.110024675,39.9405940594",
    "50$116.157009846,40.1746174617",
    "37$116.344950532,39.5085508551",
    "1967$116.485906046,40.00360036",
    "2$116.638607853,40.9576957696",
    "1$115.745889596,39.6525652565",
    "103$116.485906046,40.0216021602",
    "33$116.556383803,40.399639964",
    "1$117.017619439,40.2556255626",
    "765$116.192248725,39.8055805581",
    "229$116.262726482,40.2286228623",
    "8772$116.356696825,39.8865886589",
    "87$116.368443117,39.697569757",
    "27$116.46241346,39.6795679568",
    "4688$116.497652339,39.9315931593",
    "60$116.697339317,39.796579658",
    "1$116.756070781,40.8226822682",
    "53$116.779563367,39.8865886589",
    "1$117.146828661,40.0846084608",
    "74$116.368443117,40.2286228623",
    "2$116.403681996,40.2466246625",
    "2$116.438920874,40.5706570657",
    "9$116.591622682,40.201620162",
    "23$116.838294831,40.0486048605",
    "17$116.121770967,40.2196219622",
    "9$116.391935703,40.399639964",
    "1$116.438920874,39.598559856",
    "10$116.756070781,39.9495949595",
    "1$117.041112025,40.3096309631",
    "2031$116.239233896,40.2106210621",
    "1$116.250980189,40.5616561656",
    "2$116.356696825,39.5445544554",
    "14$116.438920874,39.6705670567",
    "17$116.767817074,40.4266426643",
    "485$116.850041124,40.3816381638",
    "2$116.897026296,40.1746174617",
    "5$115.922083989,40.3726372637",
    "7$116.098278382,40.3816381638",
    "182$116.121770967,40.1116111611",
    "85$116.756070781,40.102610261",
    "13$116.814802246,39.8145814581",
    "1$117.052858318,40.1296129613",
    "9$117.334769346,40.2106210621",
    "68$116.027800625,39.7695769577",
    "175$116.262726482,39.8145814581",
    "4062$116.29796536,39.8775877588",
    "1572$116.521144924,39.8865886589",
    "1$116.016054332,39.7605760576",
    "12$116.110024675,39.8415841584",
    "155$116.157009846,40.102610261",
    "165$116.309711653,39.6345634563",
    "10$116.532891217,40.3186318632",
    "762$116.556383803,40.0666066607",
    "12$115.663665546,39.6165616562",
    "1$116.250980189,40.5526552655",
    "983$116.521144924,40.0216021602",
    "75$116.54463751,40.1476147615",
    "1$116.732578196,40.3186318632",
    "1$115.675411839,39.6075607561",
    "15$115.828113646,40.0126012601",
    "5$116.814802246,39.6885688569",
    "20$116.814802246,40.5616561656",
    "14$116.098278382,39.7515751575",
    "18$116.46241346,40.201620162",
    "10$116.62686156,40.1476147615",
    "147$116.744324489,39.904590459",
    "1$117.170321246,40.4176417642",
    "10$116.203995017,39.7065706571",
    "75$116.603368974,39.8325832583",
    "96$116.756070781,39.8685868587",
    "16$117.170321246,40.4626462646",
    "59$115.945576575,40.3636363636",
    "1$116.157009846,40.300630063",
    "65$116.497652339,40.1566156616",
    "3$116.62686156,40.0126012601",
    "2$116.79130966,39.8325832583",
    "4$117.029365732,40.4626462646",
    "976$116.239233896,40.0846084608",
    "1$116.638607853,39.6345634563",
    "3$116.086532089,40.4356435644",
    "2$116.098278382,39.8505850585",
    "1$116.145263553,40.3636363636",
    "38$116.192248725,40.2196219622",
    "96$116.391935703,39.796579658",
    "3$116.415428289,40.300630063",
    "11$116.497652339,40.2196219622",
    "545$116.509398632,39.7605760576",
    "1$116.615115267,39.697569757",
    "2$116.79130966,40.4806480648",
    "3$115.593187789,39.6525652565",
    "9$115.769382182,39.6165616562",
    "1$115.80462106,40.4446444644",
    "56$116.192248725,39.7785778578",
    "64$116.333204239,40.1746174617",
    "1680$116.344950532,39.7245724572",
    "34$116.438920874,40.2106210621",
    "23$116.474159753,39.6885688569",
    "259$116.62686156,40.1206120612",
    "125$116.814802246,40.1476147615",
    "12$116.110024675,39.8235823582",
    "169$116.203995017,40.0666066607",
    "3$116.262726482,39.6795679568",
    "167$116.333204239,39.6885688569",
    "16$116.497652339,39.6345634563",
    "1$117.287784175,40.1656165617",
    "5$115.72239701,39.9405940594",
    "3$115.863352525,40.1206120612",
    "9$115.992561746,39.7425742574",
    "122$116.321457946,40.1386138614",
    "5187$116.333204239,40.0486048605",
    "7$116.509398632,39.5805580558",
    "143$116.673846732,40.3636363636",
    "14$116.79130966,39.6705670567",
    "1$117.182067539,40.6516651665",
    "2$117.205560125,40.1116111611",
    "5$115.88684511,40.0306030603",
    "23$116.027800625,40.3636363636",
    "66$116.086532089,39.6705670567",
    "1$116.121770967,40.5256525653",
    "79$116.145263553,39.7695769577",
    "23$116.556383803,40.2196219622",
    "30$116.638607853,39.7785778578",
    "7$116.697339317,40.2286228623",
    "8$116.732578196,39.7875787579",
    "23$116.87353371,39.7335733573",
    "43$116.145263553,39.7785778578",
    "2$116.262726482,39.5895589559",
    "2$116.333204239,40.4536453645",
    "1$116.54463751,40.4086408641",
    "12$116.673846732,40.0846084608",
    "10$116.732578196,40.2196219622",
    "16$117.146828661,40.5346534653",
    "6$115.980815453,40.3456345635",
    "1565$116.192248725,39.9945994599",
    "9$116.21574131,40.2826282628",
    "5$116.262726482,39.5445544554",
    "679$116.29796536,39.7785778578",
    "7444$116.333204239,40.0396039604",
    "1$116.38018941,39.5625562556",
    "494$116.521144924,40.0126012601",
    "19$116.615115267,39.7785778578",
    "47$116.756070781,39.8505850585",
    "7$116.861787417,40.0936093609",
    "5$117.076350904,40.2916291629",
    "79$115.910337696,39.6075607561",
    "95$116.13351726,39.796579658",
    "14$116.485906046,39.5715571557",
    "77$116.521144924,40.0936093609",
    "1$116.640667699,41.0495049505",
    "4$116.756070781,40.3456345635",
    "116$116.87353371,40.2376237624",
    "3$115.839859939,39.7065706571",
    "21$116.098278382,40.0486048605",
    "3$116.145263553,40.6246624662",
    "35$116.21574131,40.1476147615",
    "4076$116.38018941,39.9135913591",
    "1924$116.403681996,40.0576057606",
    "16$116.673846732,39.6435643564",
    "44$116.673846732,40.0486048605",
    "9$116.756070781,39.9945994599",
    "3$117.299530468,40.2106210621",
    "10$116.262726482,39.7335733573",
    "1$116.38018941,40.2826282628",
    "1$116.415428289,39.4815481548",
    "33$116.427174582,39.6165616562",
    "1$116.556383803,40.4356435644",
    "148$116.579876389,40.0576057606",
    "2$115.710650718,40.0306030603",
    "339$115.992561746,39.697569757",
    "83$116.180502432,39.9855985599",
    "45$116.591622682,40.2646264626",
    "49$116.638607853,40.0216021602",
    "8$116.685593024,40.0126012601",
    "3$117.135082368,40.4086408641",
    "35$116.098278382,40.1206120612",
    "6$116.333204239,40.2286228623",
    "71$116.556383803,40.4446444644",
    "24$116.814802246,40.0576057606",
    "8$116.990996639,40.1206120612",
    "3$115.898591403,39.8325832583",
    "2844$116.438920874,40.0486048605",
    "39$116.70908561,39.9405940594",
    "48$115.945576575,40.2106210621",
    "216$116.145263553,39.9405940594",
    "11$116.662100439,39.7875787579",
    "4$116.79130966,39.6525652565",
    "8$116.063039503,39.8865886589",
    "25$116.098278382,40.4446444644",
    "1374$116.239233896,39.8325832583",
    "11301$116.46241346,39.8685868587",
    "3$116.556383803,39.9855985599",
    "1$116.803055953,40.1386138614",
    "15$116.826548539,40.2556255626",
    "183$115.980815453,39.7155715572",
    "2$115.992561746,40.5526552655",
    "366$116.21574131,39.9405940594",
    "1061$116.239233896,40.0486048605",
    "3$116.403681996,40.498649865",
    "98$116.732578196,39.895589559",
    "129$115.980815453,39.9405940594",
    "17$116.110024675,39.6435643564",
    "192$116.250980189,39.8235823582",
    "203$116.321457946,39.499549955",
    "152$116.356696825,40.2196219622",
    "142$116.556383803,40.1386138614",
    "8$116.79130966,40.1476147615",
    "5$116.814802246,39.7605760576",
    "9$115.922083989,40.4266426643",
    "3$116.13351726,40.6246624662",
    "5$116.262726482,40.5526552655",
    "21$116.333204239,39.6615661566",
    "10$116.38018941,39.4635463546",
    "617$116.38018941,39.7605760576",
    "7399$116.427174582,39.9585958596",
    "2$116.46241346,39.5355535554",
    "34$116.673846732,39.8415841584",
    "1$115.593187789,39.8685868587",
    "8$115.734143303,39.5625562556",
    "28$115.745889596,39.5355535554",
    "6$115.769382182,39.895589559",
    "2$115.781128475,40.0306030603",
    "458$116.157009846,39.796579658",
    "8510$116.415428289,39.9585958596",
    "1290$116.615115267,39.9315931593",
    "3$116.70908561,39.6165616562",
    "28$116.908772589,39.8055805581",
    "33$116.908772589,40.201620162",
    "17$117.158574954,40.4176417642",
    "30$115.980815453,40.4266426643",
    "36$116.110024675,39.7695769577",
    "5$116.474159753,39.7425742574",
    "17$116.485906046,39.6255625563",
    "38$116.70908561,39.8325832583",
    "3$116.803055953,40.1566156616",
    "9$116.838294831,39.7695769577",
    "20$117.276037882,40.201620162",
    "2$115.88684511,40.4086408641",
    "555$116.098278382,39.8865886589",
    "62$116.157009846,40.0396039604",
    "29$116.157009846,40.2106210621",
    "44$116.227487603,39.7245724572",
    "43$116.344950532,40.1386138614",
    "636$116.509398632,39.8865886589",
    "1984$116.532891217,39.904590459",
    "1$116.615115267,40.3096309631",
    "2$115.992561746,40.0216021602",
    "35$116.685593024,40.3456345635",
    "1$117.111589782,40.2286228623",
    "9$115.863352525,39.6165616562",
    "63$116.391935703,40.0486048605",
    "359$116.485906046,39.7515751575",
    "23$117.170321246,40.498649865",
    "129$116.203995017,40.1116111611",
    "13$116.321457946,40.2196219622",
    "1447$116.474159753,40.0396039604",
    "448$116.556383803,39.7245724572",
    "39$116.685593024,40.1746174617",
    "17$116.826548539,40.0756075608",
    "5$116.227487603,39.6705670567",
    "31$116.262726482,39.697569757",
    "42$116.756070781,39.8415841584",
    "104$117.076350904,40.1476147615",
    "4$115.675411839,39.6165616562",
    "25$116.239233896,40.0936093609",
    "101$116.485906046,40.0756075608",
    "1053$116.54463751,39.9225922592",
    "17$116.650354146,40.6426642664",
    "8$116.767817074,40.2196219622",
    "1$117.334769346,40.1656165617",
    "1$115.734143303,39.6435643564",
    "1$116.039546917,40.3636363636",
    "4$116.074785796,40.300630063",
    "2$116.086532089,40.1836183618",
    "7$116.168756139,39.6885688569",
    "5709$116.415428289,39.8685868587",
    "2$116.438920874,40.1836183618",
    "46$116.662100439,40.1656165617",
    "1$116.732578196,40.0756075608",
    "84$116.756070781,40.1386138614",
    "2$116.016054332,39.8235823582",
    "5$116.13351726,39.6255625563",
    "69$116.203995017,39.8685868587",
    "2221$116.333204239,39.7335733573",
    "1$116.826548539,40.2466246625",
    "8$115.816367353,39.697569757",
    "1$116.086532089,40.1746174617",
    "9$116.274472775,40.3276327633",
    "7$116.46241346,40.2196219622",
    "389$116.579876389,39.8685868587",
    "44$116.638607853,40.0126012601",
    "5$116.732578196,40.0396039604",
    "13$116.744324489,39.9945994599",
    "13$116.814802246,40.1386138614",
    "2$116.814802246,40.5256525653",
    "1$116.850041124,40.0936093609",
    "369$116.227487603,40.0396039604",
    "131$116.356696825,39.697569757",
    "32$116.427174582,39.5355535554",
    "1$116.485906046,40.3546354635",
    "1738$116.509398632,39.9585958596",
    "4$116.650354146,40.8766876688",
    "13$116.70908561,39.8055805581",
    "32$116.803055953,39.8505850585",
    "1$117.146828661,40.2556255626",
    "252$116.027800625,39.895589559",
    "87$116.21574131,39.7875787579",
    "88$116.38018941,39.8235823582",
    "2$117.158574954,40.6696669667",
    "162$115.72239701,39.6345634563",
    "10$116.039546917,40.201620162",
    "25$116.438920874,39.6885688569",
    "292$116.638607853,39.6525652565",
    "63$116.70908561,39.7065706571",
    "4$116.744324489,40.3636363636",
    "9$117.029365732,40.3816381638",
    "1$117.029365732,40.5616561656",
    "13$117.135082368,40.5346534653",
    "8$117.240799003,40.3456345635",
    "5$117.346515639,40.201620162",
    "5$115.933830282,40.4086408641",
    "158$116.086532089,39.9495949595",
    "173$116.21574131,40.0576057606",
    "19$116.309711653,39.7335733573",
    "8$116.38018941,39.6525652565",
    "525$116.427174582,40.0126012601",
    "54$116.897026296,40.3816381638",
    "4$116.897026296,40.4536453645",
    "1$117.088097196,40.1836183618",
    "7$115.757635889,39.5445544554",
    "6$116.274472775,39.6255625563",
    "483$116.38018941,40.1116111611",
    "4272$116.403681996,39.9855985599",
    "1534$116.46241346,39.8505850585",
    "457$116.485906046,40.0936093609",
    "74$116.532891217,40.0666066607",
    "61$116.650354146,40.2916291629",
    "8$117.158574954,40.5706570657",
    "1$115.851606232,40.0306030603",
    "14$115.980815453,39.598559856",
    "2$116.098278382,40.4896489649",
    "26$116.21574131,39.7425742574",
    "1$116.532891217,40.3456345635",
    "2$116.779563367,39.7875787579",
    "10$116.826548539,40.3546354635",
    "1$117.229052711,40.2196219622",
    "3$116.157009846,39.9855985599",
    "1130$116.21574131,40.2196219622",
    "2608$116.286219067,39.8235823582",
    "3$116.615115267,39.6255625563",
    "1$116.744324489,40.8226822682",
    "1$116.814802246,40.0306030603",
    "4$116.838294831,39.6705670567",
    "5$116.87353371,39.697569757",
    "8$117.017619439,40.0486048605",
    "8$115.910337696,39.5715571557",
    "802$116.203995017,39.8325832583",
    "27$116.46241346,40.1386138614",
    "1$117.029365732,40.3906390639",
    "41$115.875098818,40.4896489649",
    "32$115.922083989,39.6435643564",
    "47$116.074785796,39.7335733573",
    "127$116.227487603,40.0486048605",
    "3873$116.391935703,39.9315931593",
    "4772$116.403681996,39.8685868587",
    "6$116.744324489,40.1836183618",
    "7$116.756070781,40.3636363636",
    "5$116.803055953,40.1296129613",
    "2$116.967504053,40.102610261",
    "7$116.016054332,39.5805580558",
    "32$116.098278382,39.8055805581",
    "31$116.13351726,39.7695769577",
    "158$116.157009846,39.7785778578",
    "23$116.391935703,40.2196219622",
    "1$116.450667167,40.7416741674",
    "12$116.474159753,39.6795679568",
    "2$116.568130096,40.1566156616",
    "2$116.732578196,40.0936093609",
    "9$116.744324489,40.1476147615",
    "8$116.861787417,39.796579658",
    "26$115.992561746,39.6345634563",
    "1$116.239233896,40.5796579658",
    "14$116.344950532,40.4176417642",
    "20$116.638607853,39.7065706571",
    "161$116.638607853,39.9945994599",
    "111$116.70908561,39.9495949595",
    "18$116.70908561,40.0666066607",
    "14$116.756070781,40.1296129613",
    "29$116.803055953,40.0306030603",
    "8$117.076350904,40.2736273627",
    "21$116.074785796,39.8145814581",
    "61$116.203995017,39.6165616562",
    "3934$116.262726482,39.8865886589",
    "20181$116.309711653,39.9855985599",
    "21$116.46241346,39.5535553555",
    "230$116.46241346,40.0486048605",
    "2$115.898591403,40.0306030603",
    "5$116.027800625,40.2916291629",
    "11$116.063039503,39.895589559",
    "466$116.180502432,40.0396039604",
    "28$116.203995017,40.2736273627",
    "11006$116.474159753,39.9135913591",
    "32$116.697339317,39.6345634563",
    "22$116.756070781,39.6885688569",
    "2$117.193813832,40.2106210621",
    "7$117.287784175,40.1476147615",
    "40$115.651919253,39.6615661566",
    "57$116.086532089,39.8235823582",
    "49$116.192248725,40.1206120612",
    "113$116.203995017,39.6885688569",
    "2$116.826548539,39.7335733573",
    "4$117.334769346,40.2376237624",
    "4$115.933830282,40.4446444644",
    "176$115.96906916,39.7605760576",
    "1$115.96906916,40.0936093609",
    "439$116.21574131,40.2376237624",
    "36$116.579876389,40.1476147615",
    "15$116.732578196,40.3906390639",
    "4$116.87353371,40.1476147615",
    "64$115.945576575,39.6255625563",
    "171$116.203995017,40.2196219622",
    "84$116.344950532,39.4905490549",
    "2$116.391935703,39.5715571557",
    "10$116.685593024,39.7785778578",
    "3$116.685593024,39.8325832583",
    "57$116.87353371,40.3816381638",
    "5$117.052858318,40.4896489649",
    "33$116.098278382,39.6795679568",
    "2$116.180502432,40.3186318632",
    "6318$116.286219067,39.8415841584",
    "441$116.403681996,39.796579658",
    "297$116.579876389,39.8145814581",
    "291$116.662100439,40.1746174617",
    "5$117.252545296,40.1656165617",
    "44$115.957322868,39.7155715572",
    "1272$116.192248725,39.9495949595",
    "1062$116.274472775,40.1566156616",
    "55$116.29796536,39.7065706571",
    "2$116.62686156,40.9846984698",
    "3$116.697339317,40.0486048605",
    "11$116.756070781,40.2106210621",
    "2$117.002742931,40.1836183618",
    "102$115.96906916,40.4716471647",
    "53$116.13351726,40.0576057606",
    "15$116.157009846,39.6525652565",
    "1$116.168756139,40.3366336634",
    "11$116.239233896,39.6615661566",
    "5170$116.427174582,40.0666066607",
    "42$116.521144924,40.1476147615",
    "1$116.603368974,40.7236723672",
    "33$116.650354146,40.2736273627",
    "6$116.697339317,40.3726372637",
    "11$116.767817074,40.4356435644",
    "3$116.979250346,40.102610261",
    "3$117.487471153,40.6516651665",
    "1$115.757635889,39.7605760576",
    "6$115.898591403,39.7875787579",
    "12$116.004308039,39.6255625563",
    "19$116.027800625,39.7155715572",
    "61$116.227487603,40.0936093609",
    "579$116.239233896,40.201620162",
    "283$116.615115267,40.0756075608",
    "16$116.650354146,40.0396039604",
    "39$116.732578196,40.102610261",
    "3$115.839859939,39.7695769577",
    "5$115.922083989,39.9405940594",
    "1909$116.286219067,39.895589559",
    "1$116.344950532,40.3186318632",
    "39$116.38018941,40.1386138614",
    "300$116.403681996,39.7065706571",
    "1$116.403681996,40.5616561656",
    "8$116.509398632,40.2376237624",
    "129$116.591622682,39.7425742574",
    "88$116.685593024,39.7605760576",
    "2$116.767817074,40.3726372637",
    "6$115.828113646,40.4536453645",
    "63$115.957322868,40.3636363636",
    "980$116.274472775,40.0486048605",
    "39$116.497652339,40.1836183618",
    "1352$116.615115267,40.0576057606",
    "31$116.920518881,40.0666066607",
    "2$115.745889596,39.5715571557",
    "224$116.21574131,40.201620162",
    "1165$116.29796536,40.0846084608",
    "3478$116.309711653,39.8685868587",
    "33$116.62686156,39.7065706571",
    "1$117.240799003,40.1746174617",
    "573$116.016054332,40.3546354635",
    "139$116.29796536,39.6795679568",
    "23$116.403681996,39.6255625563",
    "5734$116.403681996,39.8415841584",
    "501$116.427174582,40.1296129613",
    "34$116.450667167,40.2196219622",
    "14$116.603368974,39.7245724572",
    "24$116.673846732,40.3186318632",
    "1$117.041112025,40.300630063",
    "16$117.146828661,40.3906390639",
    "53$116.086532089,40.1116111611",
    "1436$116.250980189,40.0486048605",
    "2745$116.344950532,40.0216021602",
    "6$116.70908561,39.7425742574",
    "16$116.744324489,40.0756075608",
    "4$116.885280003,40.4806480648",
    "1$116.039546917,40.5436543654",
    "14$116.110024675,39.8325832583",
    "9$116.157009846,39.6165616562",
    "20$116.274472775,39.7425742574",
    "506$116.321457946,39.7425742574",
    "153$116.62686156,39.8595859586",
    "9$116.074785796,39.8235823582",
    "91$116.086532089,39.7065706571",
    "15$116.13351726,40.201620162",
    "25$116.180502432,39.796579658",
    "44$116.38018941,39.6705670567",
    "25$116.615115267,40.300630063",
    "18$116.885280003,40.201620162",
    "10$115.88684511,39.6165616562",
    "36$116.027800625,39.7245724572",
    "6$116.121770967,40.3546354635",
    "1$116.427174582,40.4356435644",
    "6$116.532891217,40.2736273627",
    "266$116.556383803,39.8055805581",
    "88$116.662100439,40.3186318632",
    "1$116.908772589,40.102610261",
    "63$117.052858318,40.1566156616",
    "2$115.933830282,40.5256525653",
    "12$116.004308039,39.6705670567",
    "937$116.21574131,39.9225922592",
    "206$116.250980189,40.1926192619",
    "1$116.333204239,40.3276327633",
    "234$116.356696825,39.7515751575",
    "1$116.391935703,39.5355535554",
    "10571$116.427174582,39.9855985599",
    "792$116.62686156,39.895589559",
    "136$116.662100439,39.9495949595",
    "33$116.767817074,40.0756075608",
    "11$117.182067539,40.1296129613",
    "15$115.933830282,39.5895589559",
    "211$116.556383803,39.7335733573",
    "929$116.568130096,39.8505850585",
    "1$116.814802246,39.697569757",
    "36$116.850041124,40.3366336634",
    "3$116.967504053,40.0756075608",
    "6$116.121770967,40.2646264626",
    "123$116.13351726,40.0756075608",
    "6$116.168756139,40.4716471647",
    "159$116.192248725,39.9585958596",
    "34$116.250980189,39.7695769577",
    "5$116.403681996,40.4176417642",
    "21$116.650354146,40.3906390639",
    "5$116.70908561,40.2556255626",
    "5$115.957322868,39.8145814581",
    "1$116.145263553,40.6336633663",
    "10$116.239233896,40.3546354635",
    "2$116.262726482,39.5085508551",
    "3$116.368443117,40.2826282628",
    "55$116.46241346,40.0936093609",
    "93$116.744324489,39.895589559",
    "9$115.651919253,39.9945994599",
    "4$115.863352525,39.6075607561",
    "2$115.980815453,39.6165616562",
    "3$116.086532089,40.4266426643",
    "6$116.145263553,39.598559856",
    "2199$116.145263553,39.7335733573",
    "196$116.403681996,39.7605760576",
    "1$116.62686156,40.9936993699",
    "38$116.720831903,40.2106210621",
    "1$116.803055953,40.795679568",
    "11$116.850041124,40.0576057606",
    "443$116.885280003,39.7155715572",
    "3$116.967504053,40.3276327633",
    "2$116.990996639,40.0396039604",
    "4$117.170321246,40.1926192619",
    "275$116.192248725,39.9765976598",
    "264$116.38018941,39.7425742574",
    "198$116.438920874,39.7515751575",
    "233$116.603368974,40.1296129613",
    "19$116.79130966,40.3276327633",
    "17$116.814802246,40.3546354635",
    "6$117.005873146,40.1656165617",
    "17$117.146828661,40.3636363636",
    "13$117.193813832,40.6426642664",
    "10$115.828113646,39.5625562556",
    "7$116.039546917,39.9945994599",
    "8$116.368443117,40.2556255626",
    "5$116.415428289,39.5805580558",
    "735$116.427174582,39.8145814581",
    "61$116.438920874,40.4626462646",
    "1$116.54463751,39.6075607561",
    "21$116.908772589,39.7785778578",
    "4$116.95575776,40.1386138614",
    "9$115.851606232,39.5805580558",
    "333$116.274472775,39.7875787579",
    "1$116.309711653,40.2376237624",
    "100$116.321457946,40.201620162",
    "16$116.368443117,40.3726372637",
    "111$116.662100439,40.2106210621",
    "18$116.850041124,40.3546354635",
    "7$117.323023053,40.2826282628",
    "1$115.980815453,39.9765976598",
    "2$115.980815453,40.0126012601",
    "11$116.004308039,40.5256525653",
    "141$116.415428289,39.7335733573",
    "1$116.568130096,40.2826282628",
    "673$116.62686156,39.8775877588",
    "12$116.662100439,39.7065706571",
    "16$116.79130966,40.0396039604",
    "129$116.826548539,40.3636363636",
    "3$115.910337696,40.5076507651",
    "6$115.922083989,39.9585958596",
    "7$116.004308039,40.4896489649",
    "9$116.509398632,39.7335733573",
    "40$116.579876389,40.2736273627",
    "8$116.62686156,39.9405940594",
    "8$116.885280003,39.7695769577",
    "5$116.897026296,40.0756075608",
    "16$117.135082368,40.1746174617",
    "15$117.170321246,40.4446444644",
    "1$117.240799003,40.4266426643",
    "6$115.80462106,39.598559856",
    "39$116.13351726,39.895589559",
    "6$116.157009846,40.5706570657",
    "4$116.685593024,40.2106210621",
    "4$117.005873146,40.0396039604",
    "24$115.863352525,39.796579658",
    "357$116.168756139,39.8595859586",
    "173$116.274472775,39.7605760576",
    "1$116.603368974,40.2556255626",
    "28$116.638607853,40.0756075608",
    "20$116.732578196,39.697569757",
    "1$116.814802246,40.2196219622",
    "1$116.850041124,39.8415841584",
    "18$115.992561746,39.7875787579",
    "1645$116.227487603,40.2196219622",
    "324$116.309711653,39.7785778578",
    "19$116.532891217,40.1566156616",
    "21$116.732578196,40.1116111611",
    "8$116.767817074,40.3546354635",
    "1$117.146828661,40.5886588659",
    "254$116.13351726,39.9405940594",
    "132$116.203995017,40.2376237624",
    "98$116.568130096,39.9495949595",
    "6$117.076350904,40.2826282628",
    "4$115.992561746,40.2106210621",
    "30$116.063039503,39.8775877588",
    "24$116.121770967,39.7695769577",
    "550$116.556383803,39.8505850585",
    "15$116.638607853,39.7335733573",
    "2$116.979250346,40.5706570657",
    "19$117.123336075,40.2466246625",
    "235$116.157009846,39.7695769577",
    "2313$116.438920874,40.0216021602",
    "61$116.54463751,39.8325832583",
    "184$116.591622682,39.8595859586",
    "266$116.685593024,40.1296129613",
    "61$116.685593024,40.300630063",
    "5$116.79130966,39.6795679568",
    "13$115.80462106,39.5535553555",
    "4$115.945576575,39.7425742574",
    "4$115.945576575,39.796579658",
    "100$116.063039503,39.7425742574",
    "299$116.203995017,39.8595859586",
    "3$117.229052711,40.3276327633",
    "3$116.063039503,39.5895589559",
    "620$116.157009846,39.7605760576",
    "11$116.203995017,40.2646264626",
    "5$116.356696825,39.6525652565",
    "8850$116.427174582,40.0396039604",
    "85$116.438920874,39.6165616562",
    "42$116.438920874,40.2466246625",
    "14$116.579876389,39.7785778578",
    "12$116.662100439,40.2916291629",
    "10$117.229052711,40.6156615662",
    "22$117.276037882,40.6426642664",
    "4$117.346515639,40.1656165617",
    "1$115.675411839,39.8595859586",
    "6$115.863352525,40.4536453645",
    "3$116.157009846,39.6615661566",
    "27$116.168756139,39.697569757",
    "171$116.21574131,39.8145814581",
    "5$116.403681996,39.5265526553",
    "21$116.46241346,39.6525652565",
    "91$116.485906046,40.102610261",
    "558$116.521144924,39.7875787579",
    "91$116.568130096,40.0936093609",
    "4$117.064604611,40.1116111611",
    "11$117.076350904,40.5886588659",
    "416$116.192248725,39.9855985599",
    "2$116.450667167,40.4356435644",
    "258$116.568130096,39.7695769577",
    "190$116.568130096,40.0216021602",
    "5$116.615115267,40.2646264626",
    "15$116.697339317,40.4176417642",
    "5$116.79130966,40.597659766",
    "5$116.039546917,39.6885688569",
    "426$116.110024675,39.7245724572",
    "728$116.110024675,39.9135913591",
    "16$116.274472775,39.6345634563",
    "21$116.38018941,40.1656165617",
    "107$116.532891217,40.0576057606",
    "2$116.838294831,40.4806480648",
    "7$116.897026296,39.8145814581",
    "1$115.828113646,39.6255625563",
    "326$116.086532089,39.9315931593",
    "1906$116.344950532,39.7335733573",
    "1$116.603368974,39.697569757",
    "223$116.662100439,40.0396039604",
    "63$116.662100439,40.399639964",
    "34$115.945576575,39.6075607561",
    "29$116.121770967,39.6075607561",
    "31$116.438920874,40.2286228623",
    "6$115.757635889,39.5625562556",
    "73$116.039546917,40.3366336634",
    "7$116.05129321,39.6615661566",
    "11$116.05129321,40.3366336634",
    "140$116.239233896,40.1746174617",
    "5$116.286219067,39.4905490549",
    "1458$116.344950532,39.796579658",
    "3048$116.532891217,39.9225922592",
    "4$116.532891217,40.4626462646",
    "495$116.650354146,40.1386138614",
    "24$116.744324489,40.1206120612",
    "2$117.311276761,40.2106210621",
    "1$115.828113646,39.8775877588",
    "42$116.121770967,40.0486048605",
    "524$116.21574131,40.1206120612",
    "86$116.274472775,39.7245724572",
    "14$116.638607853,39.7245724572",
    "6$116.662100439,40.2466246625",
    "5$116.744324489,40.0396039604",
    "1$116.990996639,40.3726372637",
    "7$117.158574954,40.1836183618",
    "4$115.933830282,39.6345634563",
    "3$116.063039503,40.2106210621",
    "1755$116.250980189,39.8685868587",
    "43$116.591622682,40.1476147615",
    "2$117.041112025,40.0666066607",
    "29$117.193813832,40.5886588659",
    "29$116.121770967,40.1386138614",
    "333$116.286219067,40.1926192619",
    "40$116.29796536,40.2286228623",
    "1298$116.321457946,39.6705670567",
    "472$116.497652339,39.8415841584",
    "51$116.638607853,40.0396039604",
    "29$116.685593024,39.9675967597",
    "4$116.79130966,40.2556255626",
    "11$116.885280003,39.7335733573",
    "1$115.875098818,39.6525652565",
    "37$116.180502432,39.8685868587",
    "5746$116.309711653,39.8865886589",
    "2360$116.521144924,39.9315931593",
    "1128$116.697339317,39.895589559",
    "42$117.005873146,40.1386138614",
    "1$117.017619439,40.2646264626",
    "6$116.356696825,39.6435643564",
    "284$116.427174582,40.1116111611",
    "19$116.615115267,39.7335733573",
    "6$116.673846732,39.7695769577",
    "1127$116.673846732,39.904590459",
    "4$115.745889596,39.9855985599",
    "14$115.851606232,39.697569757",
    "13$116.016054332,40.1386138614",
    "14$116.145263553,40.0936093609",
    "34$116.62686156,40.2736273627",
    "65$116.638607853,40.1476147615",
    "2$116.803055953,40.1836183618",
    "1$116.885280003,40.6606660666",
    "19$116.05129321,39.9945994599",
    "2081$116.180502432,39.9135913591",
    "4$116.227487603,40.3096309631",
    "851$116.438920874,39.8145814581",
    "4472$116.497652339,39.9585958596",
    "3009$116.521144924,39.9405940594",
    "5$116.756070781,40.2196219622",
    "1$115.675411839,39.6885688569",
    "67$116.21574131,40.0846084608",
    "13$116.262726482,40.3096309631",
    "50$116.638607853,39.8055805581",
    "16$116.697339317,39.6885688569",
    "11$116.70908561,39.7785778578",
    "19$117.041112025,40.1656165617",
    "26$117.370008225,40.1836183618",
    "1$115.898591403,40.1746174617",
    "2$115.980815453,40.102610261",
    "74$116.074785796,39.7065706571",
    "367$116.121770967,39.895589559",
    "2$116.180502432,39.598559856",
    "2870$116.203995017,39.9135913591",
    "252$116.262726482,40.2376237624",
    "9237$116.321457946,39.8865886589",
    "251$116.662100439,40.0846084608",
    "48$116.779563367,40.2286228623",
    "5$116.979250346,40.1836183618",
    "4$115.839859939,39.8145814581",
    "892$116.203995017,39.8235823582",
    "380$116.286219067,39.8055805581",
    "189$116.579876389,39.7605760576",
    "1$116.662100439,39.7335733573",
    "999$116.662100439,40.1296129613",
    "81$116.767817074,39.895589559",
    "9$116.95575776,40.0846084608",
    "1$115.863352525,40.0666066607",
    "34$115.910337696,40.2376237624",
    "26$116.098278382,40.2736273627",
    "1218$116.415428289,40.1116111611",
    "3$116.615115267,39.8145814581",
    "16$116.779563367,39.6345634563",
    "4$116.826548539,40.4176417642",
    "44$117.111589782,40.0936093609",
    "2$115.687158132,39.6165616562",
    "3$115.96906916,39.6705670567",
    "69$116.145263553,40.0846084608",
    "52$116.168756139,40.1566156616",
    "5$116.250980189,39.7245724572",
    "3$116.356696825,40.3276327633",
    "10$116.485906046,40.3456345635",
    "102$116.591622682,39.8685868587",
    "1$116.732578196,39.9765976598",
    "7$116.779563367,40.201620162",
    "4$117.182067539,40.5886588659",
    "1$116.039546917,40.2736273627",
    "2$116.110024675,40.4896489649",
    "134$116.46241346,40.1746174617",
    "103$116.521144924,40.0576057606",
    "123$116.650354146,39.8415841584",
    "32$117.135082368,40.1656165617",
    "2$115.828113646,40.4806480648",
    "277$116.46241346,40.1116111611",
    "49$116.239233896,39.7695769577",
    "850$116.427174582,39.7875787579",
    "173$116.603368974,39.9405940594",
    "1$116.744324489,40.795679568",
    "30$116.826548539,40.4806480648",
    "1$115.922083989,40.1746174617",
    "1$115.980815453,40.0576057606",
    "2$116.415428289,39.5445544554",
    "592$116.509398632,40.1656165617",
    "149$116.720831903,39.9405940594",
    "4$116.779563367,40.2196219622",
    "30$116.814802246,39.8505850585",
    "21$116.826548539,40.0486048605",
    "18$116.826548539,40.3906390639",
    "1$117.229052711,40.201620162",
    "1$117.264291589,40.1296129613",
    "9$116.145263553,40.0126012601",
    "75$116.556383803,40.1746174617",
    "11$116.685593024,39.6615661566",
    "12$115.792874768,39.6705670567",
    "4$116.086532089,40.3906390639",
    "15$116.098278382,40.0846084608",
    "34$116.13351726,40.1746174617",
    "126$116.438920874,40.1566156616",
    "7221$116.474159753,39.895589559",
    "3728$116.579876389,39.9135913591",
    "40$116.662100439,40.0756075608",
    "44$116.79130966,39.7155715572",
    "1$116.157009846,40.4716471647",
    "22$116.309711653,39.7155715572",
    "8988$116.46241346,39.9225922592",
    "23$116.532891217,39.6165616562",
    "42$116.662100439,40.1926192619",
    "8$115.922083989,40.4176417642",
    "5$116.05129321,40.5526552655",
    "109$116.685593024,39.9765976598",
    "1$116.004308039,39.796579658",
    "22$116.838294831,40.6246624662",
    "6$117.123336075,40.399639964",
    "10$117.229052711,40.6606660666",
    "1$116.039546917,40.1296129613",
    "141$116.086532089,39.9135913591",
    "360$116.110024675,39.9495949595",
    "414$116.262726482,40.2106210621",
    "8$116.333204239,40.1476147615",
    "9$116.662100439,40.6606660666",
    "5$116.744324489,40.0306030603",
    "23$116.779563367,39.9495949595",
    "1$117.111589782,40.5076507651",
    "2$116.168756139,40.1116111611",
    "4761$116.29796536,39.8685868587",
    "44$116.403681996,40.2196219622",
    "20$116.732578196,40.0306030603",
    "17$116.826548539,39.6795679568",
    "3$116.227487603,39.598559856",
    "3592$116.262726482,39.9225922592",
    "13$116.54463751,39.697569757",
    "2$116.79130966,40.4446444644",
    "6$117.146828661,40.1296129613",
    "5$115.910337696,39.8235823582",
    "41$116.063039503,40.300630063",
    "16$116.145263553,40.1656165617",
    "530$116.250980189,39.8325832583",
    "18$116.391935703,40.2466246625",
    "7088$116.485906046,39.9225922592",
    "477$116.615115267,39.9135913591",
    "127$116.13351726,39.8235823582",
    "132$116.168756139,40.2286228623",
    "2$116.286219067,39.5715571557",
    "44$116.309711653,39.7065706571",
    "4$116.403681996,39.6885688569",
    "1$116.450667167,39.5355535554",
    "369$116.521144924,39.9765976598",
    "163$116.579876389,39.7335733573",
    "145$116.826548539,40.1476147615",
    "27$115.522710032,40.0756075608",
    "11$115.792874768,39.598559856",
    "11$116.13351726,39.8415841584",
    "142$116.157009846,40.2376237624",
    "1675$116.509398632,40.0396039604",
    "32$116.603368974,40.2646264626",
    "48$116.732578196,39.7245724572",
    "1$115.651919253,39.9855985599",
    "5907$116.333204239,40.0576057606",
    "3$116.391935703,39.6255625563",
    "115$116.568130096,39.8865886589",
    "13$116.603368974,40.2466246625",
    "21$116.838294831,40.4446444644",
    "1$117.381754518,40.1836183618",
    "1$115.851606232,40.4536453645",
    "1$115.945576575,40.4896489649",
    "479$116.239233896,40.00360036",
    "7$116.262726482,39.5715571557",
    "47$116.70908561,40.1746174617",
    "28$116.87353371,39.7155715572",
    "3$117.052858318,40.0756075608",
    "85$116.145263553,39.9495949595",
    "1922$116.145263553,40.2466246625",
    "609$116.157009846,39.9225922592",
    "2079$116.391935703,40.0846084608",
    "216$116.54463751,40.00360036",
    "2$117.088097196,40.1926192619",
    "4$117.193813832,40.3906390639",
    "2$115.980815453,39.7875787579",
    "2$116.05129321,40.1656165617",
    "17$116.157009846,40.5346534653",
    "2$116.391935703,39.4545454545",
    "168$116.497652339,39.7515751575",
    "40$116.509398632,40.4626462646",
    "2$116.521144924,39.598559856",
    "126$116.579876389,39.8775877588",
    "134$116.591622682,39.9765976598",
    "189$116.70908561,39.8415841584",
    "11$116.732578196,40.1476147615",
    "1$116.826548539,40.399639964",
    "10$116.967504053,40.2916291629",
    "19$117.170321246,40.4896489649",
    "194$115.992561746,40.4626462646",
    "8$116.098278382,39.598559856",
    "101$116.38018941,40.2466246625",
    "5$117.123336075,40.2196219622",
    "2$115.933830282,40.3366336634",
    "43$116.004308039,39.7245724572",
    "1$116.203995017,40.4896489649",
    "31$116.21574131,40.1746174617",
    "2445$116.262726482,39.9315931593",
    "90$116.615115267,39.9675967597",
    "36$116.615115267,40.2736273627",
    "4$117.123336075,40.2556255626",
    "4$116.074785796,40.2646264626",
    "19$116.29796536,39.5265526553",
    "855$116.309711653,40.0126012601",
    "5421$116.46241346,39.9495949595",
    "1$116.62686156,40.9306930693",
    "14$116.638607853,39.8595859586",
    "85$116.70908561,40.3276327633",
    "40$116.920518881,40.2106210621",
    "2$117.123336075,40.201620162",
    "8$115.945576575,40.3726372637",
    "24$116.391935703,39.6705670567",
    "9$116.427174582,40.4086408641",
    "17$116.532891217,40.3096309631",
    "9$116.638607853,40.00360036",
    "12$115.734143303,39.6075607561",
    "1$116.016054332,39.6345634563",
    "1$116.016054332,39.9225922592",
    "46$116.086532089,39.796579658",
    "20$116.192248725,39.5895589559",
    "1477$116.239233896,39.8415841584",
    "144$116.450667167,39.7515751575",
    "643$116.591622682,39.9405940594",
    "56$116.603368974,40.2106210621",
    "63$116.62686156,39.9495949595",
    "8$116.967504053,40.399639964",
    "2$115.957322868,40.4086408641",
    "4$116.180502432,40.6516651665",
    "16$116.29796536,39.598559856",
    "1041$116.615115267,39.904590459",
    "83$116.885280003,40.6786678668",
    "489$117.111589782,40.1386138614",
    "1$115.80462106,39.5625562556",
    "109$116.110024675,40.0936093609",
    "1$116.13351726,40.5256525653",
    "26$116.168756139,40.5346534653",
    "129$116.344950532,39.499549955",
    "2$116.38018941,39.5715571557",
    "85$116.685593024,40.3906390639",
    "31$117.217306418,40.1476147615",
    "77$116.05129321,39.6255625563",
    "6$116.098278382,40.5526552655",
    "349$116.274472775,40.1386138614",
    "5$116.485906046,40.2556255626",
    "23$116.509398632,39.6705670567",
    "16$116.591622682,39.6705670567",
    "2$116.767817074,39.7425742574",
    "1$115.499217446,39.9225922592",
    "1$116.004308039,40.4086408641",
    "22$116.039546917,39.7155715572",
    "31$116.05129321,39.9495949595",
    "89$116.168756139,39.9675967597",
    "2253$116.344950532,40.0936093609",
    "1929$116.38018941,40.0666066607",
    "1$116.54463751,40.2736273627",
    "2$116.615115267,40.4176417642",
    "47$116.638607853,39.8505850585",
    "5$116.650354146,39.7155715572",
    "3$116.673846732,40.6066606661",
    "1$116.79130966,40.4536453645",
    "2$116.908772589,40.1386138614",
    "87$116.932265174,40.1566156616",
    "39$115.992561746,39.6885688569",
    "23$116.145263553,40.2376237624",
    "81$116.192248725,39.8145814581",
    "5912$116.29796536,39.904590459",
    "45$116.697339317,40.3276327633",
    "110$116.720831903,39.8505850585",
    "94$116.744324489,39.8595859586",
    "5$116.826548539,40.1296129613",
    "1$115.546202618,39.7785778578",
    "4$116.004308039,40.498649865",
    "10$116.086532089,39.8505850585",
    "7365$116.427174582,39.9405940594",
    "15$116.756070781,40.1476147615",
    "208$116.838294831,40.1476147615",
    "3$117.123336075,40.597659766",
    "1$115.851606232,39.6345634563",
    "6$116.004308039,39.6525652565",
    "147$116.203995017,39.6795679568",
    "4$116.286219067,39.6075607561",
    "298$116.286219067,40.0576057606",
    "192$116.532891217,39.9945994599",
    "38$116.615115267,39.9495949595",
    "131$116.732578196,39.9495949595",
    "5$116.756070781,39.796579658",
    "1$116.016054332,39.7695769577",
    "13$116.016054332,40.3096309631",
    "7$116.05129321,40.4896489649",
    "1254$116.262726482,40.1656165617",
    "3$116.603368974,39.6615661566",
    "6$116.850041124,39.7065706571",
    "9$116.861787417,40.2466246625",
    "10$117.123336075,40.1836183618",
    "186$116.004308039,40.4626462646",
    "30$116.485906046,39.7155715572",
    "136$116.556383803,40.2106210621",
    "2$116.591622682,40.3816381638",
    "8$116.662100439,39.7785778578",
    "36$116.779563367,39.7155715572",
    "2$116.039546917,39.8235823582",
    "2$116.427174582,39.4455445545",
    "46$116.485906046,40.1926192619",
    "7$116.509398632,40.2466246625",
    "1$116.79130966,40.6066606661",
    "32$116.05129321,39.6795679568",
    "7$116.21574131,39.7155715572",
    "346$116.356696825,39.8055805581",
    "3$116.474159753,39.5805580558",
    "39$116.497652339,40.1476147615",
    "14$116.767817074,40.4086408641",
    "3$115.957322868,39.7065706571",
    "769$116.168756139,40.0576057606",
    "91$116.192248725,39.7245724572",
    "2374$116.21574131,39.895589559",
    "1100$116.29796536,40.1566156616",
    "8192$116.427174582,39.895589559",
    "137$116.579876389,39.7875787579",
    "88$116.615115267,39.9855985599",
    "10$116.685593024,40.3546354635",
    "33$116.79130966,39.8145814581",
    "7$117.123336075,40.2646264626",
    "91$115.792874768,39.6795679568",
    "17$115.992561746,39.7515751575",
    "179$116.262726482,39.9675967597",
    "17$116.427174582,39.5625562556",
    "18$116.603368974,40.1656165617",
    "74$116.638607853,40.4266426643",
    "33$116.650354146,40.201620162",
    "26$117.158574954,40.3366336634",
    "18$116.121770967,40.0126012601",
    "110$116.145263553,40.0666066607",
    "192$116.438920874,40.102610261",
    "2$117.088097196,40.5886588659",
    "6$115.910337696,40.0216021602",
    "14$116.063039503,40.3096309631",
    "15$116.638607853,40.4086408641",
    "1$116.767817074,39.6435643564",
    "39$116.767817074,40.0666066607",
    "121$117.005873146,40.0666066607",
    "3$117.076350904,40.3906390639",
    "17$115.96906916,39.6075607561",
    "2$116.063039503,40.5346534653",
    "124$116.309711653,39.6615661566",
    "239$116.368443117,39.7875787579",
    "1656$116.427174582,39.8775877588",
    "6$116.615115267,39.9765976598",
    "5$116.967504053,40.1566156616",
    "19$117.146828661,40.5436543654",
    "1$115.792874768,39.7155715572",
    "100$115.992561746,39.9315931593",
    "65$116.157009846,40.0846084608",
    "2$116.192248725,39.6525652565",
    "7967$116.415428289,39.9225922592",
    "114$116.54463751,40.0756075608",
    "1$116.638607853,39.6075607561",
    "10$116.744324489,40.4356435644",
    "30$116.803055953,39.8055805581",
    "9$116.838294831,40.4086408641",
    "11$116.098278382,40.1836183618",
    "103$116.157009846,40.0936093609",
    "1$116.321457946,40.6336633663",
    "214$116.568130096,39.7785778578",
    "14$116.779563367,40.1656165617",
    "2$117.099843489,40.1926192619",
    "4$117.205560125,40.4266426643",
    "15$115.933830282,39.6795679568",
    "74$116.391935703,39.7425742574",
    "6479$116.450667167,39.895589559",
    "1$116.861787417,40.3456345635",
    "2$115.980815453,39.8595859586",
    "198$116.121770967,40.0576057606",
    "51$116.121770967,40.1206120612",
    "179$116.180502432,39.9765976598",
    "126$116.192248725,40.0576057606",
    "12$116.239233896,40.3096309631",
    "1001$116.250980189,39.9675967597",
    "1$116.333204239,40.6876687669",
    "23$116.826548539,39.8595859586",
    "1$117.346515639,40.6516651665",
    "12$115.992561746,40.4896489649",
    "381$116.203995017,40.0396039604",
    "2$116.239233896,40.6696669667",
    "4068$116.29796536,39.9945994599",
    "1619$116.309711653,40.0216021602",
    "5$116.438920874,40.2646264626",
    "2$116.474159753,40.2916291629",
    "1$115.534456325,39.7245724572",
    "76$116.098278382,39.6705670567",
    "1383$116.333204239,40.0216021602",
    "34$116.344950532,40.1296129613",
    "1$116.356696825,40.2826282628",
    "7586$116.368443117,39.8415841584",
    "13$116.38018941,39.6165616562",
    "418$116.638607853,40.1386138614",
    "6$116.838294831,39.6615661566",
    "189$115.96906916,39.7245724572",
    "14$116.027800625,40.2826282628",
    "35$116.168756139,40.1476147615",
    "2$116.344950532,40.6876687669",
    "963$116.403681996,40.1116111611",
    "27$115.910337696,39.598559856",
    "2311$116.262726482,39.8685868587",
    "13263$116.333204239,39.9945994599",
    "3265$116.333204239,40.0126012601",
    "104$116.46241346,40.1836183618",
    "8$116.509398632,40.1566156616",
    "97$116.579876389,39.6885688569",
    "34$116.697339317,39.8235823582",
    "6$116.861787417,39.7425742574",
    "5$117.041112025,40.1746174617",
    "3719$116.391935703,39.904590459",
    "305$116.556383803,39.9315931593",
    "668$116.638607853,40.1206120612",
    "97$116.779563367,39.8235823582",
    "31$116.838294831,40.4626462646",
    "4$116.885280003,39.7605760576",
    "6$115.828113646,39.5445544554",
    "23$116.110024675,40.2376237624",
    "1$116.110024675,40.5796579658",
    "48$116.485906046,40.1656165617",
    "20$116.673846732,39.7065706571",
    "9$116.720831903,39.7875787579",
    "198$116.21574131,39.8235823582",
    "2$116.497652339,40.4176417642",
    "57$116.54463751,40.2466246625",
    "76$116.662100439,40.3456345635",
    "2$116.685593024,40.6516651665",
    "4$116.756070781,40.3096309631",
    "1539$116.344950532,39.7875787579",
    "973$116.497652339,40.00360036",
    "12$116.591622682,40.3636363636",
    "1$116.697339317,40.3456345635",
    "3$117.041112025,40.1386138614",
    "11$115.816367353,40.4626462646",
    "9$116.074785796,40.4806480648",
    "770$116.227487603,39.9585958596",
    "524$116.262726482,39.9945994599",
    "142$116.321457946,39.6615661566",
    "2$116.356696825,40.696669667",
    "1$115.628426668,39.6345634563",
    "5$115.992561746,39.5895589559",
    "1$116.086532089,40.1206120612",
    "8$116.732578196,40.1926192619",
    "38$115.863352525,39.5625562556",
    "2$116.063039503,40.00360036",
    "235$116.168756139,39.9405940594",
    "2$116.427174582,39.5085508551",
    "31$116.662100439,40.1566156616",
    "1$116.885280003,40.1926192619",
    "3$116.944011467,40.1746174617",
    "9$116.967504053,40.3186318632",
    "12$117.311276761,40.1926192619",
    "20$115.957322868,40.3816381638",
    "90$116.145263553,40.1566156616",
    "718$116.438920874,40.0126012601",
    "12235$116.46241346,39.895589559",
    "6791$116.509398632,39.9135913591",
    "1$116.532891217,39.6075607561",
    "6$116.62686156,40.2106210621",
    "2$117.217306418,40.2106210621",
    "4$115.945576575,40.201620162",
    "2$116.192248725,40.3456345635",
    "411$116.356696825,39.8145814581",
    "50$116.427174582,39.7155715572",
    "26$116.591622682,39.7875787579",
    "10$116.685593024,39.7425742574",
    "5$116.756070781,40.1926192619",
    "5$116.87353371,39.7875787579",
    "4$116.990996639,40.4626462646",
    "35$116.110024675,39.8055805581",
    "1$116.168756139,39.5805580558",
    "111$116.474159753,40.1296129613",
    "7$116.521144924,40.1926192619",
    "89$116.568130096,40.4446444644",
    "6$116.650354146,40.6246624662",
    "2$116.720831903,40.7866786679",
    "26$116.732578196,39.8505850585",
    "1$117.029365732,40.0666066607",
    "1$115.898591403,40.5436543654",
    "88$116.321457946,39.4815481548",
    "1194$116.403681996,39.8235823582",
    "4$115.64017296,39.9405940594",
    "3019$116.309711653,40.0576057606",
    "8157$116.368443117,39.8685868587",
    "3$116.450667167,39.5265526553",
    "2$116.79130966,40.1566156616",
    "10$117.041112025,40.3816381638",
    "1$117.076350904,40.4176417642",
    "222$116.145263553,39.9225922592",
    "633$116.591622682,40.0396039604",
    "13$116.826548539,40.5616561656",
    "1$116.180502432,40.300630063",
    "1719$116.333204239,39.7785778578",
    "17$116.415428289,40.201620162",
    "788$116.497652339,40.0396039604",
    "302$116.556383803,39.8235823582",
    "242$116.591622682,40.0126012601",
    "37$116.779563367,39.6705670567",
    "1$115.534456325,39.7875787579",
    "158$116.180502432,40.0216021602",
    "132$116.21574131,39.8325832583",
    "50$116.21574131,40.1926192619",
    "1197$116.521144924,39.895589559",
    "48$116.744324489,40.0846084608",
    "11$116.838294831,39.7515751575",
    "8$116.944011467,40.5616561656",
    "101$116.239233896,40.1656165617",
    "5583$116.344950532,40.0576057606",
    "300$116.450667167,40.0756075608",
    "597$116.509398632,39.9675967597",
    "1$116.932265174,40.4536453645",
    "3$117.252545296,40.3096309631",
    "1$116.039546917,40.2286228623",
    "18$116.192248725,39.6705670567",
    "193$116.321457946,39.5535553555",
    "2156$116.391935703,39.8325832583",
    "7186$116.438920874,39.8685868587",
    "3$116.450667167,40.3276327633",
    "8728$116.497652339,39.9135913591",
    "7$116.662100439,40.6696669667",
    "4$116.70908561,40.2826282628",
    "9$116.720831903,39.7695769577",
    "29$116.779563367,39.9135913591",
    "18$117.146828661,40.1386138614",
    "2623$116.46241346,39.9675967597",
    "22$116.591622682,40.0216021602",
    "226$116.638607853,40.1656165617",
    "28$115.816367353,39.5535553555",
    "6$116.063039503,40.4266426643",
    "30$116.121770967,39.8325832583",
    "3$116.145263553,39.6075607561",
    "11$116.250980189,39.6705670567",
    "16$116.29796536,39.5355535554",
    "2010$116.321457946,39.8685868587",
    "12$116.427174582,39.6345634563",
    "3$116.744324489,40.3816381638",
    "15$117.041112025,40.0936093609",
    "806$116.262726482,40.1476147615",
    "12058$116.309711653,39.9675967597",
    "852$116.391935703,40.0306030603",
    "2$115.80462106,39.6165616562",
    "138$116.05129321,39.598559856",
    "48$116.098278382,39.7695769577",
    "13$116.121770967,39.7605760576",
    "504$116.286219067,40.0846084608",
    "13$116.427174582,40.3546354635",
    "235$116.521144924,40.0306030603",
    "136$116.62686156,39.8325832583",
    "26$116.803055953,39.6435643564",
    "2$116.803055953,39.8235823582",
    "322$116.227487603,40.1926192619",
    "138$116.262726482,40.1926192619",
    "97$116.38018941,39.697569757",
    "36$116.650354146,40.0486048605",
    "1046$116.685593024,39.8865886589",
    "1$116.685593024,40.7686768677",
    "129$116.732578196,39.8595859586",
    "1$115.863352525,40.3906390639",
    "2$116.086532089,40.4806480648",
    "8625$116.368443117,39.8505850585",
    "13$116.62686156,39.7245724572",
    "26$116.767817074,40.1746174617",
    "11$115.781128475,39.5625562556",
    "3$115.828113646,39.697569757",
    "21$116.227487603,40.00360036",
    "504$116.356696825,40.1206120612",
    "3$116.403681996,40.2556255626",
    "31$116.803055953,40.3636363636",
    "12$117.252545296,40.2736273627",
    "2$115.792874768,39.5355535554",
    "64$115.945576575,39.6795679568",
    "2$116.086532089,40.4086408641",
    "28$116.21574131,40.0486048605",
    "1$116.720831903,39.9855985599",
    "2$116.920518881,40.3726372637",
    "7$115.875098818,40.0396039604",
    "1$116.70908561,40.399639964",
    "8$116.79130966,40.2196219622",
    "13$116.897026296,40.399639964",
    "2$115.863352525,40.1116111611",
    "23$115.980815453,39.6525652565",
    "9$116.145263553,39.6525652565",
    "6$116.239233896,39.796579658",
    "224$116.239233896,39.9945994599",
    "3574$116.286219067,40.0126012601",
    "133$116.732578196,39.9225922592",
    "76$117.170321246,40.1116111611",
    "3$117.276037882,40.1926192619",
    "8$116.027800625,39.5805580558",
    "1$116.29796536,40.5526552655",
    "20$116.403681996,40.0936093609",
    "110$116.509398632,40.102610261",
    "1$116.744324489,40.6246624662",
    "2$116.79130966,40.2376237624",
    "24$115.839859939,39.6435643564",
    "3$115.945576575,40.4266426643",
    "86$116.098278382,40.1116111611",
    "25$116.250980189,40.2916291629",
    "2$116.38018941,39.5805580558",
    "719$116.497652339,39.9495949595",
    "535$116.532891217,39.9315931593",
    "432$116.615115267,40.0486048605",
    "2$116.826548539,39.796579658",
    "160$116.180502432,39.8145814581",
    "15$116.638607853,40.3816381638",
    "3$116.79130966,39.7605760576",
    "48$117.146828661,40.3276327633",
    "1375$116.180502432,39.9225922592",
    "623$116.274472775,40.0756075608",
    "17$116.438920874,39.697569757",
    "3$116.05129321,40.4536453645",
    "32$116.157009846,39.6705670567",
    "125$116.168756139,39.7065706571",
    "123$116.192248725,40.2466246625",
    "1696$116.509398632,39.8505850585",
    "47$116.603368974,40.300630063",
    "1115$116.685593024,39.904590459",
    "2$117.005873146,40.399639964",
    "268$117.123336075,40.1386138614",
    "1$115.922083989,39.598559856",
    "3$116.027800625,39.7425742574",
    "227$116.110024675,39.9675967597",
    "34$116.227487603,39.7425742574",
    "13$116.239233896,39.697569757",
    "425$116.591622682,40.0576057606",
    "26$115.781128475,39.5445544554",
    "12$116.168756139,40.2556255626",
    "459$116.203995017,40.00360036",
    "135$116.321457946,39.5265526553",
    "13$116.485906046,39.5805580558",
    "4121$116.497652339,39.895589559",
    "36$116.673846732,40.2826282628",
    "1$117.193813832,40.3636363636",
    "7$117.193813832,40.6876687669",
    "80$116.286219067,40.1296129613",
    "12$116.438920874,40.2196219622",
    "24$116.838294831,40.5796579658",
    "91$115.96906916,39.598559856",
    "64$115.96906916,40.3636363636",
    "46$116.157009846,39.697569757",
    "4$116.262726482,39.6165616562",
    "129$116.321457946,39.7155715572",
    "13$116.391935703,39.7695769577",
    "581$116.46241346,40.0396039604",
    "7$116.474159753,39.5895589559",
    "13$116.79130966,39.8055805581",
    "1$117.002742931,40.3636363636",
    "1$117.017619439,40.0396039604",
    "48$117.240799003,40.2646264626",
    "1264$116.262726482,39.8775877588",
    "6628$116.368443117,39.904590459",
    "1438$116.450667167,39.796579658",
    "577$116.485906046,39.8325832583",
    "451$116.497652339,40.0936093609",
    "828$116.532891217,39.895589559",
    "3$116.908772589,40.0756075608",
    "12$117.111589782,40.3186318632",
    "6$115.816367353,39.5805580558",
    "2$115.875098818,39.598559856",
    "19$115.922083989,40.1206120612",
    "1$116.086532089,40.5796579658",
    "55$116.650354146,40.1656165617",
    "14$116.897026296,40.1566156616",
    "478$116.168756139,39.8145814581",
    "191$116.168756139,39.8325832583",
    "2$116.556383803,40.5706570657",
    "9$116.673846732,40.2286228623",
    "35$117.076350904,40.1656165617",
    "16$117.170321246,40.5796579658",
    "25$116.168756139,40.1926192619",
    "738$116.274472775,40.1476147615",
    "27$116.286219067,39.6525652565",
    "3847$116.403681996,39.8865886589",
    "80$116.603368974,40.1116111611",
    "2$117.005873146,40.2556255626",
    "6$117.052858318,40.2466246625",
    "1$115.534456325,39.6075607561",
    "1$115.710650718,39.7245724572",
    "6$115.922083989,40.3546354635",
    "1$116.474159753,39.7515751575",
    "1696$116.509398632,40.00360036",
    "6$116.532891217,39.6885688569",
    "623$116.556383803,39.9675967597",
    "6$116.62686156,40.0396039604",
    "24$116.650354146,39.8055805581",
    "22$116.732578196,40.2826282628",
    "29$116.744324489,40.3366336634",
    "1$115.757635889,39.7515751575",
    "100$116.063039503,39.6615661566",
    "90$116.074785796,40.00360036",
    "7493$116.427174582,39.9675967597",
    "1970$116.485906046,39.8595859586",
    "26$116.568130096,40.2916291629",
    "11$116.967504053,40.4176417642",
    "1$115.510963739,39.7785778578",
    "2$115.863352525,39.8055805581",
    "3$116.039546917,39.8055805581",
    "17$116.110024675,39.8145814581",
    "2$116.121770967,39.6255625563",
    "8$116.13351726,40.3456345635",
    "469$116.415428289,39.8145814581",
    "296$116.521144924,40.0846084608",
    "4$116.521144924,40.2556255626",
    "84$116.615115267,40.0666066607",
    "1$115.557948911,39.895589559",
    "498$116.239233896,39.9765976598",
    "2142$116.262726482,40.0486048605",
    "65$116.286219067,40.1836183618",
    "8746$116.438920874,39.9585958596",
    "1$116.474159753,40.8226822682",
    "10$116.615115267,39.7245724572",
    "83$116.638607853,39.9675967597",
    "21$115.957322868,39.7425742574",
    "3$116.05129321,39.7515751575",
    "12$116.098278382,39.7785778578",
    "33$116.180502432,39.697569757",
    "41$116.474159753,40.1386138614",
    "36$116.603368974,39.8055805581",
    "52$116.662100439,39.6435643564",
    "74$116.79130966,39.8505850585",
    "1$117.299530468,40.2286228623",
    "1$115.863352525,39.5445544554",
    "5$116.368443117,40.1296129613",
    "1$116.415428289,40.3096309631",
    "13$116.556383803,39.6705670567",
    "46$116.685593024,40.3276327633",
    "6$116.779563367,40.0486048605",
    "4$115.687158132,39.6075607561",
    "10$115.945576575,39.8235823582",
    "3$115.980815453,40.0396039604",
    "781$116.556383803,40.102610261",
    "1436$116.673846732,39.8775877588",
    "4$116.756070781,40.4086408641",
    "2$117.029365732,40.2466246625",
    "1$116.615115267,39.6795679568",
    "2$116.063039503,39.8325832583",
    "16583$116.344950532,39.9945994599",
    "2852$116.368443117,40.0396039604",
    "101$116.579876389,39.7515751575",
    "39$116.650354146,39.8505850585",
    "95$116.79130966,39.7785778578",
    "1$116.897026296,40.4266426643"
];
export default Data;


// WEBPACK FOOTER //
// ./src/components/mapBar/data.js